import { Component, OnInit, OnDestroy, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { WebServiceService } from '../../shared/services/web-service.service';
import { ToasterService } from 'angular2-toaster';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { EesDesService } from '../../shared/services/ees-des.service';
import { DataService } from '../../shared/services/data-sharing/data.service';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';

Chart.plugins.register(pluginDataLabels as any);

type AmcMgmtChartKind = 'overdue' | 'status';
type AmcMgmtScope = 'my' | 'all';

interface AmcMgmtCardFilterState {
  lobId: string;
  lobLabel: string;
  locId: string;
  locLabel: string;
  departmentId: string;
  departmentLabel: string;
  employeeId: string;
  employeeName: string;
  lobSearchTerm: string;
  departmentSearchTerm: string;
  locSearchTerm: string;
  employeeSearchTerm: string;
  filteredLobList: Array<{ id: any; label: string }>;
  filteredDepartmentList: Array<{ id: any; label: string }>;
  filteredLocList: Array<{ id: any; label: string }>;
  isLobDropdownOpen: boolean;
  isLocDropdownOpen: boolean;
  isDepartmentDropdownOpen: boolean;
  isEmployeeDropdownOpen: boolean;
  locSearchDebounceRef: any;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private dashboardDestroyed: boolean = false;
  topProduct: any = {data:[],lineChartColors:[],labels:[]}
  filteredRankingData: any = [];

  public barChartType: any = 'bar';
  public pieeChartType: any = 'pie';

  public stackbarChartType: any = 'bar';
  public stackChartType: any = 'bar';
  public stackbarlineChartType: any = 'bar';
  public vertical_title: any;
  public stackbarupdownChartType: any = 'bar';
  public barArrowChartType: any = 'bar';
  public linebarChartType: any = 'bar';
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  showTyaSuiteLogo: boolean = false;
  isRunning: boolean = false;
  isRun: boolean = false;
  isDataVisible: boolean = false;
  vendorranking: any;
  topProducts: any;
  tallyIntegrationData: any;
  failedIntegrationData: any;
  constructor(public webService: WebServiceService,
    private toasterService: ToasterService,
    private router: Router,public eesdesService:EesDesService,
    public _localStorageService: LocalStorageService, private titleService: Title, private popupService: DataService,
    private elRef: ElementRef) {
    this.amcMgmtInitCardFilters();
  }
    @Output()
    makeVisibility = new EventEmitter()
    breadCrumb: string[] = [];
  dashboardData: any = [];
  dashboardLoader: boolean = false;
  /** True while Wave-1 (first-paint cards) APIs are in flight. Soft banner only — content stays visible. */
  initialDashboardLoading: boolean = true;
  /** True while Wave-2 (AMC / vendor / heavy charts) APIs continue after first paint. */
  dashboardSecondaryLoading: boolean = false;
  clientList: any = [];
  isClient: boolean = false;
  whenNeeded:boolean = false;
  barChartLegend: boolean = true;
  pieChartLegend: boolean = true;
  pieeChartLegend: boolean = true;
  stackbarChartLegend: boolean = true;
  stackbarlineChartLegend: boolean = true;
  stackbarupdownChartLegend: boolean = true;
  stackChartLegend: boolean = true;
  linebarChartLegend: boolean = true;
  barlineChartLegend: boolean = true;
  demoBarChartList:any=[];
  lineChartList:any=[];
  linebarChartList:any=[];
  pieChartList:any=[];
  pieeChartList:any=[];
  stackbarChartList:any=[];
  stackChartList:any=[];
  stackbarlineChartList:any=[];
  barArrowChartList:any=[];
  stackbarupdownChartList:any=[];
  company_setup: any = {};
  pieChartColors:any=[];
  showPendingInvoicesPopup: boolean = false;
  inventory_title:any='Amount Rupees';
  fast_moving_title:any='Amount In Rupees/(Percentage)';
  Slow_moving_title:any='Amount In Rupees/(Percentage)';
  bank_balance_title:any='Total Amount Rs 1,77,368/-';
  loan_balance_title:any='Total Amount Rs 2,12,150/-';
  upcoming_title:any='Amount in Rupees';
  receivables_title:any='Amount in Rupees';
  net_cash_flow_title:any='Amount in Rupees';
  Customer_ageing_title:any='Amount in Rupees/(percentage';
  business_performance_title:any='Amount in Rupees/(percentage';
  po_statics_title:any='PO Statics';
  pendingPOTitle:any='Pending PO For Last Days'
  pendingPOChartType:any='bar';
  pendingPOChartLabels:any=[];
  pendingPOChartRecord:any=[];
  pendingPOChartColors:any=[];
  pendingTaskList: any = [{
    id: 0,
    text: "My PR For Approval",
    count: 15,
    color: "#4cb2c4"
  }, {
    id: 1,
    text: "Po For Approval",
    count: 30,
    color: "#4caf62"
  }, {
    id: 2,
    text: "Invoice For Approval",
    count: 10,
    color: "#f1894f"
  }, {
    id: 3,
    text: "Master For My Approval",
    count: 5,
    color: "#4eb1c2"
  }, {
    id: 4,
    text: "Payments For My Approval",
    count: 25,
    color: "#ec343c"
  }, {
    id: 5,
    text: "Payments For My Approval",
    count: 15,
    color: "#4caf62"
  },]
  pieChartType: any = 'pie';
  // pieeChartType: any = 'pie';
  chartList: any = [];
  // company_setup:any = {};
  today:Date= new Date()
  curHr:any= this.today.getHours()
  message:any='';
  userCode: any = "";
  userName: string = '';
  employeeUserRoleId:any = localStorage.getItem('emp_role') ? localStorage.getItem('emp_role') : ''
  // complianceCardList:any=[
  //   {'client_name':'abc',"label":['Pending','Upcoming','Over-Due','Completed'],"data":[10,20,0,90],"pieChartType":'pie',"lineChartLegend":true}
  // ];
  isMultiple:boolean=false;
  showSupportPopupFlag = false;
  defaultSupportPopupMessage: string = 'Important Support Update\n\nDear User,\n\nTo provide you with better and faster support, all service requests, issue reports, and queries will now be handled exclusively through our official support email.\n\n📧 Support Email: care@tyasuite.com\n\nKindly use this email for all future communications. This will help us track your requests efficiently and ensure timely resolution.\n\nThank you for choosing TYASuite!';
  supportPopupMessage: string = '';
  supportPopupAcknowledging: boolean = false;

  ngOnInit() {
    window.sessionStorage.clear()
    this.isMultiple = this.eesdesService.get('isMultiple',localStorage.getItem('isMultiple')) == '1' ? true : false;
   this.employeeUserRoleId = localStorage.getItem('emp_role') ? localStorage.getItem('emp_role') : ''
this.getMenuList();
    this.checkAuth();
    this.makeChartList();
    this.barchartDemo();
    this.titleService.setTitle("Dashboard");
    document.getElementById("base-div").style.paddingTop = "65px";
    document.getElementById("base-div").style.marginLeft = "60px";
    document.getElementById("mySidenav").style.width = "60px";
    document.getElementById("header").style.display = "block";
    localStorage.removeItem('pm_dashboard_action');
    localStorage.removeItem('master_dashboard_action');
    localStorage.removeItem('report_dashboard_action');
    this.clearAmcDashboardNavigationStorage();
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
   this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
   this.popupService.popupState$.pipe(takeUntil(this.destroy$)).subscribe(show => {
    this.showSupportPopupFlag = show;
    if (show) {
      this.supportPopupMessage = this.popupService.getSupportPopupMessage() || this.defaultSupportPopupMessage;
    }
  });
   this.popupService.supportPopupMessage$.pipe(takeUntil(this.destroy$)).subscribe(message => {
    if (message) {
      this.supportPopupMessage = message;
    }
  });
  console.log('build test')

  }

  private isDashboardActive(): boolean {
    return !this.dashboardDestroyed;
  }

  private clearAmcDashboardNavigationStorage() {
    [
      'dashboard_card_type',
      'scope',
      'task_priority',
      'status_bucket',
      'ageing_bucket',
      'task_status',
      'employee_id',
      'lob',
      'lob_location',
      'department',
      'task_id',
      'amc_management_dashboard_filter',
      'amc_management_dashboard_all_filter',
      'amc_critical_pending_my_filter',
      'amc_critical_pending_all_filter',
      'amc_compliance_pending_my_filter',
      'amc_compliance_pending_all_filter',
      'amc_overdue_ageing_filter',
      'amc_overdue_ageing_all_filter',
      'dashboard_navigation_source',
      'dashboard_navigation_bucket',
    ].forEach((key) => localStorage.removeItem(key));
  }

  private dashboardApi(url: string, data: any) {
    return this.webService.commonPostMethod(url, data).pipe(takeUntil(this.destroy$));
  }

  private dashboardCounterLoadStarted = false;
  private dashboardCounterHttpBusy = false;
  private dashboardCounterHttpQueue: Array<() => void> = [];

  private beginDashboardCounterLoad() {
    this.initialDashboardLoading = true;
    this.dashboardSecondaryLoading = false;
    this.dashboardCounterLoadStarted = true;
    this.dashboardCounterHttpBusy = false;
    this.dashboardCounterHttpQueue = [];
  }

  private resetDashboardCounterLoad() {
    this.dashboardCounterLoadStarted = false;
    this.dashboardCounterHttpBusy = false;
    this.dashboardCounterHttpQueue = [];
    this.dashboardSecondaryLoading = false;
  }

  /** Clears Wave-1 soft banner so first cards can show while Wave-2 continues. */
  private completeInitialDashboardLoad() {
    this.initialDashboardLoading = false;
  }

  private completeSecondaryDashboardLoad() {
    this.dashboardSecondaryLoading = false;
    this.resetDashboardCounterLoad();
  }

  /** Fail-safe: stop all progressive loaders (menu/setup errors, destroy). */
  private failDashboardCounterLoad() {
    this.initialDashboardLoading = false;
    this.dashboardSecondaryLoading = false;
    this.resetDashboardCounterLoad();
  }

  private enqueueDashboardCounterHttp(execute: () => void) {
    this.dashboardCounterHttpQueue.push(execute);
    this.pumpDashboardCounterHttpQueue();
  }

  private pumpDashboardCounterHttpQueue() {
    if (this.dashboardCounterHttpBusy || this.dashboardCounterHttpQueue.length === 0 || !this.isDashboardActive()) {
      return;
    }
    const execute = this.dashboardCounterHttpQueue.shift();
    if (!execute) {
      return;
    }
    this.dashboardCounterHttpBusy = true;
    execute();
  }

  private releaseDashboardCounterHttpSlot() {
    this.dashboardCounterHttpBusy = false;
    this.pumpDashboardCounterHttpQueue();
  }

  /** One counter HTTP at a time when afterComplete is provided (dashboard initial load chain). */
  private runDashboardCounterHttp(
    url: string,
    data: any,
    afterComplete: (() => void) | undefined,
    next: (data: any) => void,
    error?: () => void
  ) {
    const executeRequest = () => {
      this.dashboardApi(url, data).pipe(
        finalize(() => {
          if (afterComplete !== undefined) {
            this.releaseDashboardCounterHttpSlot();
            if (this.isDashboardActive()) {
              afterComplete();
            }
          }
        })
      ).subscribe(
        next,
        () => {
          if (error) {
            error();
          }
        }
      );
    };

    if (afterComplete !== undefined) {
      this.enqueueDashboardCounterHttp(executeRequest);
    } else {
      executeRequest();
    }
  }

  private continueDashboardCounterChain(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (onComplete) {
      onComplete();
    }
  }

  private proceedDashboardCounterNext(onComplete: (() => void) | undefined, legacyNext: () => void) {
    if (onComplete) {
      this.continueDashboardCounterChain(onComplete);
    } else {
      legacyNext();
    }
  }

  /**
   * Progressive dashboard load:
   * Wave 1 (first paint) — pending approval + main cards/graphs users see first.
   * Wave 2 (background) — vendor / AMC / heavy widgets; may take 30–50s.
   * Content is never hidden behind a full-page wait; cards paint as each API returns.
   */
  private loadDashboardCounterApisSequentially() {
    if (!this.isDashboardActive()) {
      return;
    }
    this.beginDashboardCounterLoad();
    const startPendingChain = () => {
      this.getPendingPMTask(() => {
        this.getAgreementDashboardCards(() => {
          this.loadDashboardMainCounterChainSequentially(() => {
            this.completeInitialDashboardLoad();
            this.dashboardSecondaryLoading = true;
            this.loadDashboardSecondaryCounterChainSequentially();
          });
        });
      });
    };
    // FY filter ON: load years first so defaults are in counter payloads.
    // FY filter OFF: skip FY API and run dashboard as before.
    if (this.company_setup.enable_financial_year_filter_in_landing_dashboard == '1') {
      this.getFinancialYears(() => startPendingChain());
    } else {
      this.selectedFinancialYears = [];
      startPendingChain();
    }
  }

  /** Wave 1: main dashboard cards/charts — first visible content. */
  private loadDashboardMainCounterChainSequentially(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this.company_setup.hide_dashboard_counter == '1') {
      if (onComplete) {
        onComplete();
      } else {
        this.completeInitialDashboardLoad();
      }
      return;
    }
    this.getClientList(() => {
      this.getDynamicData(() => {
        this.getModuleWiseCompanyAnalytics(() => {
          this.getDynamicProjectData(() => {
            this.getPendingTaskForRaiser(() => {
              this.getPendingPMTaskForRaiser(() => {
                this.getPendingTask(() => {
                  this.getCardData(() => {
                    this.getInvoiceAgeingData(() => {
                      this.getSalesStatisticsData(() => {
                        this.getOpenArAgeingData(() => {
                          this.getArOutstandingAgeingData(() => {
                            this.getTopCustomersData(() => {
                              this.getTotalRevenueData(() => {
                                this.getNewCustomersData(() => {
                                  this.getMissedCustomersData(() => {
                                    this.getUpcomingRenewalsData(() => {
                                      this.getExpiredAgreementsData(() => {
                                        if (onComplete) {
                                          onComplete();
                                        } else {
                                          this.completeInitialDashboardLoad();
                                        }
                                      });
                                    });
                                  });
                                });
                              });
                            });
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  /** Wave 2: vendor / AMC / integration widgets — continues after first paint. */
  private loadDashboardSecondaryCounterChainSequentially() {
    if (!this.isDashboardActive()) {
      return;
    }
    this.getPendingTaskForVendor(() => {
      this.getVendorPOStatics(() => {
        this.getVendorInvoiceStatics(() => {
          this.getVendorPOBarStatics(() => {
            this.getTallyIntegrationData(() => {
              this.getMyAmcTaskCards(() => {
                this.getAllAmcTaskCards(() => {
                  this.getAmcManagementDashboard('my', () => {
                    this.getAmcManagementDashboard('my', () => {
                      this.getAmcManagementDashboard('all', () => {
                        this.getAmcManagementDashboard('all', () => {
                          this.getAmcCriticalPending('my', () => {
                            this.getAmcCriticalPending('all', () => {
                              this.getAmcCompliancePending('my', () => {
                                this.getAmcCompliancePending('all', () => {
                                  if (this.company_setup.hide_dashboard_counter == '0') {
                                    this.getAmcOverdueAgeingChart('my', () => {
                                      this.getAmcOverdueAgeingChart('all', () => {
                                        this.getFailedIntegrationData(() => {
                                          this.completeSecondaryDashboardLoad();
                                        });
                                      });
                                    });
                                  } else {
                                    this.getFailedIntegrationData(() => {
                                      this.completeSecondaryDashboardLoad();
                                    });
                                  }
                                });
                              });
                            });
                          });
                        }, 'status');
                      }, 'overdue');
                    }, 'status');
                  }, 'overdue');
                });
              });
            });
          });
        });
      });
    });
  }
  barChartLabelsList:any=[];
  ChartLabelsList:any=[];
  ChartbarlineLabelsList:any=[];
  pieChartLabelsList:any=[];
  pieeChartLabelsList:any=[];
  ChartLegend:any=[];
  stackbarChartLabelsList:any=[];
  stackChartLabelsList:any=[];
  stackbarlineChartLabelsList:any=[];
  stackbarupdownChartLabelsList:any=[];
  barArrowLabelsList:any=[];
  barchartDemo()
  {

    //Inventory Details

    this.demoBarChartList=[];
    this.lineChartList=[];
    this.linebarChartList=[];
    this.barChartLabelsList=["Item 1","Item 2",'Item 3','Item 4','Item 5','Other Item']
    this.demoBarChartList=[
    {
      data: [15,30, 40, 50, 60,80],
       label: 'Slow Moving',
      },

  ]

//Fast Moving Items

  this.ChartLabelsList=["Item 1","Item 2",'Item 3','Item 4','Item 5','Other Item']
    this.lineChartList=[
       {
        type: 'line',
      label: "Gross Margin",
      data: [20, 50, 45, 70, 45, 50],
      fill: false,
      borderColor: 'orange',
      pointStyle: 'spline',
      pointBorderWidth: 3
    },
    {
      label: "High value",
      data: [80, 60, 50, 40, 30, 15,],
      backgroundColor: ['#FF0000','#00FA9A','#FF0000','#00FA9A','#FF0000','#00FA9A',]

      },

  ]

  //Slow Moving Items

  this.ChartbarlineLabelsList=["Item 1","Item 2",'Item 3','Item 4','Item 5','Other Item']
    this.linebarChartList=[
 {
        type: 'line',
      label: "My Second dataset",
      data: [30, 40, 70, 60, 65, 40],
      fill: false,
      borderColor: 'red',
      pointStyle: 'spline',
      pointBorderWidth: 3,
      display: true,
    },
    {
      label: "high vallue",
      data: [80,70, 60, 50, 40, 30, 20, 15],
      backgroundColor: ['	#0000cc','#33cc33','#0000cc','#33cc33','#0000cc','#33cc33',]

      },

  ]

  //Bank Balance
  this.pieChartLabelsList = ['HDFC Bank', 'Katak Bank', 'Axis Bank', 'SBI Bank', 'ICIC Bank','Other Banks'];
    this.pieChartList=[
    {
      title:"abcd",
        type: 'pie',
      // data:  [12, 10, 15, 10, 40, 13],
      data:  [10, 10, 12, 15, 40, 13],
      backgroundColor: ['#FF0000','#FF8C00','#00FA9A','	#32CD32','#FF0000','#0000CD','#FFFF00',]

    }
  ]
  this.pieeChartLabelsList = ['HDFC Bank', 'Katak Bank', 'Axis Bank', 'SBI Bank', 'ICIC Bank','Other Banks','date=maturity/Renewal Date'];
  // this.ChartLegend ={
  //   visible:true,
  //   posit

  // }
    this.pieeChartList=[
    {
      title:"abcd",
        type: 'pie',
      // data:  [12, 10, 15, 10, 40, 13],
      data:  [25, 10, 10, 5, 30, 20],
      backgroundColor: ['#ff0000','#40ff00','	#00ffbf','#ff9900','#FFFF00','#000080',, ]

    },

      // {"label":'HDFC Bank',"data":[25],text:'25%'},

  ]

  //Upcoming Payables
  this.stackbarChartLabelsList =['Next Week', '2nd Week', '3rd week', '4th week', '5th Week','later'];
  this.stackbarChartList=[
    { data: [45, 18, 32, 60, 5,10], label: 'opex', stack: 'a',
   },
    { data: [10, 17, 32, 25, 20, 40], label: 'capex', stack: 'a',
    backgroundColor: ['#32CD32','#32CD32','#32CD32','#32CD32','#32CD32','#32CD32']

  }
  ]
  //
  this.stackChartLabelsList =['Next Week', '2nd Week', '3rd week', '4th week', '5th Week','later'];
  this.stackChartList=[
    { data: [60, 20, 15, 50, 60,20], label: 'Other Customers', stack: 'a',
   },
    { data: [15, 35, 15, 20, 20, 20], label: 'Top 10 Customer By Revenue', stack: 'a',
    backgroundColor: ['#32CD32','#32CD32','#32CD32','#32CD32','#32CD32','#32CD32']

  }
  ]
  //Customer Ageing
  this.stackbarlineChartLabelsList =['Current', '1-15 Days', '16-30 Days', '31-60 Days', '61-90 Days','More than 90 Days'];
  this.stackbarlineChartList=[
    {
      type: 'line',
    label: "Percentage Of Total Receivable",
    data: [50, 60, 30, 50, 40, 70],
    fill: false,
    borderColor: 'blue',
    pointStyle: 'spline',
    pointBorderWidth: 3,
    display: true,
  },

    { data: [35, 30, 15, 15, 30,50], label: 'Others', stack: 'a',
    backgroundColor: ['#FFA500','#FFA500','#FFA500','#FFA500','#FFA500','#FFA500']
   },
    { data: [15, 30, 15, 35, 10, 20], label: 'Top 10 Customer By Revenue', stack: 'a',
    backgroundColor: ['#32CD32','#32CD32','#32CD32','#32CD32','#32CD32','#32CD32'] }
  ]

  //Upcoming Net Cash Flow
  this.stackbarupdownChartLabelsList =['Over Due', 'Next Week', '2nd Week', '3rd Week', '4th Week','5th Week','Later'];
  this.stackbarupdownChartList=[

    { data: [-20, -10, 50, 30, 100,90, -90]},

  ]


  this.barArrowLabelsList=["Jan","Feb",'Mar','Apr','May','Jun']
    this.barArrowChartList=[

      {
        type: 'line',
      label: "Net Profit Percentage",
      data: [26,49,70, 50,55, 68],
      fill: false,
      borderColor: '#00cc00',
      pointStyle: 'spline',
      pointBorderWidth: 3,
      display: true,
    },
    {
      label: "Revenue",
      data: [68,35,39, 75, 45, 50],
      backgroundColor: ['	red','red','red','red','red','red',]

      },
    {
      label: "Expense",
      data: [40,55,40, 38,65,40],
      backgroundColor: ['	#0000cc','#0000cc','#0000cc','#0000cc','#0000cc','#0000cc',]

      },
    {
      label: "Net Profit",
      data: [20,15,26,30,38,20,],
       backgroundColor: ['	#77b300','#77b300','#77b300','#77b300','#77b300','#77b300',]

      },

  ]

  }
  getGreeting()
  {
    this.userName = this._localStorageService.getUserName()
    this.userCode = "(" + this.eesdesService.get('employee_code',localStorage.getItem('employee_code')) + ")";

    if (this.company_setup.is_welcome_message_visible=='1') {

     let temp:any=[];
     temp= this.company_setup.welcome_item_columnList.options.filter((v)=>{return v.time_value>this.curHr})
    //  console.log(temp)
    //  console.log(this.curHr)

     if(temp.length>0)
      {
        // console.log(temp[0])

        this.message=temp[0].message_value+" " +this.userName;
      }
    }
  }
  isPendingCardVisible(id)
  {
    return this.company_setup.email_dashboard_notification.some((v)=>{return v.id==id && v.is_visible_on_dashboard && v.is_visible_on_dashboard_by_url})
  }
  isPendingCardVisibleForPM(id)
  {
    return this.company_setup.project_management_dashboard_notification.some((v)=>{return v.id==id && v.is_visible_on_dashboard && v.is_visible_on_dashboard_by_url})
    // return true;
  }

  isPendingCardVisibleForRaiser(id)
  {
    // Only for SRN: backend sends id with "raise_" prefix (raise_pending_srn)
    // but this function strips "raise_" from keys. So handle SRN without disturbing other ids.
    if (id == 'raise_pending_srn') {
      return this.company_setup.email_dashboard_notification.some((v)=>{
        return v.id == 'raise_pending_srn' && v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url
      })
    }
    if(id!=''&&id!=undefined)
    {
      if(id!='pending_raised_stock')
      {

      id=id.replace("raise_", "")
      }
      else
      {
        id="pending_stock_issue"
      }
    }
    // console.log("id",id)
    // console.log("this.company_setup.email_dashboard_notification",this.company_setup.email_dashboard_notification)
    const raiserMatch = (v) => v.id == id && v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url;
    if (id === 'mailed_invoice' || id === 'failed_mailed_invoice' || id ==='my_assigned_invoices') {
      const em = this.company_setup.email_dashboard_notification || [];
      const zt = this.company_setup.zero_touch_dashboard_notifications || [];
      return em.some(raiserMatch) || zt.some(raiserMatch);
    }
    return this.company_setup.email_dashboard_notification.some(raiserMatch)
  }
  shouldShowRfqPendingForPoTitle() {
    const rfqPendingForPo = (this.company_setup.email_dashboard_notification)
    .find((v) => v.id === 'rfq_pending_for_po');
    if (!rfqPendingForPo) {
      return false;
    }
    return rfqPendingForPo.is_visible_on_dashboard === true;
  }
  isPendingPMCardVisibleForRaiser(id)
  {
    if(id!=''&&id!=undefined)
    {
      id=id.replace("raise_", "")
    }
    const pmMatch = (v) => v.id == id && v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url;
    if (id === 'mailed_invoice' || id === 'failed_mailed_invoice' || id === 'my_assigned_invoices') {
      const pm = this.company_setup.project_management_dashboard_notification || [];
      const zt = this.company_setup.zero_touch_dashboard_notifications || [];
      return pm.some(pmMatch) || zt.some(pmMatch);
    }
    return this.company_setup.project_management_dashboard_notification.some(pmMatch)
  }
  GetCompanySetUpData() {
    if (!this.isDashboardActive()) {
      return;
    }
    let req = {
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      variable_list:['is_my_pending_task_visible_in_dashboard','welcome_item_columnList',
      'email_dashboard_notification','project_management_dashboard_notification',
      'vendor_dashboard_notification',
      'dashboard_cards_according_to_user_role_pm','is_vendor_po_statistics_visible',
      'is_vendor_invoice_statistics_visible','is_vendor_po_till_date_visible','landing_url',
      'is_vendor_po_not_dis_till_date_visible',"is_update_action_mand_for_incom_ven_profile","MINUTES_UNITL_AUTO_LOGOUT",'how_many_days_pending_in_dashboard','currency_icon',"hide_tyasuite_logo_in_landing_dashboard", "hide_dashboard_counter" ,"view_more_button", "enable_strict_auto_logout_policy", "enable_invoice_ageing_card_with_daywise_counts", "zero_touch_dashboard_notifications", "sap_b1_api_enable", "enable_sap_integration", "enable_all_company_data_approval", "enable_financial_year_filter_in_landing_dashboard", "is_risky_vendors_visible_in_dashboard"],
      component:this.constructor.name?this.constructor.name:'',

    }
    this.company_setup={}
    this.company_setup.email_dashboard_notification=[];
    this.company_setup.vendor_dashboard_notification=[];
    this.company_setup.zero_touch_dashboard_notifications=[];

    this.company_setup.project_management_dashboard_notification=[];
    this.dashboardApi("Update_company_meta/ajax_getall_bycompany_limited_as_requested", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup={}
          this.company_setup=data.response ? data.response : {}
          this.company_setup.currency_icon=this.company_setup.currency_icon?this.company_setup.currency_icon:'INR'
          this.company_setup.how_many_days_pending_in_dashboard=parseInt(this.company_setup.how_many_days_pending_in_dashboard?this.company_setup.how_many_days_pending_in_dashboard:0)

          this.pendingPOTitle="Pending Data For Last "+this.company_setup.how_many_days_pending_in_dashboard+" Days";
          this.company_setup.is_my_pending_task_visible_in_dashboard = this.company_setup.is_my_pending_task_visible_in_dashboard ? this.company_setup.is_my_pending_task_visible_in_dashboard : '0';
          this.company_setup.view_more_button = this.company_setup.view_more_button ? this.company_setup.view_more_button : '0';

          this.company_setup.welcome_item_columnList=this.company_setup.welcome_item_columnList?this.company_setup.welcome_item_columnList:{"options":[]};
          this.company_setup.email_dashboard_notification=this.company_setup.email_dashboard_notification?this.company_setup.email_dashboard_notification:[];
          this.company_setup.landing_url=this.company_setup.landing_url?this.company_setup.landing_url:'1';
          this.company_setup.hide_tyasuite_logo_in_landing_dashboard=this.company_setup.hide_tyasuite_logo_in_landing_dashboard?this.company_setup.hide_tyasuite_logo_in_landing_dashboard:'0';
          if(this.company_setup.hide_tyasuite_logo_in_landing_dashboard == '1'){
            this.showTyaSuiteLogo = false;
          }else{
            this.showTyaSuiteLogo = true;
          }
       

          if(this.company_setup.email_dashboard_notification)
          {
            for(let i of this.company_setup.email_dashboard_notification)
            {
              i.id=(i.id!='' && i.id!=undefined && i.id!=null)?(i.id.trim()):i.id
              i.raise_page_url=this.getPageUrl(i,'RAISE')
              const isMailedInvoiceCard = i.id === 'mailed_invoice' || i.id === 'failed_mailed_invoice' || i.id === 'my_assigned_invoices';
              const isVendorAgreementCard = i.id === 'vendor_agreement_expiring_60' || i.id === 'expired_vendor_agreement'
                || i.id === 'customer_agreement_expiring_60' || i.id === 'expired_customer_agreement';
              const raiserToggleOn = i.is_visible_on_raiser_dashboard === true || i.is_visible_on_raiser_dashboard === 1 || i.is_visible_on_raiser_dashboard === '1';
              if (isMailedInvoiceCard) {
                i.is_visible_on_raiser_dashboard_by_url = raiserToggleOn;
                i.is_visible_on_raiser_dashboard = raiserToggleOn;
              } else {
                i.is_visible_on_raiser_dashboard_by_url=i.is_visible_on_raiser_dashboard&&this.IS_VAILID_URL(i.raise_page_url);
                i.is_visible_on_raiser_dashboard=i.is_visible_on_raiser_dashboard_by_url
              }
              i.approve_page_url=this.getPageUrl(i,'APPROVE')
              if (isVendorAgreementCard) {
                // Company setup toggle controls visibility (page lives in master)
                const approveToggleOn = i.is_visible_on_dashboard === true || i.is_visible_on_dashboard === 1 || i.is_visible_on_dashboard === '1';
                i.is_visible_on_dashboard_by_url = approveToggleOn;
              } else {
                i.is_visible_on_dashboard_by_url=i.is_visible_on_dashboard&&this.IS_VAILID_URL(i.approve_page_url);
              }

            }
          }
          this.company_setup.zero_touch_dashboard_notifications=this.company_setup.zero_touch_dashboard_notifications?this.company_setup.zero_touch_dashboard_notifications:[];
          if(this.company_setup.zero_touch_dashboard_notifications)
          {
            for(let i of this.company_setup.zero_touch_dashboard_notifications)
            {
              i.id=(i.id!='' && i.id!=undefined && i.id!=null)?(String(i.id).trim()):i.id
              i.raise_page_url=this.getPageUrl(i,'RAISE')
              const isMailedInvoiceCard = i.id === 'mailed_invoice' || i.id === 'failed_mailed_invoice' || i.id === 'my_assigned_invoices';
              const raiserToggleOn = i.is_visible_on_raiser_dashboard === true || i.is_visible_on_raiser_dashboard === 1 || i.is_visible_on_raiser_dashboard === '1';
              if (isMailedInvoiceCard) {
                i.is_visible_on_raiser_dashboard_by_url = raiserToggleOn;
                i.is_visible_on_raiser_dashboard = raiserToggleOn;
              } else {
                i.is_visible_on_raiser_dashboard_by_url=i.is_visible_on_raiser_dashboard&&this.IS_VAILID_URL(i.raise_page_url);
                i.is_visible_on_raiser_dashboard=i.is_visible_on_raiser_dashboard_by_url
              }
              i.approve_page_url=this.getPageUrl(i,'APPROVE')
              i.is_visible_on_dashboard_by_url=i.is_visible_on_dashboard&&this.IS_VAILID_URL(i.approve_page_url);
            }
          }
          // console.log(this.company_setup.email_dashboard_notification);

          if(this.company_setup.email_dashboard_notification.some((v)=>{return v.id=='recurring_invoice'}))
          {
            let d=this.company_setup.email_dashboard_notification.filter((v)=>{return v.id=='recurring_invoice'})[0]
         // this.company_setup.project_management_dashboard_notification.push(d)
          }
          if(this.company_setup.project_management_dashboard_notification)
          {
            for(let i of this.company_setup.project_management_dashboard_notification)
            {
              i.raise_page_url=this.getPMPageUrl(i,'RAISE')
              i.is_visible_on_raiser_dashboard_by_url=i.is_visible_on_raiser_dashboard&&this.IS_VAILID_URL(i.raise_page_url);
              i.is_visible_on_raiser_dashboard=i.is_visible_on_raiser_dashboard_by_url
              i.approve_page_url=this.getPMPageUrl(i,'APPROVE')
              i.is_visible_on_dashboard_by_url=i.is_visible_on_dashboard&&this.IS_VAILID_URL(i.approve_page_url);

            }
          }
          // console.log(this.company_setup.project_management_dashboard_notification);

          this.company_setup.vendor_dashboard_notification=this.company_setup.vendor_dashboard_notification?this.company_setup.vendor_dashboard_notification:[];

          this.company_setup.project_management_dashboard_notification=this.company_setup.project_management_dashboard_notification?this.company_setup.project_management_dashboard_notification:[];
          this.company_setup.is_welcome_message_visible='0'
          this.company_setup.is_my_pending_task_visible_in_dashboard= this.company_setup.email_dashboard_notification.some((v)=>{return v.is_visible_on_dashboard && v.is_visible_on_dashboard_by_url})?'1':'0'

          this.company_setup.is_my_pending_task_visible_in_dashboard_for_vendor= this.company_setup.vendor_dashboard_notification.some((v)=>{return v.is_visible_on_vendor_dashboard})?'1':'0'


          this.company_setup.is_my_pending_task_visible_in_dashboard_for_raiser= (this.company_setup.email_dashboard_notification.some((v)=>{return v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url}) || this.company_setup.zero_touch_dashboard_notifications.some((v)=>{return v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url}))?'1':'0'
          this.company_setup.is_my_pending_project_managementTask_visible_in_dashboard_for_raiser= this.company_setup.project_management_dashboard_notification.some((v)=>{return v.is_visible_on_raiser_dashboard && v.is_visible_on_raiser_dashboard_by_url})?'1':'0'
          this.company_setup.is_my_pending_project_managementTask_visible_in_dashboard= this.company_setup.project_management_dashboard_notification.some((v)=>{return v.is_visible_on_dashboard && v.is_visible_on_dashboard_by_url})?'1':'0'
          this.company_setup.dashboard_cards_according_to_user_role_pm= this.company_setup.dashboard_cards_according_to_user_role_pm ? this.company_setup.dashboard_cards_according_to_user_role_pm : []
if (this.company_setup.welcome_item_columnList.options.length>0) {
  this.company_setup.is_welcome_message_visible=this.company_setup.welcome_item_columnList.options.some((v)=>{return v.visible_value})?'1':'0';

}
          if(req.company_id=='0'||req.company_id==''||req.company_id==undefined)
          {
            this.company_setup.is_welcome_message_visible = this.company_setup.is_welcome_message_visible ? this.company_setup.is_welcome_message_visible : '1';
          }
          if(this.company_setup.is_welcome_message_visible=='1')
          {
            this.getGreeting();
          }

          this.company_setup.is_vendor_po_not_dis_till_date_visible = this.company_setup.is_vendor_po_not_dis_till_date_visible ? this.company_setup.is_vendor_po_not_dis_till_date_visible : '1';
          this.company_setup.is_vendor_po_till_date_visible = this.company_setup.is_vendor_po_till_date_visible ? this.company_setup.is_vendor_po_till_date_visible : '1';
          this.company_setup.is_vendor_invoice_statistics_visible = this.company_setup.is_vendor_invoice_statistics_visible ? this.company_setup.is_vendor_invoice_statistics_visible : '1';
          this.company_setup.is_vendor_po_statistics_visible = this.company_setup.is_vendor_po_statistics_visible ? this.company_setup.is_vendor_po_statistics_visible : '1';
          this.company_setup.is_risky_vendors_visible_in_dashboard = this.company_setup.is_risky_vendors_visible_in_dashboard ? this.company_setup.is_risky_vendors_visible_in_dashboard : '0';
          this.company_setup.hide_dashboard_counter = this.company_setup.hide_dashboard_counter ? this.company_setup.hide_dashboard_counter : '0';
          // this.company_setup.hide_dashboard_counter = "1";
          this.company_setup.MINUTES_UNITL_AUTO_LOGOUT = this.company_setup.MINUTES_UNITL_AUTO_LOGOUT ? this.company_setup.MINUTES_UNITL_AUTO_LOGOUT : 10;
          localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',this.company_setup.MINUTES_UNITL_AUTO_LOGOUT);
          this.company_setup.enable_strict_auto_logout_policy = this.company_setup.enable_strict_auto_logout_policy ? this.company_setup.enable_strict_auto_logout_policy : '0';
          localStorage.setItem('enable_strict_auto_logout_policy',this.company_setup.enable_strict_auto_logout_policy);
          this.company_setup.enable_invoice_ageing_card_with_daywise_counts = this.company_setup.enable_invoice_ageing_card_with_daywise_counts ? this.company_setup.enable_invoice_ageing_card_with_daywise_counts : '0';
          this.company_setup.enable_financial_year_filter_in_landing_dashboard = this.company_setup.enable_financial_year_filter_in_landing_dashboard ? this.company_setup.enable_financial_year_filter_in_landing_dashboard : '0';
          this.company_setup.sap_b1_api_enable = this.company_setup.sap_b1_api_enable ? this.company_setup.sap_b1_api_enable : '0';
          this.company_setup.enable_sap_integration = this.company_setup.enable_sap_integration ? this.company_setup.enable_sap_integration : '0';
          this.company_setup.enable_all_company_data_approval = this.company_setup.enable_all_company_data_approval ? this.company_setup.enable_all_company_data_approval : '0';
          this.filteredRankingData=[]
    this.topProduct.data=[]
          this.renderBreadcrum();

        }
        else {
          this.toasterService.pop('error', "Error", data.message);
          this.renderBreadcrum();
        }


      }, error => {
        this.renderBreadcrum();
        this.toasterService.pop("error", "Error", "Something Went Wrong");
      }
    )
  }
  makeChartList() {
    this.chartList = [];
    this.chartList = [
      { 'id': 'line', 'name': 'Line Chart' },
      { 'id': 'pie', 'name': 'Pie Chart' },
      { 'id': 'bar', 'name': 'Bar Chart' },
      { 'id': 'doughnut', 'name': 'Doughnut Chart' },
      { 'id': 'radar', 'name': 'Radar Chart' },
      { 'id': 'polarArea', 'name': 'Polar Area Chart' },
      { 'id': 'bubble', 'name': 'Bubble Chart' },
      { 'id': 'scatter', 'name': 'Scatter Chart' }];
  }
  urlList: any = [];
  checkAuth() {
    let page_url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    let data: any = {};
    data = this.eesdesService.get('menus',localStorage.getItem('menus'))
      ? this.eesdesService.get('menus',localStorage.getItem('menus'))
      : {};

    this.urlList = data ? data : [];
    if (
      this._localStorageService.getUserId() == undefined ||
      this._localStorageService.getUserId() == null
    ) {
      this.toasterService.pop(
        'info',
        'Info',
        'You are not able access this page! Login First'
      );
      window.localStorage.clear();
      this.router.navigateByUrl('/login');


      return false;
    }
    if (
      this._localStorageService.getEmpCompanyId() == 0 ||
      this._localStorageService.getEmpCompanyId() == null ||
      this._localStorageService.getEmpCompanyId() == undefined
    ) {
    } else {
      const currenturl = page_url ? page_url : '';
      let count = 0;
      if (this.urlList.length > 0) {
        for (const i of this.urlList) {
          if (i.submenu != undefined) {
            for (const j of i.submenu) {
              if (j.aurl == currenturl) {
                count++;
              }
            }
          }
        }
        if (count <= 0) {
          // this.toasterService.pop(
          //   'info',
          //   'Info',
          //   'you are not able access this page'
          // );
          if (currenturl !== '/dashboard') {
            this.router.navigateByUrl('/dashboard');
            return false;
          }
        }
      }
    }

    return true;
  }

  renderBreadcrum() {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this.dashboardCounterLoadStarted) {
      return;
    }
    this.breadCrumb = ["Home", "Dashboard",];
    // if(this.company_setup.hide_dashboard_counter!='1') {
    //   this.getDynamicData();
    //   this.getDynamicProjectData();
    //   this.getPendingTaskForRaiser();
    //   this.getPendingPMTaskForRaiser();
    //   this.getPendingTask();
    //   this.getCardData()
    // }
    
    this.loadDashboardCounterApisSequentially();
    this.getPendingPMTask();

    // this.getClientList();

    // vendor login
    // if (this._localStorageService.getUserRole() == "vendor") {
    this.getPendingTaskForVendor();
    this.getVendorPOStatics();
    this.getVendorInvoiceStatics();
    this.getVendorPOBarStatics();
    // }

    // Tally Integration cards (permission guard inside getTallyIntegrationData)
    this.getTallyIntegrationData();
    this.getMyAmcTaskCards();
    this.getAllAmcTaskCards();
    this.getVendorDetailsCard();
    if (this.company_setup.hide_dashboard_counter == '0') {
      this.getAmcOverdueAgeingChart('my');
      this.getAmcOverdueAgeingChart('all');
    }
    this.getFailedIntegrationData();

    this.loadDashboardCounterApisSequentially();
  }
  getClientList(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    const proceedAfterClientList = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getDynamicData());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };
    let obj = {
      "userid": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : "0",
    }

     if (this._localStorageService.getUserRole() != "vendor" && this.IS_VAILID_URL('/client-master')) {

    this.runDashboardCounterHttp(
      "Clientmaster/ajax_get_assigned_clients",
      obj,
      () => proceedAfterClientList(),
      (data) => {
          if (data.status) {
            this.clientList = data.response.filter((v)=>{return v.status!=='0'});
            if (this.clientList) {

              for (let i of this.clientList) {
                this.isClient = true;
                i.count = 0;
                i.count = i.compliance_count?i.compliance_count:0;
              }
            }
            else {
              this.isClient = false;
            }
            this.clientList.sort((a, b) => parseInt(b.count) - parseInt(a.count));
          }
        },
        () => {
        }
      );
     }
     else{
      proceedAfterClientList();
     }
  }
  setClient(id, name, type, count, tl, tm,data) {
    if(data.status=='0')
    {
      this.toasterService.pop('info','Info','Client Is Deleted');
      return false;
    }
    let user_type: any = "";
    if (tl) {
      user_type = "TL";
    }
    if (tm) {
      user_type = "TM";
    }
    if (count >= 0) {
      localStorage.setItem("client_id", id);
      localStorage.setItem("client_name", name);
      localStorage.setItem("client_type", type);
      localStorage.setItem("user_type", user_type);
      window.location.href=window.location.origin+'/compliance/#/client-assigned-compliances';
      // this.webService.redirectURL('/client-assigned-compliances')
    }
    else {
      localStorage.setItem("client_id", "");
      localStorage.setItem("client_name", "");
      localStorage.setItem("client_type", "");
      localStorage.setItem("user_type", "");
      this.toasterService.pop("info", "Info", "Total Compliances For ( " + name.toUpperCase() + " ) is = " + count);
      return;
    }
  }
  responseData: any = [];
  filteredData: any = [];
  filteredviewData: any = [];
  filteredModuleWiseData: any = [];
  salesStatisticsCharts: any = [];
  openArAgeingChart: any = null;
  arOutstandingAgeingChart: any = null;
  topCustomersData: any = null;
  topCustomersMoreLoading: boolean = false;
  totalRevenueChart: any = null;
  newCustomersData: any = null;
  missedCustomersData: any = null;
  upcomingRenewalsData: any = null;
  expiredAgreementsData: any = null;

  getModuleWiseCompanyAnalytics(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }

    const obj = {
      user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      company_id: this._localStorageService.getEmpCompanyId(),
      is_remove_keys: "0",
      keys_list: [],
      is_vendor: "0",
      financial_years: this.selectedFinancialYears,
    };

    this.runDashboardCounterHttp(
      "/dashboard_company_cards/ajax_dashboard_cards_sorted_by_company",
      obj,
      onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
      (data) => {
        if (data && data.status) {
          this.filteredModuleWiseData = this.filterchartData(data.response);
        }
      }
    );
  }

  getDynamicData(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
      if (this._localStorageService.getUserRole() == "vendor") {
       this.continueDashboardCounterChain(onComplete);
       return;
     }
    this.dashboardLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
      "financial_years": this.selectedFinancialYears,
    }

    const proceedAfterDynamicData = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getDynamicProjectData());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };

    this.runDashboardCounterHttp(
      "/User_Roles/ajax_dashboard_cards_sorted",
      obj,
      onComplete ? () => proceedAfterDynamicData() : undefined,
      (data) => {
          if (data.status) {
            this.responseData = data.response
            this.dashboardData = data.response;
            this.filteredData = this.filterchartData(data.response);
            // localStorage.setItem('filteredData',JSON.stringify(this.filteredData));
            // console.log(this.filteredData);
            if (this.dashboardData) {
              for (let i of this.dashboardData) {
                if (i.items) {
                  for (let j of i.items) {
                    j.icon = this.getKeyImage(j.key);
                  }
                }
              }
              this.dashboardLoader = false;
            }
          }
          this.dashboardLoader = false;
        },
        () => {
          this.dashboardLoader = false;

        }
      );
  }


  getViewData() {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() == "vendor") {
     return;
   }
  this.dashboardLoader = true
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  }
  this.isviewCompanyCardVisible =true;


  this.dashboardApi("/User_Roles/dashboardCardsCountersBasedOnCcAccess", obj).

    subscribe(
      data => {
        if (data.status) {
          this.responseData = data.response
          this.dashboardData = data.response;
          this.filteredviewData = this.filterchartViewData(data.response);
          // localStorage.setItem('filteredData',JSON.stringify(this.filteredData));
          // console.log(this.filteredData);
          if (this.dashboardData) {
            for (let i of this.dashboardData) {
              if (i.items) {
                for (let j of i.items) {
                  j.icon = this.getKeyImage(j.key);
                }
              }
            }
            this.dashboardLoader = false;
          }
        }
        this.dashboardLoader = false;
      },
      error => {
        this.dashboardLoader = false;

      }
    );
}
filterchartViewData(data: any) {
  let list: any = [];
  for (let x of data) {
    let temp = { title: "", label: [], data: [], total: 0 };
    temp.title = x.title;
    temp.total = 0;
    for (let y of x.items) {
      temp.total = temp.total + parseFloat(y.count);
      if (parseFloat(y.count) > 0) {
        temp.label.push(y.title + " (" + y.full_title + ")");
      }
      else {
        temp.label.push(y.title);

      }
      temp.data.push(y.count);
    }
    temp.total = this.webService.convertNaN(temp.total) ? this.webService.convertNaN(temp.total) : '0';

    list.push(temp);
  }
  return list;
}

  filterchartData(data: any) {
    let list: any = [];
    for (let x of data) {
      let temp = { title: "", label: [], data: [], total: 0 };
      temp.title = x.title;
      temp.total = 0;
      for (let y of x.items) {
        temp.total = temp.total + parseFloat(y.count);
        if (parseFloat(y.count) > 0) {
          temp.label.push(y.title + " (" + y.count + ")");
        }
        else {
          temp.label.push(y.title);

        }
        temp.data.push(y.count);
      }
      temp.total = this.webService.convertNaN(temp.total) ? this.webService.convertNaN(temp.total) : '0';

      list.push(temp);
    }
    return list;
  }

  getKeyImage(key) {
    let image = "";
    switch (key) {
      case "raised_pr":
        image = "Damaged@2x.png";
        break;
      case "pending_pr":
        image = "Pending@2x.png";
        break;
        case "recurring_invoice":
        image = "Pending@2x.png";
        break;

      case "rejected_pr":
        image = "Rejected@2x.png";
        break;
      case "approved_pr":
        image = "Approved@2x.png";
        break;
      case "raised_po":
        image = "Damaged@2x.png";
        break;
      case "pending_po":
        image = "Pending@2x.png";
        break;
      case "approved_po":
        image = "Approved@2x.png";
        break;
      case "rejected_po":
        image = "Rejected@2x.png";
        break;
      case "received_items":
        image = "Received@2x.png";
        break;
      case "total_items":
        image = "Damaged@2x.png";
        break;
      case "accepted_items":
        image = "Received@2x.png";
        break;
      case "rejected_items":
        image = "Rejected@2x.png";
        break;
      case "damaged_items":
        image = "Damaged@2x.png";
        break;
      case "all_invoice":
        image = "Damaged@2x.png";
        break;
      case "pending_iv":
        image = "Pending@2x.png";
        break;
      case "approved_iv":
        image = "Approved@2x.png";
        break;
      case "rejected_iv":
        image = "Rejected@2x.png";
        break;
      case "all_invoice_payment":
        image = "Damaged@2x.png";
        break;
      case "pending_ip":
        image = "Pending@2x.png";
        break;
      case "approved_ip":
        image = "Approved@2x.png";
        break;
      case "rejected_ip":
        image = "Rejected@2x.png";
        break;
      default:
        image = "#";
    }
    return image;
  }
  navigateUrl(key, module, count, title) {
    if (count <= 0) {
      this.toasterService.pop("info", "Info", title + " = " + count);
      return false;
    }
    let url = "";
    let dashboardAction = ""
    switch (key) {
      case "raised_pr":
        url = "my-purchases-pr";
        dashboardAction = ""
        break;

      case "pending_pr1":
        url = "my-purchases-pr";
        dashboardAction = "pending_pr"
        break;
        case "recurring_invoice":
          url = "auto-generated-inv";
          dashboardAction = "pending_recurring_invoice"
          break;
      case "rejected_pr":
        url = "my-purchases-pr";
        dashboardAction = "rejected_pr"
        break;
      case "approved_pr":
        url = "my-purchases-pr";
        dashboardAction = "approved_pr"
        break;
      case "raised_po":
        url = "my-orders";
        dashboardAction = ""
        break;
      case "pending_po":
        url = "my-orders";
        dashboardAction = "pending_po"
        break;
      case "approved_po":
        url = "my-orders";
        dashboardAction = "approved_po"
        break;
      case "rejected_po":
        url = "my-orders";
        dashboardAction = "rejected_po"
        break;
      case "received_items":
        url = "#";
        dashboardAction = "received_items"
        break;
      case "total_items":
        url = "#";
        dashboardAction = ""
        break;
      case "accepted_items":
        url = "#";
        dashboardAction = "accepted_items"
        break;
      case "rejected_items":
        url = "#";
        dashboardAction = "rejected_items"
        break;
      case "damaged_items":
        url = "#";
        dashboardAction = "damaged_items"
        break;
      case "damaged_items":
        url = "#";
        dashboardAction = "damaged_items"
        break;
      case "all_invoice":
        url = "invoice-report";
        dashboardAction = ""
        break;
      case "pending_iv":
        url = "invoice-report";
        dashboardAction = "pending_iv"
        break;
      case "approved_iv":
        url = "invoice-report";
        dashboardAction = "approved_iv"
        break;
      case "rejected_iv":
        url = "invoice-report";
        dashboardAction = "rejected_iv"
        break;
      case "all_invoice_payment":
        url = "my-invoices";
        dashboardAction = ""
        break;
      case "pending_ip":
        url = "my-invoices";
        dashboardAction = "pending_ip"
        break;
      case "approved_ip":
        url = "my-invoices";
        dashboardAction = "approved_ip"
        break;
      case "rejected_ip":
        url = "my-invoices";
        dashboardAction = "rejected_ip"
        break;
      default:
        url = "#";
    }
    localStorage.setItem("dashboardAction", this.webService.set(dashboardAction,'dashboardAction'));
    this.webService.redirectURL(url)

  }
  getkeyName(id,name)
  {
    let t:any='';
    t=Object.keys(id);


    if(t==name)
    {
      return true;
    }
    return false;
  }
  responseProjectData: any = [];
  filteredProjectData: any = [];
  dashboardProjectLoader: boolean = false;
  invoiceAgeingData: any = null;
  invoiceAgeingLoader: boolean = false;
  getDynamicProjectData(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
      if (this._localStorageService.getUserRole() == "vendor") {
       this.continueDashboardCounterChain(onComplete);
       return;
     }
     if(!this.IS_VAILID_URL('/my-project-master')&&!this.IS_VAILID_URL('/project-master')&&!this.IS_VAILID_URL('/project-master-approval'))
    {
      if(this.company_setup.hide_dashboard_counter!='1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getPendingTaskForRaiser());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
      return;
    }

    this.dashboardProjectLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
    }

    const proceedAfterProjectData = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getPendingTaskForRaiser());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };

    this.runDashboardCounterHttp(
      "project/Project_master/get_all_projects_for_chart",
      obj,
      onComplete ? () => proceedAfterProjectData() : undefined,
      (data) => {
          if (data.status) {
            this.responseProjectData = data.response?data.response:[]

            if(!Array.isArray(this.responseProjectData))
            {
              return;
            }

            this.filteredProjectData = this.filterchartProjectData(this.responseProjectData);
            if (data.response) {
              for (let i of data.response) {
                if (i.items) {
                  for (let j of i.items) {
                    j.icon = this.getKeyImage(j.key);
                  }
                }
              }
              this.dashboardProjectLoader = false;
            }

          }
          this.dashboardProjectLoader = false;
        },
        () => {
          this.dashboardProjectLoader = false;

        }
      );

  }
  getInvoiceAgeingData(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.invoiceAgeingLoader = true;
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
    }
    this.runDashboardCounterHttp(
      "ocr/Api/invoiceAgeingCounters",
      obj,
      onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
      (data) => {
          this.invoiceAgeingLoader = false;
          if (data.status && data.data && data.data.ageing_buckets) {
            this.invoiceAgeingData = this.formatInvoiceAgeingData(data.data);
          }
        },
        () => {
          this.invoiceAgeingLoader = false;
        }
      );
  }

  formatInvoiceAgeingData(data: any) {
    let totalCount = data.summary ? data.summary.total_count : 0;
    const ageingBucketColors: { [bucketName: string]: string } = {
      '0 Day': '#59A14F',
      '1 Day': '#4E79A7',
      '2 Days': '#F28E2B',
      '3 Days': '#E15759',
      '4 Days': '#76B7B2',
      '5 Days': '#EDC949',
      '6 Days': '#AF7AA1',
      '7 Days': '#9C755F',
      '7-15 Days': '#FF7C43',
      'More than 15 Days': '#A05195',
      '15+': '#A05195'
    };
    const defaultAgeingColor = '#4E79A7';
    let temp = {
      title: "Unprocessed Invoice Ageing (" + totalCount + ")",
      label: [],
      data: [],
      colors: [],
      total: totalCount,
      pieChartType: 'pie',
      lineChartLegend: true,
      key: 'invoice_ageing',
      items: []
    };
    if (data.ageing_buckets && Array.isArray(data.ageing_buckets)) {
      for (let bucket of data.ageing_buckets) {
        let count = bucket.count || 0;
        if (count > 0) {
          let labelText = bucket.bucket + " (" + count + ")";
          temp.label.push(labelText);
          temp.data.push(count);
          temp.colors.push(ageingBucketColors[bucket.bucket] || defaultAgeingColor);
          temp.items.push({
            bucket: bucket.bucket,
            count: count,
            value: bucket.value,
            from_date: bucket.from_date,
            to_date: bucket.to_date,
            days_range: bucket.days_range,
            label: labelText
          });
        }
      }
    }
    temp.total = this.webService.convertNaN(temp.total) ? this.webService.convertNaN(temp.total) : '0';
    return temp;
  }

  filterchartProjectData(data: any) {
    let list: any = [];
    for (let x of data) {
      let temp = { title: "", label: [], data: [], total: 0, pieChartType: 'pie', lineChartLegend: true , key:x.key};
      temp.title = x.title;
      temp.pieChartType = temp.pieChartType ? temp.pieChartType : 'pie';
      temp.total = 0;
      for (let y of x.items) {
        temp.total = temp.total + parseFloat(y.count);
        if (parseFloat(y.count) > 0) {
          temp.label.push(y.title + " (" + y.count + ")");
        }
        else {
          //temp.label.push(y.title);
          temp.label.push(y.title + " (0)");

        }
        temp.data.push(y.count);
      }
      temp.total = this.webService.convertNaN(temp.total) ? this.webService.convertNaN(temp.total) : '0';

      list.push(temp);
    }
    return list;
  }
  getData(d)
  {

  }
  pendingTaskTitle:any='';
  pendingTaskCount:any = 0;
  getPendingTask(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }

    if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.pendingTaskCount = "";
    let localCount:any = 0;
    this.pendingTaskList=[];
// if(this.company_setup.email_dashboard_notification.every((v)=>{return !v.is_visible_on_dashboard}))
// {
//   return;
// }
    this.dashboardProjectLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
      "financial_years": this.selectedFinancialYears,
    }

    const proceedAfterPendingTask = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getCardData());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };

    this.runDashboardCounterHttp(
      "User_Roles/ajax_dashboard_pending_cards_sorted",
      obj,
      onComplete ? () => proceedAfterPendingTask() : undefined,
      (data) => {
          // console.log(data)
          if (data.status) {
            this.pendingTaskList=data.response.items?data.response.items:[];
            this.pendingTaskTitle=data.response.title?data.response.title:'';
            if(this.pendingTaskList){
              for(let totalCount of this.pendingTaskList) {
                totalCount.count = this.webService.convertNaN(totalCount.count) ? this.webService.convertNaN(totalCount.count) : 0;
                if( totalCount.count !=""){
                  if(this.isPendingCardVisible(totalCount.key)){
                    localCount += parseFloat(totalCount.count);
                  }
                }
              }
            }
            this.pendingTaskCount = localCount ? localCount : 0;
           }
           this.dashboardProjectLoader=false;
        },
        () => {
          this.dashboardProjectLoader=false;
        }
      );
  }
  pendingTaskTitleForRaiser:any='';
  pendingTaskListForRaiser:any=[];
  pendingTaskCountForRaiser:any=0;
  getPendingTaskForRaiser(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }

     if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.pendingTaskListForRaiser=[];

//     if(this.company_setup.email_dashboard_notification.every((v)=>{return !v.is_visible_on_raiser_dashboard}))
// {
//   return;
// }
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
      "financial_years": this.selectedFinancialYears,
    }
    let localCount:any = 0;
    // if(1==1) {
    //   return false;
    // }
    this.dashboardProjectLoader = true

    const proceedAfterPendingTaskForRaiser = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getPendingPMTaskForRaiser());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };

    this.runDashboardCounterHttp(
      "User_Roles/ajax_dashboard_pending_cards_sorted_for_raiser",
      obj,
      onComplete ? () => proceedAfterPendingTaskForRaiser() : undefined,
      (data) => {
          if (data.status) {
            this.pendingTaskListForRaiser=data.response.items?data.response.items:[];
            if( this.pendingTaskListForRaiser)
            {
              for(let i of  this.pendingTaskListForRaiser)
              {
                i.key=i.key=='raise_pending_recurring_invoices'?'recurring_invoices':i.key
                // if(i.key == "amc_due_for_renewal")
                // {
                //   i.key = "amc_due_for_renewal";
                // }
                i.count = this.webService.convertNaN(i.count) ? this.webService.convertNaN(i.count) : 0;

                i.count=parseInt(i.count)?parseInt(i.count):0
                i.count = i.count ? i.count : 0;
                if( i.count !=""){
                  if(this.isPendingCardVisibleForRaiser(i.key)){
                    localCount += parseFloat(i.count);
                  }
                }
              }
            }
            this.pendingTaskTitleForRaiser=data.response.title?data.response.title:''
            this.pendingTaskCountForRaiser = localCount ? localCount : 0;

           }
           this.dashboardProjectLoader=false;
        },
        () => {
          this.dashboardProjectLoader=false;

        }
      );
  }


  pendingPMTaskTitle:any='';
  pendingProjectManagementTaskList:any= [];
  pendingPMTaskCount:any = 0;
  pendingPMTaskCountLastDays:any=0;
  getPendingPMTask(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.pendingProjectManagementTaskList=[];

//     if(!this.IS_VAILID_URL('/time-sheet-weekly')&&!this.IS_VAILID_URL('/time-sheet-v2'))
//     {
// return;
//     }
    this.pendingTaskCount = "";
    let localCount:any = 0;
    let localDaysCount:any=0;
    this.dashboardProjectLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
      "how_many_days_pending_in_dashboard":this.company_setup.how_many_days_pending_in_dashboard?this.company_setup.how_many_days_pending_in_dashboard:'5',
      "financial_years": this.selectedFinancialYears,
    }
    this.pendingProjectManagementTaskList=[];
    this.pendingPOChartRecord=[];
    this.pendingPOChartLabels=[];
    this.pendingPOChartColors=[]
    this.runDashboardCounterHttp(
      "project/Timesheet/get_timesheet_chart",
      obj,
      onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
      (data) => {
          if (data.status) {
            let temp:any=[];
            // data.response=typeof data.response=='object'?([data.response?data.response:{}]):data.response
            if(data.response)
            {
              for(let i of data.response)
              {
                // console.log(i)
                if(i.items.length>0)
                {
                  for(let j of i.items)
                  {
                    j.key=j.key=='raise_pending_recurring_invoices'?'recurring_invoice':j.key
                    temp.push(j);
                  }
                }
              }
            }
            this.pendingProjectManagementTaskList=temp?temp:[];
            this.pendingPMTaskTitle=data.response.title?data.response.title:'';
            let pendingPOChartRecord:any=[];
            let pendingPOChartColors:any=[];
            if(this.pendingProjectManagementTaskList){
              for(let totalCount of this.pendingProjectManagementTaskList) {
                // console.log(totalCount)
                let title=totalCount.title;
                if(title.indexOf(" For My Approval")!==-1)
                {
                  title=title.replace(" For My Approval", "");;
                }
                if(title.indexOf(" for My Approval")!==-1)
                {
                  title=title.replace(" for My Approval", "");;
                }

                totalCount.total_count = this.webService.convertNaN(totalCount.total_count) ? parseInt(this.webService.convertNaN(totalCount.total_count)) : 0;
                totalCount.count = this.webService.convertNaN(totalCount.count) ? parseInt(this.webService.convertNaN(totalCount.count)) : 0;

                if(parseInt(totalCount.total_count)>0)
                {
                this.pendingPOChartLabels.push(title)
                pendingPOChartColors.push(totalCount.color)
                pendingPOChartRecord.push(parseInt(totalCount.total_count));
                }
                if( totalCount.total_count !=""){
                  if(this.isPendingCardVisibleForPM(totalCount.key)||this.isPendingCardVisible(totalCount.key)){
                    localCount += parseFloat(totalCount.total_count);
                  }
                }
                if( totalCount.count !=""){
                  if(this.isPendingCardVisibleForPM(totalCount.key)||this.isPendingCardVisible(totalCount.key)){
                    localDaysCount += parseFloat(totalCount.count);
                  }
                }
              }
            }
            this.pendingPOChartColors.push({backgroundColor:pendingPOChartColors})
            this.pendingPOChartRecord.push({data:pendingPOChartRecord,label:'Pending',backgroundColor:pendingPOChartColors,borderWidth: 4,
            hoverBorderColor: this.companyThemeBlockColor,})
           // this.setChartType(this.pendingPOChartType);

            // this.pendingPOChartRecord=this.pendingProjectManagementTaskList?this.pendingProjectManagementTaskList:[]
            this.pendingPMTaskCount = localCount ? localCount : 0;
            this.pendingPMTaskCountLastDays= localDaysCount ? localDaysCount : 0;
            // if(this.company_setup.hide_dashboard_counter=='1') {
              this.dashboardProjectLoader = false
            // }
           }
          this.dashboardProjectLoader = false;
        },
        () => {
          this.dashboardProjectLoader = false;
        }
      );
  }
  pendingPMTaskTitleForRaiser:any='';
  pendingProjectManagementTaskListForRaiser:any= [];
  pendingPMTaskCountForRaiser:any = 0;
  getPendingPMTaskForRaiser(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() == "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.pendingProjectManagementTaskListForRaiser=[];
//     if(!this.IS_VAILID_URL('/my-project-master')&&!this.IS_VAILID_URL('/project-master')&&!this.IS_VAILID_URL('/project-master-approval'))
//     {
// return;
//     }
    this.pendingTaskCount = "";
    let localCount:any = 0;
    this.dashboardProjectLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
      "financial_years": this.selectedFinancialYears,
    }
    // if(1==1) {
    //   return false;
    // }
    this.pendingProjectManagementTaskListForRaiser=[];

    const proceedAfterPendingPMTaskForRaiser = () => {
      if (this.company_setup.hide_dashboard_counter != '1') {
        this.proceedDashboardCounterNext(onComplete, () => this.getPendingTask());
      } else {
        this.continueDashboardCounterChain(onComplete);
      }
    };

    this.runDashboardCounterHttp(
      "project/Expense_sheet/get_pending_project_management_dashboard_chart",
      obj,
      onComplete ? () => proceedAfterPendingPMTaskForRaiser() : undefined,
      (data) => {
          if (data.status) {
            let temp :any =[];
            if(data.response){
              for(let i of data.response)
              {
                for(let j of i.items)
                {
                  j.key=j.key=='raise_pending_recurring_invoices'?'recurring_invoice':j.key
                  temp.push(j);
                }
              }
            }

            this.pendingProjectManagementTaskListForRaiser=temp?temp:[];
            this.pendingPMTaskTitleForRaiser=data.response.title?data.response.title:'';
            if(this.pendingProjectManagementTaskListForRaiser){
              for(let totalCount of this.pendingProjectManagementTaskListForRaiser) {
                if (totalCount.key == 'all_approved_rfq_response' && this.shouldShowRfqPendingForPoTitle()) {
                  totalCount.title = 'RFQ Pending for PO';
                }
                totalCount.count = this.webService.convertNaN(totalCount.count) ? this.webService.convertNaN(totalCount.count) : 0;
                if( totalCount.count !=""){
                  if(this.isPendingPMCardVisibleForRaiser(totalCount.key) || this.isPendingCardVisibleForRaiser(totalCount.key)){
                    localCount += parseFloat(totalCount.count);
                  }
                }
              }
            }
            this.pendingPMTaskCountForRaiser = localCount ? localCount : 0;
           }
          this.dashboardProjectLoader = false;
        },
        () => {
          this.dashboardProjectLoader = false;
        }
      );
  }

  navigatePendingPmTaskByUrl(key,isTotal) {
    let url = "";
    let project = '';
    let dashboardAction = "";
    switch (key) {
      case "pending_timesheet":
        project = 'project_management'
        dashboardAction = ""
       window.location.href=window.location.origin+'/project_management/#/time-sheet-approval';

        break;

        case "pending_project":
          project = 'project_management'
          dashboardAction = ""
          window.location.href=window.location.origin+'/project_management/#/project-master-approval';

           break;

           case "pending_questionnaire":
            project = 'master'
            dashboardAction = ""
        window.location.href=window.location.origin+'/master/#/questionnaire-for-my-approval';

          break;

          case "pending_vendor_rating":
            project = 'master'
            dashboardAction = ""
        window.location.href=window.location.origin+'/master/#/rate-vendor';

          break;

        case "pending_expense":
          project = 'project_management'
          dashboardAction = ""
      window.location.href=window.location.origin+'/project_management/#/expense-sheet-v2-approval';

        break;
        
        case "pending_task":
          project = 'project_management'
        dashboardAction = ""
       window.location.href=window.location.origin+'/project_management/#/task-master-approval';

        break;
        case "pending_pr":
          url = "/allpr-approvals";
          project='operation'
          dashboardAction = "approval_pending_pr"
          break;

        case "recurring_invoice":
          url = "/auto-generated-inv";
          project='operation'
          dashboardAction = "pending_recurring_invoice"
          if(isTotal=='1')
          {
            url = "/recurring-inv-for-approval";
            project='operation'
            dashboardAction = "approval_recurring_invoice"
          }
          break;
          case "my_pr":
            url = "/my-purchases-pr";
            project='operation'
            dashboardAction = "my_pr"
            break;
          case "pending_po":
            url = "/po-approval";
            project='operation'
            dashboardAction = "approval_pending_po"
            break;

            case "pending_iv":
              url = "/invoice-approval";
              project='operation'
              dashboardAction = "approval_pending_iv"
              break;


            case "pending_ip":
              url = "/invoice-payment-approval";
              project='operation'
              dashboardAction = "approval_pending_ip"
              break;  
                       
      case "pending_grn":
        url = "/add-grn";
        project='operation'
        dashboardAction = "pending_grn"
        break;
      case "pending_stock_issue":
          url = "/stock-issue-approval";
          project='asset_management'
          dashboardAction = "pending_stock_issue"
          break;
      case "pending_sales_order":
        url = "/sales-order-approval";
        project='o2c'
        dashboardAction = "pending_sales_order"
        break;
      case "pending_sales_invoice":
        url = "/sales-invoice-for-approval";
        project='o2c'
        dashboardAction = "pending_sales_invoice"
        break;
      case "pending_production":
            url = "/production-record-approval";
            project='asset_management'
            dashboardAction = "pending_production"
            break;
      case "pending_ir":
        url = "/allir-approvals";
        project='operation'
        dashboardAction = "pending_ir"
        break;
      case "pending_boq":
          url = "/boq-approval";
          project='master'
          dashboardAction = "pending_boq"
          break;
      case "pending_adhoc_advance_payment":
        url = "/adhoc-advance-payment-approval";
        project='operation'
        dashboardAction = "pending_adhoc_advance_payment"
        break;
      case "rfq":
        url = "/add-rfq-approval";
        project='master'
        dashboardAction = "rfq"
        break;
        case "rfq":
        url = "/vendors";
        project='master'
        dashboardAction = "rfq"
        break;
      case "rfq_response":
        url = "/rfq-response-approval";
        project='master'
        dashboardAction = "rfq_response"
        break;
      case "journal_entry":
        url = "/je-approval";
        project='finance'
        dashboardAction = "journal_entry"
        break;
      case "pending_pr_for_rfq":
        url = "/pending-pr-for-rfq-no";
        project='operation'
        dashboardAction = "pending_pr_for_rfq"
        break;
      case "rfq":
        url = "/add-rfq";
        project='master'
        dashboardAction = "pending_add_rfq"
        break;
        case "pending_stn":
          url = "/stn-sender-approval";
          project='asset_management'
          dashboardAction = "pending_stn"
          break;
        case "cvppm_pending_approval":
            url = "/cvppm-approval";
            project='mapping'
            dashboardAction = "cvppm_pending_approval"
            break;
            case "utr_pending_to_be_updated":
              url = "/add-payment";
              project='operation'
              dashboardAction = "utr_pending_to_be_updated"
              break; 
              case "vendor_master_pending_to_be_updated":
              url = "/vendor-approval";
              project='master'
              dashboardAction = "vendor_master_pending_to_be_updated"
              break;
              case "vendor_agreement_expiring_60":
              url = "/vendor-agreement";
              project='master'
              dashboardAction = "vendor_agreement_expiring_60"
              break;
              case "expired_vendor_agreement":
              url = "/vendor-agreement";
              project='master'
              dashboardAction = "expired_vendor_agreement"
              break;
              case "customer_agreement_expiring_60":
              url = "/customer-agreement";
              project='master'
              dashboardAction = "customer_agreement_expiring_60"
              break;
              case "expired_customer_agreement":
              url = "/customer-agreement";
              project='master'
              dashboardAction = "expired_customer_agreement"
              break;
              case "product_master_pending_to_be_updated":
              url = "/product-approval";
              project='master'
              dashboardAction = "product_master_pending_to_be_updated"
              break; 
              case "employee_master_pending_to_be_updated":
              url = "/employee-master-approval";
              project='master'
              dashboardAction = "employee_master_pending_to_be_updated"
              break; 
              case "hsn_master_pending_to_be_updated":
              url = "/hsn-approval";
              project='master'
              dashboardAction = "hsn_master_pending_to_be_updated"
              break;  
              case "dc_note_pending_approval":
              url = "/debit-credit-for-approvals";
              project='operation'
              dashboardAction = "dc_note_pending_approval"
              break; 
              case "customer_master_approval":
                url = "/customer-master-approval";
                project='master'
                dashboardAction = "customer_master_approval"
                break;  
                case "customer_balance_approval":
                url = "/customer-balance-approval";
                project='report'
                dashboardAction = "customer_balance_approval"
                // window.location.href=window.location.origin+'/report/#/customer-balance-approval';
                break;
                case "po_hold":
                  url = "/hold-po-for-additional-info";
                  project='operation'
                  dashboardAction = "po_hold"
                  break;
                case "hold_grn":
                  url = "/hold-grn";
                  project='operation'
                  dashboardAction = "hold_grn"
                  break;
                case "hold_payment":
                  url = "/hold-invoice-payment";
                  project='operation'
                  dashboardAction = "hold_payment"
                  break;
        case "technical_rfq_response":
          url = "/rfq-technical-response-approval";
          project='master'
          dashboardAction = "rfq_response"
          break;
          case "amc_due_for_renewal":
            url = "/amc-renewal-dashboard";
            project='master'
            dashboardAction = "amc_due_for_renewal"
            break;
            case "amc_card_expiry":
              url = "/amc-renewal-dashboard";
              project='master'
              dashboardAction = "amc_card_expiry"
              break;
      case "total_no_of_amc_tasks":
        url = "/all-amc-tasks";
        project = 'master'
        dashboardAction = "total_no_of_amc_tasks"
        break;
      case "total_active_amc_tasks":
        url = "/amc-master";
        project = 'master'
        dashboardAction = "total_active_amc_tasks"
        break;
      case "total_pending_amc_tasks":
        url = "/all-amc-tasks";
        project = 'master'
        dashboardAction = "total_pending_amc_tasks"
        break;
      case "amc_tasks_due_in_upcoming_days":
        url = "/all-amc-tasks";
        project = 'master'
        dashboardAction = "amc_tasks_due_in_upcoming_days"
        break;
      case "my_amc_today_tasks":
        // my-amc-task page + ajax_get_scheduled_tasks_by_responsible_person expect dashboard_card_type (master app reads URL / localStorage)
        localStorage.setItem("dashboard_card_type", "my_today");
        // console.log("[Dashboard] AMC card click", { cardKey: key, dashboard_card_type: "my_today" });
        url = "/my-amc-task";
        project = 'master'
        dashboardAction = "my_amc_today_tasks"
        break;
      case "my_amc_overdue_tasks":
        localStorage.setItem("dashboard_card_type", "my_overdue");
        // console.log("[Dashboard] AMC card click", { cardKey: key, dashboard_card_type: "my_overdue" });
        url = "/my-amc-task";
        project = 'master'
        dashboardAction = "my_amc_overdue_tasks"
        break;
      case "my_amc_this_week_tasks":
        localStorage.setItem("dashboard_card_type", "my_this_week");
        // console.log("[Dashboard] AMC card click", { cardKey: key, dashboard_card_type: "my_this_week" });
        url = "/my-amc-task";
        project = 'master'
        dashboardAction = "my_amc_this_week_tasks"
        break;
      case "my_amc_next_week_tasks":
        localStorage.setItem("dashboard_card_type", "my_next_week");
        // console.log("[Dashboard] AMC card click", { cardKey: key, dashboard_card_type: "my_next_week" });
        url = "/my-amc-task";
        project = 'master'
        dashboardAction = "my_amc_next_week_tasks"
        break;
      case "all_amc_today_tasks":
        // all-amc-tasks + ajax_get_scheduled_tasks_by_responsible_person use dashboard_card_type (master app)
        localStorage.setItem("dashboard_card_type", "all_today");
        // console.log("[Dashboard] All AMC card click", { cardKey: key, dashboard_card_type: "all_today" });
        url = "/all-amc-tasks";
        project = 'master'
        dashboardAction = "all_amc_today_tasks"
        break;
      case "all_amc_overdue_tasks":
        localStorage.setItem("dashboard_card_type", "all_overdue");
        // console.log("[Dashboard] All AMC card click", { cardKey: key, dashboard_card_type: "all_overdue" });
        url = "/all-amc-tasks";
        project = 'master'
        dashboardAction = "all_amc_overdue_tasks"
        break;
      case "all_amc_this_week_tasks":
        localStorage.setItem("dashboard_card_type", "all_this_week");
        // console.log("[Dashboard] All AMC card click", { cardKey: key, dashboard_card_type: "all_this_week" });
        url = "/all-amc-tasks";
        project = 'master'
        dashboardAction = "all_amc_this_week_tasks"
        break;
      case "all_amc_next_week_tasks":
        localStorage.setItem("dashboard_card_type", "all_next_week");
        // console.log("[Dashboard] All AMC card click", { cardKey: key, dashboard_card_type: "all_next_week" });
        url = "/all-amc-tasks";
        project = 'master'
        dashboardAction = "all_amc_next_week_tasks"
        break;
        case "part_payment":
          url = "/part-payment-for-approval";
          project='operation'
          dashboardAction = "part_payment"
          break;
          case "lob_master_pending_to_be_updated":
              url = "/primary-location-approval";
              project='master'
              dashboardAction = "lob_master_pending_to_be_updated"
              break; 
              case "unit_type_master_pending_to_be_updated":
              url = "/unit-type-approval";
              project='master'
              dashboardAction = "unit_type_master_pending_to_be_updated"
              break; 
              case "company_bank_master_pending_to_be_updated":
              url = "/company-bank-approval";
              project='master'
              dashboardAction = "company_bank_master_pending_to_be_updated"
              break; 
              case "account_master_pending_to_be_updated":
              url = "/account-master-approval";
              project='master'
              dashboardAction = "account_master_pending_to_be_updated"
              break; 
              case "tds_master_pending_to_be_updated":
              url = "/tds-approval";
              project='master'
              dashboardAction = "tds_master_pending_to_be_updated"
              break; 
              case "department_master_pending_to_be_updated":
              url = "/department-approval";
              project='master'
              dashboardAction = "department_master_pending_to_be_updated"
              break;
              case "pending_amc_task_approval":
                url = "/task-approvals";
                project = 'master';
                dashboardAction = "pending_amc_task_approval";
                break;
              case "user_role_master_pending_to_be_updated":
              url = "/user-role-approval";
              project='settings'
              dashboardAction = "user_role_master_pending_to_be_updated"
              break;
              case "reason_master_pending_to_be_updated":
                url = "/reason-master-approval";
                project = 'master'
                dashboardAction = "reason_master_pending_to_be_updated"
                break;
              case "line_of_business_master_pending_to_be_updated":
                url = "/lob-master-approval";
                project = 'master'
                dashboardAction = "line_of_business_master_pending_to_be_updated"
                break;
                   
        default:
          url = "";
    }

    localStorage.setItem("dashboardAction", this.webService.set(dashboardAction,'dashboardAction'));
    localStorage.setItem("dashboardAction_isTotal", this.webService.set(isTotal,'dashboardAction_isTotal'));
    
    if(url!=''&&url!=undefined)
    {
      let redirectUrl = '/#';
      let origin = window.location.origin;
      if (project == 'master') {
        redirectUrl = origin + '/master' + redirectUrl + url;
      } else if (project == 'settings') {
        redirectUrl = origin + '/settings' + redirectUrl + url;
      } else if (project == 'report') {
        redirectUrl = origin + '/report' + redirectUrl + url;
      } else if (project == 'mapping') {
        redirectUrl = origin + '/mapping' + redirectUrl + url;
      } else if (project == 'finance') {
        redirectUrl = origin + '/finance' + redirectUrl + url;
      }
      else if (project == 'project_management') {
        redirectUrl = origin + '/project_management' + redirectUrl + url;
      }
      else if (project == 'help_desk') {
        redirectUrl = origin + '/help_desk' + redirectUrl + url;
      }else if (project == 'o2c') {
        redirectUrl = origin + '/o2c' + redirectUrl + url;
      }
     else if (project == 'asset_management') {
      redirectUrl = origin + '/asset_management' + redirectUrl + url;
    }

      else {
        if (url == '#' || !url) return;
        this.webService.redirectURL(url);
        return;
      }
      window.location.href = redirectUrl;
    }
  }
  navigatePendingPmRaiseTaskByUrl(key)
  {
    let url = "";
    let project = '';
    let dashboardAction = "";
    switch (key) {
      case "pending_timesheet":
        project = 'project_management'
        dashboardAction = "pending_timesheeet"
        localStorage.setItem('pm_dashboard_action',dashboardAction)
      //  window.location.href=window.location.origin+'/project_management/#/time-sheet-weekly';
      if(!this.IS_VAILID_URL("/time-sheet-v2") && !this.IS_VAILID_URL("/time-sheet-weekly")){
        this.toasterService.pop("info", "Info", "You dont have Access Of This Page");
        return false
      }
      if(this.IS_VAILID_URL("/time-sheet-v2") && this.IS_VAILID_URL("/time-sheet-weekly")){
        window.location.href=window.location.origin+'/project_management/#/time-sheet-v2';
      }else if(this.IS_VAILID_URL("/time-sheet-v2")) {
        window.location.href=window.location.origin+'/project_management/#/time-sheet-v2';
      } else if(this.IS_VAILID_URL("/time-sheet-weekly")) {
        window.location.href=window.location.origin+'/project_management/#/time-sheet-weekly';
      }else {
        window.location.href=window.location.origin+'/project_management/#/time-sheet-v2';
      }
        break;

        case "pending_project":
          project = 'project_management'
          dashboardAction = "pending_project"
          localStorage.setItem('pm_dashboard_action',dashboardAction)
          window.location.href=window.location.origin+'/project_management/#/my-project-master';

           break;

        case "pending_expense":
          project = 'project_management'
        dashboardAction = "pending_expense"
        localStorage.setItem('pm_dashboard_action',dashboardAction)
      window.location.href=window.location.origin+'/project_management/#/expense-sheet-v2';

        break;

        case "pending_task":
          project = 'project_management'
        dashboardAction = "pending_task"
        localStorage.setItem('pm_dashboard_action',dashboardAction)
       window.location.href=window.location.origin+'/project_management/#/my-task-master';
                break;
                case "pending_questionnaire":
                  project = 'master'
                dashboardAction = "pending_rfq"
                localStorage.setItem('master_dashboard_action',dashboardAction)
               window.location.href=window.location.origin+'/master/#/questionnaire-for-my-approval';
              break;
               case "pending_vendor_rating":
                project = 'master'
              dashboardAction = "pending_rfq"
              localStorage.setItem('master_dashboard_action',dashboardAction)
             window.location.href=window.location.origin+'/master/#/rate-vendor';
             break;
                case "rfq":
                  project = 'master'
                dashboardAction = "pending_rfq"
                localStorage.setItem('master_dashboard_action',dashboardAction)
               window.location.href=window.location.origin+'/master/#/add-rfq';
                        break;

                        case "rfq_response":
                          project = 'master'
                        dashboardAction = "pending_rfq_response"
                        localStorage.setItem('master_dashboard_action',dashboardAction)
                       window.location.href=window.location.origin+'/master/#/view-rfq-response';
                                break;
                                case "journal_entry":
                                  project = 'finance'
                                dashboardAction = "pending_je"
                                localStorage.setItem('finance_dashboard_action',dashboardAction)
                               window.location.href=window.location.origin+'/master/#/my-pending-je';
                                        break;


      case "raise_pending_po":
        url = "/raise-po";
        project='operation'
        dashboardAction = "raise_pending_po"
        break;

        case "pending_pr":
        url = "/allpr-approvals";
        project='operation'
        dashboardAction = "pending_pr"
        break;
        case "recurring_invoice":
          url = "/auto-generated-inv";
          project='operation'
          dashboardAction = "pending_recurring_invoice"
          break;
        case "my_pr":
          url = "/my-purchases-pr";
          project='operation'
          dashboardAction = "my_pr"
          break;

        case "raise_pending_irn":
        url = "/new-irn";
        project='operation'
        dashboardAction = "raise_pending_irn"
        break;




        case "raise_pending_grn":
        url = "/add-grn";
        project='operation'
        dashboardAction = "raise_pending_grn"
        break;

        case "pr_hold":
          url = "/hold-pr-for-additional-info";
          project='operation'
          dashboardAction = "pr_hold"
          break;

          case "po_hold":
            url = "/hold-po-for-additional-info";
            project='operation'
            dashboardAction = "po_hold"
            break;

          case "hold_grn":
            url = "/hold-grn";
            project='operation'
            dashboardAction = "hold_grn"
            break;

          case "hold_payment":
            url = "/hold-invoice-payment";
            project='operation'
            dashboardAction = "hold_payment"
            break;

      case "raise_pending_iv":
        url = "/add-invoice-v2";
        project='operation'
        dashboardAction = "raise_pending_iv"
        break;


      case "raise_pending_ip":
        url = "/add-invoice-payments";
        project='operation'
        dashboardAction = "raise_pending_ip"
        break;

        case "raise_pending_production":
          project = 'asset_management'
        dashboardAction = "pending_production"
        localStorage.setItem('dashboard_action',this.eesdesService.set(dashboardAction))
       window.location.href=window.location.origin+'/asset_management/#/my-production-record';
                break;

                case "raise_pending_boq":
                  project = 'master'
                dashboardAction = "pending_boq"
                localStorage.setItem('dashboard_action',this.eesdesService.set(dashboardAction))
               window.location.href=window.location.origin+'/master/#/boq';
                        break;

                        case "raise_pending_ir":
                          url = "/my-ir";
                          project = 'operation'
                        dashboardAction = "pending_ir"
                        localStorage.setItem('dashboard_action',this.eesdesService.set(dashboardAction))
                        localStorage.setItem('dashboardAction',this.eesdesService.set(dashboardAction))

                                break;

                                case "raise_pending_sales_invoice":
                                  project = 'o2c'
                                dashboardAction = "pending_sales_invoice"
                                localStorage.setItem('dashboardAction',this.eesdesService.set(dashboardAction))
                                localStorage.setItem('dashboard_action',this.eesdesService.set(dashboardAction))

                               window.location.href=window.location.origin+'/o2c/#/my-sales-invoice';
                                        break;

                                        case "raise_pending_sales_order":
                                          project = 'o2c'
                                        dashboardAction = "pending_so"
                                        localStorage.setItem('dashboardAction',this.eesdesService.set(dashboardAction))
                                        localStorage.setItem('dashboard_action',this.eesdesService.set(dashboardAction))

                                       window.location.href=window.location.origin+'/o2c/#/my-sales-order';
                                                break;
                                              

                                                case "pending_raised_stock":
                                                  project = 'asset_management'
                                                dashboardAction = "pending_si"
                                                // Plain value for asset_management cross-app (eesdesService.set returns undefined when encryption is off)
                                                localStorage.setItem('dashboard_action', dashboardAction)
                                                localStorage.setItem('action_type', dashboardAction)
                                                localStorage.setItem('dashboardAction', this.eesdesService.set(dashboardAction))
                                               window.location.href=window.location.origin+'/asset_management/#/my-stock-issue';
                                                        break;
                                                        case "pending_pr_for_rfq":
                                                        url = "/pending-pr-for-rfq-no";
                                                        project='operation'
                                                        dashboardAction = "pending_pr_for_rfq"
                                                        break;
        // case "Approved_e":
        //   url = "/add-invoice-payments";
        //   project='project-'
        //   dashboardAction = "raise_pending_ip"
        //   break;
        case "advance_payament_raiser":
          url = "/adhoc-advance-payment";
          project='operation'
          dashboardAction = "advance_payament_raiser"
          break;
          case "all_approved_rfq_response":
          project = 'master'
          dashboardAction = "all_approved_rfq_response"
          localStorage.setItem('master_dashboard_action',dashboardAction)
          console.log( localStorage.getItem('master_dashboard_action'))
         window.location.href=window.location.origin+'/master/#/all-approved-rfq-response';
         break;
         case "vendor_invoice_dashboard":
          url = "/invoice-dashboard";
          project='operation'
          dashboardAction = "vendor_invoice_dashboard"
          break;
          case "vendor_delivery_dashboard":
            url = "/vendor-irn-dashboard";
            project='operation'
            dashboardAction = "vendor_delivery_dashboard"
            break;
          case "customer_balance_approval":
            url = "/customer-balance-approval";
            project='report'
            dashboardAction = "customer_balance_approval"
            localStorage.setItem('report_dashboard_action',dashboardAction)
            window.location.href=window.location.origin+'/report/#/customer-balance-approval';
            break;

        case "technical_rfq_response":
          project = 'master'
          dashboardAction = "pending_rfq_response"
          localStorage.setItem('master_dashboard_action',dashboardAction)
          window.location.href=window.location.origin+'/master/#/rfq-technical-response';

          case "amc_due_for_renewal":
            // url = "/amc-renewal-dashboard";
            project = 'master'
            dashboardAction = "amc_due_for_renewal"
            localStorage.setItem('amc_card_type',dashboardAction)
            window.location.href=window.location.origin+'/master/#/amc-renewal-dashboard';
            break;
            case "amc_card_expiry":
              project = 'master'
              dashboardAction = "amc_card_expiry"
              localStorage.setItem('amc_card_type',dashboardAction)
              window.location.href=window.location.origin+'/master/#/amc-renewal-dashboard';
              break;
              case "total_no_of_amc_tasks":
                project = 'master'
                dashboardAction = "total_no_of_amc_tasks"
                localStorage.setItem('amc_card_type',dashboardAction)
                window.location.href=window.location.origin+'/master/#/all-amc-tasks';
                break;
              case "total_active_amc_tasks":
                project = 'master'
                dashboardAction = "total_active_amc_tasks"
                localStorage.setItem('amc_card_type',dashboardAction)
                window.location.href=window.location.origin+'/master/#/amc-master';
                break;
              case "total_pending_amc_tasks":
                project = 'master'
                dashboardAction = "total_pending_amc_tasks"
                localStorage.setItem('amc_card_type',dashboardAction)
                window.location.href=window.location.origin+'/master/#/all-amc-tasks';
                break;
              case "amc_tasks_due_in_upcoming_days":
                project = 'master'
                dashboardAction = "amc_tasks_due_in_upcoming_days"
                localStorage.setItem('amc_card_type',dashboardAction)
                window.location.href=window.location.origin+'/master/#/all-amc-tasks';
              break;         
        case "part_payment":
          url = "/part-payment";
          project='operation'
          dashboardAction = "part-payment"
          break;
        case 'mailed_invoice':
          url = "/mailed-invoice";
          project='operation'
          dashboardAction = "mailed-invoice"
          break;
        case 'adhoc_advance_payment':
          url = "/adhoc-advance-payment";
          project = 'operation'
          dashboardAction = "adhoc_advance_payment"
          break;
          case "raise_pending_srn":
            url = "/new-srn";
            project='operation'
            dashboardAction = "raise_pending_srn"
            break;
          case "pending_amc_task_approval":
            project = 'master'
            dashboardAction = "pending_amc_task_approval"
            break;
        case 'failed_mailed_invoice':
          // Open Mailed Invoice page on "failed" tab
          try {
            localStorage.setItem('mailed_invoice_pagination', JSON.stringify({
              activeTab: 'failed',
              inProcessPage: 1,
              inProcessRowsPerPage: 20
            }));
          } catch (e) {}
          url = "/mailed-invoice";
          project='operation'
          dashboardAction = "failed-mailed-invoice"
          break;
          case "pending_amc_task_approval":
            project = 'master'
            dashboardAction = "pending_amc_task_approval"
            break;
        case "raise_pending_srn":
            url = "/new-srn";
            project='operation'
            dashboardAction = "raise_pending_srn"
            break;
          case 'my_assigned_invoices':
            url = "/my-mailed-invoice";
            project = 'operation'
            dashboardAction = "my-assigned-invoices"
            break;
        default:
          url = "";
    }

   localStorage.setItem("dashboardAction", this.eesdesService.set(dashboardAction))
    if(url!=''&&url!=undefined)
    {
      let redirectUrl = '/#';
      let origin = window.location.origin;
      if (project == 'master') {
        redirectUrl = origin + '/master' + redirectUrl + url;
      } else if (project == 'report') {
        redirectUrl = origin + '/report' + redirectUrl + url;
      } else if (project == 'mapping') {
        redirectUrl = origin + '/mapping' + redirectUrl + url;
      } else if (project == 'finance') {
        redirectUrl = origin + '/finance' + redirectUrl + url;
      }
      else if (project == 'project_management') {
        redirectUrl = origin + '/project_management' + redirectUrl + url;
      }
      else if (project == 'help_desk') {
        redirectUrl = origin + '/help_desk' + redirectUrl + url;
      }

      else {
        if (url == '#' || !url) return;
        this.webService.redirectURL(url);
        return;
      }
      window.location.href = redirectUrl;
    }
  }

  getTaskNamePM(key,title,isTotal='1') {

    let name = "";

    switch (key) {

      case "pending_timesheet":
        name='Click to go '+title+" Page"
        break;

      case "pending_project":
        name='Click to go '+title+" Page"
        break;

      case "pending_expense":
        name='Click to go '+title+" Page"
        break;
      case "cvppm_pending_approval":
        name = `Click to go ${title} Page`
        break;
      case "utr_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
        case "vendor_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
        case "vendor_agreement_expiring_60":
        name = `Click to go ${title} Page`
        break;
        case "expired_vendor_agreement":
        name = `Click to go ${title} Page`
        break;
        case "customer_agreement_expiring_60":
        name = `Click to go ${title} Page`
        break;
        case "expired_customer_agreement":
        name = `Click to go ${title} Page`
        break;
        case "product_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
        case "employee_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
        case "hsn_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
        case "dc_note_pending_approval":
        name = `Click to go ${title} Page`
        break;
        case "customer_master_approval":
        name = `Click to go ${title} Page`
        break;
        case "customer_balance_approval":
        name = `Click to go ${title} Page`
        break;
        case "po_hold":
          name = `Click to go ${title} Page`
          break;
      case "pending_task":
        name='Click to go '+title+" Page"
        break;

        case "pending_pr":
        name='Click to go '+title+" Page"
        break;
        case "recurring_invoice":
          name = `Click to go ${title} Page`
          break;
          case "cvppm_pending_approval":
            name = `Click to go ${title} Page`
            break;
          case "utr_pending_to_be_updated":
              name = `Click to go ${title} Page`
              break;
              case "vendor_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "vendor_agreement_expiring_60":
                name = `Click to go ${title} Page`
                break;
              case "expired_vendor_agreement":
                name = `Click to go ${title} Page`
                break;
              case "customer_agreement_expiring_60":
                name = `Click to go ${title} Page`
                break;
              case "expired_customer_agreement":
                name = `Click to go ${title} Page`
                break;
              case "lob_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "unit_type_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "company_bank_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "account_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "tds_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              case "department_master_pending_to_be_updated":
                name = `Click to go ${title} Page`
                break;
              
                case "line_of_business_master_pending_to_be_updated":
                  name = `Click to go ${title} Page`
                  break;
                case "user_role_master_pending_to_be_updated":
                  name = `Click to go ${title} Page`
                  break;
                case "reason_master_pending_to_be_updated":
                  name = `Click to go ${title} Page`
                  break;
              
            
      case "pending_po":
        name='Click to go '+title+" Page"
        break;
      case "pending_iv":
        name='Click to go '+title+" Page"
        break;

      case "pending_ip":
        name='Click to go '+title+" Page"
        break;

        case "raise_pending_po":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_irn":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_grn":
        name='Click to go '+title+" Page"
        break;
        case "pending_grn":
          name='Click to go '+title+" Page"
          break;
        case "raise_pending_iv":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_ip":
        name='Click to go '+title+" Page"
        break;
        case "raise_recurring_invoice":
          name='Click to go '+title+" Page"
          break;

          case "recurring_invoice":
            name='Click to go '+title+" Page"
            break;

            case "pending_questionnaire":
              name='Click to go '+title+" Page"
              break;

              case "pending_vendor_rating":
                name='Click to go '+title+" Page"
                break;

                case "vendor_invoice_dashboard":
                  name='Click to go '+title+" Page"
                  break;
                  case "vendor_delivery_dashboard":
                    name='Click to go '+title+" Page"
                    break;  
      case "technical_rfq_response":
        name = `Click to go ${title} Page`
        break;
        case "amc_due_for_renewal":
          name = `Click to go ${title} Page`
          break;
        case "amc_card_expiry":
          name = `Click to go ${title} Page`
          break;
          case "total_no_of_amc_tasks":
            name = `Click to go ${title} Page`
            break;
          case "total_active_amc_tasks":
            name = `Click to go ${title} Page`
            break;
          case "total_pending_amc_tasks":
            name = `Click to go ${title} Page`
            break;
          case "amc_tasks_due_in_upcoming_days":
          name = `Click to go ${title} Page`
          break;
      case "part_payment":
        name = `Click to go ${title} Page`
        break;
      case 'mailed_invoice':
        name = `Click to go ${title} Page`
        break;
        case "pending_amc_task_approval":
          name = `Click to go ${title} Page`
          break;
      case 'failed_mailed_invoice':
        name = `Click to go ${title} Page`
        break;
      case "raise_pending_srn":
          name = `Click to go ${title} Page`
          break;
      case 'my_assigned_invoices':
        name = `Click to go ${title} Page`
        break;
      default:
        name = "";
    }
    if(name!='' && isTotal!='1')
    {
      name=name+" and get info For Last "+this.company_setup.how_many_days_pending_in_dashboard+" Days"
    }
   return name;
  }


  pendingTaskTitleForVendor:any='';
  pendingTaskListForVendor:any= [];
  pendingTaskCountForVendor:any = 0;
  pendingTaskCountVendor:any=0;
  getPendingTaskForVendor(onComplete?: () => void) {
    if (!this.isDashboardActive()) {
      return;
    }
    if (this._localStorageService.getUserRole() !== "vendor") {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.pendingTaskCountVendor = "";
    let localCount:any = 0;
    this.dashboardProjectLoader = true
    let obj = {
      "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
      "company_id": this._localStorageService.getEmpCompanyId(),
    }
    this.pendingTaskListForVendor=[];
    this.runDashboardCounterHttp(
      "Vendor_management/ajax_dashboard_pending_cards_sorted",
      obj,
      onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
      (data) => {
          if (data.status) {
            let temp :any =[];
            if(data.response){
              for(let i of data.response)
              {
                for(let j of i.items)
                {
                  temp.push(j);
                }
              }
            }

            this.pendingTaskListForVendor=temp?temp:[];
            this.pendingTaskTitleForVendor=data.response.length>0?data.response[0].title:'';
            if(this.pendingTaskListForVendor){
              for(let totalCount of this.pendingTaskListForVendor) {
                totalCount.count = this.webService.convertNaN(totalCount.count) ? this.webService.convertNaN(totalCount.count) : 0;
                if( totalCount.count !=""){
                  if(this.isPendingCardVisibleForVendor(totalCount.key)){
                    localCount += parseFloat(totalCount.count);
                  }
                }
              }
            }
            this.pendingTaskCountForVendor = localCount ? localCount : 0;
           }
          //  console.log(this.pendingTaskListForVendor);
           this.dashboardProjectLoader = false

        },
        () => {
          this.dashboardProjectLoader = false

        }
      );
  }
  isPendingCardVisibleForVendor(id)
  {
    if(id!=''&&id!=undefined)
    {
      id=id.replace("raise_", "")
    }
    // return true
    return this.company_setup.vendor_dashboard_notification.some((v)=>{return v.id==id && v.is_visible_on_vendor_dashboard})
  }
  getTaskNameVendor(key,title) {

    let name = "";

    switch (key) {

      case "pending_timesheet":
        name='Click to go '+title+" Page"
        break;

      case "pending_project":
        name='Click to go '+title+" Page"
        break;

      case "pending_expense":
        name='Click to go '+title+" Page"
        break;
        case "cvppm_pending_approval":
          name = `Click to go ${title} Page`
          break;
        case "utr_pending_to_be_updated":
           name = `Click to go ${title} Page`
           break;
           case "vendor_master_pending_to_be_updated":
           name = `Click to go ${title} Page`
           break;
           case "vendor_agreement_expiring_60":
           name = `Click to go ${title} Page`
           break;
           case "expired_vendor_agreement":
           name = `Click to go ${title} Page`
           break;
           case "customer_agreement_expiring_60":
           name = `Click to go ${title} Page`
           break;
           case "expired_customer_agreement":
           name = `Click to go ${title} Page`
           break;
           case "product_master_pending_to_be_updated":
           name = `Click to go ${title} Page`
           break;
           case "employee_master_pending_to_be_updated":
           name = `Click to go ${title} Page`
           break;
           case "hsn_master_pending_to_be_updated":
           name = `Click to go ${title} Page`
           break;
           case "dc_note_pending_approval":
            name = `Click to go ${title} Page`
            break;
      case "pending_task":
        name='Click to go '+title+" Page"
        break;

        case "pending_pr":
        name='Click to go '+title+" Page"
        break;
        case "recurring_invoice":
          name='Click to go '+title+" Page"
          break;
          case "cvppm_pending_approval":
            name='Click to go '+title+" Page"
            break;
            case "utr_pending_to_be_updated":
              name='Click to go '+title+" Page"
              break;
              case "vendor_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "vendor_agreement_expiring_60":
                name='Click to go '+title+" Page"
                break;
              case "expired_vendor_agreement":
                name='Click to go '+title+" Page"
                break;
              case "customer_agreement_expiring_60":
                name='Click to go '+title+" Page"
                break;
              case "expired_customer_agreement":
                name='Click to go '+title+" Page"
                break;
              case "lob_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "unit_type_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "company_bank_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "account_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "tds_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "department_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
              case "product_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
                case "employee_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
                case "hsn_master_pending_to_be_updated":
                name='Click to go '+title+" Page"
                break;
                case "dc_note_pending_approval":
                name='Click to go '+title+" Page"
                break;
                case "customer_master_approval":
                name = `Click to go ${title} Page`
                break;
                case "customer_balance_approval":
                name = `Click to go ${title} Page`
                break;
                case "po_hold":
                  name = `Click to go ${title} Page`
                  break;
      case "pending_po":
        name='Click to go '+title+" Page"
        break;
      case "pending_iv":
        name='Click to go '+title+" Page"
        break;

      case "pending_ip":
        name='Click to go '+title+" Page"
        break;

        case "raise_pending_po":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_irn":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_grn":
        name='Click to go '+title+" Page"
        break;
        case "pending_grn":
          name='Click to go '+title+" Page"
          break;
        case "raise_pending_iv":
        name='Click to go '+title+" Page"
        break;
        case "raise_pending_ip":
        name='Click to go '+title+" Page"
        break;
        case "vendor_invoice_dashboard":
        name='Click to go '+title+" Page"
        break;
        case "vendor_delivery_dashboard":
        name='Click to go '+title+" Page"
        break;
      case "technical_rfq_response":
        name = `Click to go ${title} Page`
        break;
        case "amc_due_for_renewal":
        name = `Click to go ${title} Page`
        break;
        case "amc_card_expiry":
        name = `Click to go ${title} Page`
        break;
      case "total_no_of_amc_tasks":
        name = `Click to go ${title} Page`
        break;
      case "total_active_amc_tasks":
        name = `Click to go ${title} Page`
        break;
      case "total_pending_amc_tasks":
        name = `Click to go ${title} Page`
        break;
      case "amc_tasks_due_in_upcoming_days":
        name = `Click to go ${title} Page`
        break;
       case "part_payment":
        name = `Click to go ${title} Page`
        break;
      case 'mailed_invoice':
        name = `Click to go ${title} Page`
        break;
        case "pending_amc_task_approval":
          name = `Click to go ${title} Page`
          break;
      case 'failed_mailed_invoice':
        name = `Click to go ${title} Page`
        break;
      case "raise_pending_srn":
        name = `Click to go ${title} Page`
        break;
      case "user_role_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
      case "reason_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
   
      case "line_of_business_master_pending_to_be_updated":
        name = `Click to go ${title} Page`
        break;
      case 'my_assigned_invoices':
        name = `Click to go ${title} Page`
        break;
      default:
        name = "";
    }
   return name;
  }
  vendorPOPieChartType:any='pie';
  vendorPOPieChartLabelsList:any=[];
  vendorPOPieChartList:any=[];
  vendorPoPieCharttTitle:any='Submain';
  vendorPoPiechartMainTitle:any='Main';
  isVendorPOPieChartLoading:boolean=true;
  vendorPOPieChartCount:any=0;
  getVendorPOStatics(onComplete?: () => void)
  {
  if (!this.isDashboardActive()) {
    return;
  }

  if (this._localStorageService.getUserRole() !== "vendor") {
    this.isVendorPOPieChartLoading=false
    this.continueDashboardCounterChain(onComplete);
    return;
  }
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  }
  this.vendorPOPieChartLabelsList=[];
  this.vendorPOPieChartList=[];
  this.runDashboardCounterHttp(
    "Vendor_management/ajax_dashboard_pending_cards_sorted_V2",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
        if (data.status) {
          let list:any=[data.response?data.response:{}];

          let temp:any=[];
          let color:any=[];
          if(list)
          {
            for(let j of list)
            {
              if(j.items)
              {
                for(let i of j.items)
                {
                  // let count=i.count.length;
                  // let count=i.sum?i.sum:'0';
                  // console.log('count',count);
                  

              // let name=i.title;
              let name=i.title + " (" + i.count + ")";
              this.vendorPOPieChartCount=parseFloat(this.vendorPOPieChartCount)+parseFloat(this.webService.convertNaN(i.sum))
              this.vendorPOPieChartCount=this.webService.convertNaN(this.vendorPOPieChartCount);
              this.vendorPOPieChartLabelsList.push(name);
             temp.push(this.webService.convertNaN(i.sum));
             color.push(i.color);
              }
            }
          }
            this.vendorPOPieChartList=[
              {
                title:"PO Statistics",
                  type: 'pie',
                // data:  [12, 10, 15, 10, 40, 13],
                data:  temp?temp:[],
                backgroundColor:color?color:[]

              }
            ]

          }
  }
  else
  {
    this.isVendorPOPieChartLoading=false

  }
  this.isVendorPOPieChartLoading=false;
},
() => {
  this.isVendorPOPieChartLoading=false

}
);
}
  pmCardVisibleAccordingUserRole(key){
    let status:boolean=true;
    switch(key){
    case 'all_project':
    status= this.company_setup.dashboard_cards_according_to_user_role_pm.some((v)=>{return v.id == key && v.user_role_list.some((d)=>{return parseInt(d.item_id) == parseInt(this.employeeUserRoleId)})});
    break;
    default:
  status=true;
}
return status;
}



vendorInvoicePieChartType:any='pie';
  vendorInvoicePieChartLabelsList:any=[];
  vendorInvoicePieChartList:any=[];
  vendorInvoicePieCharttTitle:any='Submain';
  vendorInvoicePiechartMainTitle:any='Main';
  isVendorInvoicePieChartLoading:boolean=true;
  vendorInvoicePieChartCount:any=0;
  getVendorInvoiceStatics(onComplete?: () => void)
  {
  if (!this.isDashboardActive()) {
    return;
  }

  if (this._localStorageService.getUserRole() !== "vendor") {
    this.isVendorInvoicePieChartLoading=false
    this.continueDashboardCounterChain(onComplete);
    return;
  }
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  }
  this.vendorInvoicePieChartLabelsList=[];
  this.vendorInvoicePieChartList=[];
  this.runDashboardCounterHttp(
    "Vendor_management/ajax_dashboard_pending_cards_sorted_V4",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
        if (data.status) {
          let list:any=[data.response?data.response:{}];

          let temp:any=[];
          let color:any=[];
          if(list)
          {
            for(let j of list)
            {
              if(j.items)
              {
                for(let i of j.items)
                {
              let name=i.title + " (" + i.count + ")";
              this.vendorInvoicePieChartCount=parseFloat(this.vendorInvoicePieChartCount)+parseFloat(this.webService.convertNaN(i.sum))
              this.vendorInvoicePieChartCount=this.webService.convertNaN(this.vendorInvoicePieChartCount);
              this.vendorInvoicePieChartLabelsList.push(name);
             temp.push(this.webService.convertNaN(i.sum));
             color.push(i.color);
              }
            }
          }
            this.vendorInvoicePieChartList=[
              {
                title:"Invoice Statistics",
                  type: 'pie',
                // data:  [12, 10, 15, 10, 40, 13],
                data:  temp?temp:[],
                backgroundColor:color?color:[]

              }
            ]

          }

  }
  else
  {

  }
  this.isVendorInvoicePieChartLoading=false

},
() => {
  this.isVendorInvoicePieChartLoading=false

}
);
}

po_till_date_vendorPObarChartType:any='bar';
po_till_date_vendorPObarChartLabelsList:any=[];
po_till_date_vendorPObarChartList:any=[];
po_till_date_vendorPobarCharttTitle:any='Submain';
po_till_date_vendorPobarchartMainTitle:any='Main';
po_till_date_isVendorPObarChartLoading:boolean=true;
po_till_date_vendorPObarChartCount:any='';


po_not_dis_till_date_vendorPObarChartType:any='bar';
po_not_dis_till_date_vendorPObarChartLabelsList:any=[];
po_not_dis_till_date_vendorPObarChartList:any=[];
po_not_dis_till_date_vendorPobarCharttTitle:any='Submain';
po_not_dis_till_date_vendorPobarchartMainTitle:any='Main';
po_not_dis_till_date_isVendorPObarChartLoading:boolean=true;
po_not_dis_till_date_vendorPObarChartCount:any='';

getVendorPOBarStatics(onComplete?: () => void)
{
if (!this.isDashboardActive()) {
  return;
}

if (this._localStorageService.getUserRole() !== "vendor") {
  this.po_till_date_isVendorPObarChartLoading=false
  this.po_not_dis_till_date_isVendorPObarChartLoading=false;
  this.continueDashboardCounterChain(onComplete);
  return;
}
let obj = {
  "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
  "company_id": this._localStorageService.getEmpCompanyId(),
}
this.po_till_date_vendorPObarChartLabelsList=[];
this.po_till_date_vendorPObarChartList=[];

this.po_not_dis_till_date_vendorPObarChartLabelsList=[];
this.po_not_dis_till_date_vendorPObarChartList=[];

this.runDashboardCounterHttp(
  "Vendor_management/ajax_dashboard_pending_cards_sorted_V3",
  obj,
  onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
  (data) => {
      if (data.status) {
        let list:any=[data.response.items[0]?data.response.items[0]:{}];


        if(list)
        {
          for(let i of list)
          {
                if(i.count.length>0)
                {
                  for(let k of i.count)
                  {
                    let count=k.total_items;
                    let name=i.title;
                    this.po_till_date_vendorPObarChartCount=parseFloat(this.po_till_date_vendorPObarChartCount)+parseFloat(this.webService.convertNaN(count))
                    this.po_till_date_vendorPObarChartCount=this.webService.convertNaN(this.po_till_date_vendorPObarChartCount);
                    this.po_till_date_vendorPObarChartLabelsList.push(k.product_name);


                   this.po_till_date_vendorPObarChartList.push({
                     type: 'bar',
                     label: k.product_name,
                     data: k.total_items,
                     fill: false,
                     borderColor: k.color,
                     pointStyle: 'spline',
                     pointBorderWidth: 7,
                     display: true,
                     backgroundColor:k.color,
                   })
            }
          }
          this.po_till_date_vendorPobarchartMainTitle=i.title+"("+this.po_till_date_vendorPObarChartCount+")";

        }

          // console.log(this.po_till_date_vendorPObarChartList);
          // console.log(this.po_till_date_vendorPObarChartLabelsList)
        }

        let list1:any=[data.response.items[1]?data.response.items[1]:{}];


        if(list1)
        {
          for(let i of list1)
          {
                if(i.count.length>0)
                {
                  for(let k of i.count)
                  {
                    let count=k.total_items;
                    let name=i.title;
                    this.po_not_dis_till_date_vendorPObarChartCount=parseFloat(this.po_not_dis_till_date_vendorPObarChartCount)+parseFloat(this.webService.convertNaN(count))
                    this.po_not_dis_till_date_vendorPObarChartCount=this.webService.convertNaN(this.po_not_dis_till_date_vendorPObarChartCount);
                    this.po_not_dis_till_date_vendorPObarChartLabelsList.push(k.product_name);


                   this.po_not_dis_till_date_vendorPObarChartList.push(
                    {
                     type: 'bar',
                     label: k.product_name,
                     data: k.total_items,
                     fill: false,
                     backgroundColor:k.color,
                     borderColor: k.color,
                     pointStyle: 'spline',
                     pointBorderWidth: 7,
                     display: true,
                   })

            }
          }

          this.po_not_dis_till_date_vendorPobarchartMainTitle=i.title +"("+this.po_not_dis_till_date_vendorPObarChartCount+")";

        }
        }
}
else
{

}
this.po_till_date_isVendorPObarChartLoading=false
this.po_not_dis_till_date_isVendorPObarChartLoading=false;


},
() => {
this.po_till_date_isVendorPObarChartLoading=false
this.po_not_dis_till_date_isVendorPObarChartLoading=false;


}
);
}
getPageUrl(data,type)
{
let url:any='';

switch(data.id)
{
  case 'pending_pr':
    url=type=='RAISE'?'/raisepr':'/allpr-approvals';
  break;
  case 'recurring_invoice':
    url=type=='RAISE'?'/auto-generated-inv':'/recurring-inv-for-approval';
  break;
  case 'pending_stock_issue':
    url=type=='RAISE'?'/raise-stock-issue':'/stock-issue-approval';
  break;
  case 'pending_po':
    url=type=='RAISE'?'/raise-po':'/po-approval';
  break;
  case 'pending_irn':
    url=type=='RAISE'?'/new-irn':'/add-grn';
  break;
  case 'pending_grn':
    url=type=='RAISE'?'/add-grn':'/add-grn';
  break;
  case 'pending_iv':
    url=type=='RAISE'?'/add-invoice-v2':'/invoice-approval';
  break;
    case 'pending_ip':
    url=type=='RAISE'?'/add-invoice-payments':'/invoice-payment-approval';
  break;
  case 'pending_sales_order':
    url=type=='RAISE'?'/sales-order-creation':'/sales-order-approval';
  break;
  case 'pending_sales_invoice':
    url=type=='RAISE'?'/sales-invoice':'/sales-invoice-for-approval';
  break;
  case 'pending_production':
    url=type=='RAISE'?'/multi-step-production':'/production-record-approval';
  break;
  case 'pending_ir':
    url=type=='RAISE'?'/raiseir':'/allir-approvals';
  break;
  case 'my_todays_tasks':
  case 'my_overdue_tasks':
  case 'my_this_week_tasks':
  case 'my_next_week_tasks':
    url = '/my-amc-task';
  break;
  case 'all_todays_tasks':
  case 'all_overdue_tasks':
  case 'all_this_week_tasks':
  case 'all_next_week_tasks':
    url = '/all-amc-tasks';
  break;
  case 'pending_boq':
    url=type=='RAISE'?'/boq':'/boq-approval';
  break;
  case 'cvppm_pending_approval':
    url=type=='RAISE'?'/mapping':'/cvppm-approval';
  break;
  case 'utr_pending_to_be_updated':
    url=type=='RAISE'?'/operation':'/add-payment';
  break;
  case 'vendor_master_pending_to_be_updated':
    url=type=='RAISE'?'/master':'/vendor-approval';
  break;
  case 'vendor_agreement_expiring_60':
    url=type=='RAISE'?'/master':'/vendor-agreement';
  break;
  case 'expired_vendor_agreement':
    url=type=='RAISE'?'/master':'/vendor-agreement';
  break;
  case 'customer_agreement_expiring_60':
    url=type=='RAISE'?'/master':'/customer-agreement';
  break;
  case 'expired_customer_agreement':
    url=type=='RAISE'?'/master':'/customer-agreement';
  break;
  case 'product_master_pending_to_be_updated':
    url=type=='RAISE'?'/master':'/product-approval';
  break;
  case 'employee_master_pending_to_be_updated':
    url=type=='RAISE'?'/master':'/employee-master-approval';
  break;
  case 'hsn_master_pending_to_be_updated':
    url=type=='RAISE'?'/master':'/hsn-approval';
  break;
  case 'dc_note_pending_approval':
    url=type=='RAISE'?'/debit-credit-for-approvals':'/debit-credit-for-approvals';
  break;
  case 'pr_hold ':
    url=type=='RAISE'?'/hold-pr-for-additional-info':'/hold-pr-for-additional-info';
  break;
  case 'pr_hold':
    url=type=='RAISE'?'/hold-pr-for-additional-info':'/hold-pr-for-additional-info';
  break;
  case 'po_hold':
    url=type=='RAISE'?'/hold-po-for-additional-info':'/hold-po-for-additional-info';
  break;
  case 'hold_grn':
    url=type=='RAISE'?'/hold-grn':'/hold-grn';
  break;
  case 'hold_payment':
    url=type=='RAISE'?'/hold-invoice-payment':'/hold-invoice-payment';
  break;
  case 'pending_adhoc_advance_payment':
    url=type=='RAISE'?'/adhoc-advance-payment-approval':'/adhoc-advance-payment-approval';
  break;
  case 'rfq':
    url=type=='RAISE'?'/add-rfq-approval':'/add-rfq-approval';
  break;
  case 'rfq_response':
    // url=type=='RAISE'?'/view-rfq-response':'/view-rfq-response';
    url=type=='RAISE'?'/rfq-response-approval':'/rfq-response-approval';
  break;
  case 'journal_entry':
    url=type=='RAISE'?'/je-approval':'/je-approval';
  break;
  case 'pending_pr_for_rfq':
    url=type=='RAISE'?'/pending-pr-for-rfq-no':'/pending-pr-for-rfq-no';
  break;
  case 'advance_payament_raiser':
    url=type=='RAISE'?'/adhoc-advance-payment':'/adhoc-advance-payment';
  break;
  case 'pending_vendor_rating':
    url=type=='RAISE'?'/rate-vendor':'/rated-vendor';
  break;
  case 'pending_questionnaire':
    url=type=='RAISE'?'/questionnaire-template':'/questionnaire-for-my-approval';
  break;
  case 'all_approved_rfq_response':
    url=type=='RAISE'?'/all-approved-rfq-response':'/all-approved-rfq-response';
  break;
  case 'pending_stn':
    url=type=='RAISE'?'/stn-sender-approval':'/stn-sender-approval';
  break;
  case 'cvppm_pending_approval':
    url=type=='RAISE'?'/cvppm-approval':'/cvppm-approval';
  break;
  case '  utr_pending_to_be_updated':
    url=type=='RAISE'?'/add-payment':'/add-payment';
  break;
  case 'vendor_invoice_dashboard':
    url=type=='RAISE'?'/invoice-dashboard':'/invoice-dashboard';
  break;
  case 'vendor_delivery_dashboard':
    url=type=='RAISE'?'/vendor-irn-dashboard':'/vendor-irn-dashboard';
  break;
  case 'customer_master_approval':
    url=type=='RAISE'?'/master':'/customer-master-approval';
  break;
  case 'customer_balance_approval':
    url=type=='RAISE'?'/report':'/customer-balance-approval';
  break;
  case "technical_rfq_response":
    url=type=='RAISE'?'/rfq-technical-response-approval':'/rfq-technical-response-approval';
    break;
    case "amc_due_for_renewal":
    url=type=='RAISE'?'/amc-renewal-dashboard':'/amc-renewal-dashboard';
    break;
    case "amc_card_expiry":
    url=type=='RAISE'?'/amc-renewal-dashboard':'/amc-renewal-dashboard';
    break;
    case "total_no_of_amc_tasks":
    url=type=='RAISE'?'/all-amc-tasks':'/all-amc-tasks';
    break;
    case "total_active_amc_tasks":
    url=type=='RAISE'?'/amc-master':'/amc-master';
    break;
    case "total_pending_amc_tasks":
    url=type=='RAISE'?'/all-amc-tasks':'/all-amc-tasks';
    break;
    case "amc_tasks_due_in_upcoming_days":
    url=type=='RAISE'?'/all-amc-tasks':'/all-amc-tasks';
    break;
  case 'part_payment':
    url=type=='RAISE'?'/part-payment':'/part-payment-for-approval';
    break;
  case 'mailed_invoice':
    url=type=='RAISE'?'/mailed-invoice':'/mailed-invoice';
    break;
  case 'adhoc_advance_payment':
    url=type=='RAISE'?'/adhoc-advance-payment':'/adhoc-advance-payment';
    case "raise_pending_srn":
    url=type=='RAISE'?'/new-srn':'/new-srn';
    break;
  case 'failed_mailed_invoice':
    // Same page, but dashboard click will set state to open "failed" tab
    url=type=='RAISE'?'/mailed-invoice':'/mailed-invoice';
    break;
  case "raise_pending_srn":
    url=type=='RAISE'?'/new-srn':'/new-srn';
    break;
    case 'lob_master_pending_to_be_updated':
    url=type=='RAISE'?'/master':'/primary-location-approval';
    break;
    case 'unit_type_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/unit-type-approval';
    break;
    case 'company_bank_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/company-bank-approval';
    break;
    case 'account_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/account-master-approval';
    break;
    case 'tds_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/tds-approval';
    break;
    case 'department_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/department-approval';
    break;
    case 'user_role_master_pending_to_be_updated':
      url=type=='RAISE'?'/settings':'/user-role-approval';
    break;
    case 'reason_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/reason-master-approval';
    break;
    case 'line_of_business_master_pending_to_be_updated':
      url=type=='RAISE'?'/master':'/lob-master-approval';
    break;
    case 'my_assigned_invoices':
      url=type=='RAISE'?'/my-mailed-invoice':'/my-mailed-invoice';
      break;
  default:url='';
}
return url;
}
getPMPageUrl(data,type)
{
let url:any='';

switch(data.id)
{
  case 'pending_project':
    url=type=='RAISE'?'/project-master':'/project-master-approval';
  break;
  case 'recurring_invoice':
    url=type=='RAISE'?'/auto-generated-inv':'/recurring-inv-for-approval';
  break;
  case 'pending_task':
    url=type=='RAISE'?'/task-master':'/task-master-approval';
  break;
  case 'pending_timesheet':
    url=type=='RAISE'?'/time-sheet-v2':'/time-sheet-approval';
  break;
  case 'pending_expense':
    url=type=='RAISE'?'/expense-sheet-v2':'/expense-sheet-v2-approval';
  break;
  case 'pending_amc_task_approval':
    url=type=='RAISE'?'/amc-master':'/task-approvals';
  break;
  default:url='';
}
return url;
}
menuList:any=[];
getMenuList() {
   if (!this.isDashboardActive()) {
     return;
   }
   if (this.menuList.length<=0) {
    let id: any = "";
    if (this._localStorageService.getUserRole() == "administrator") {
      id = "0"
    }
    else {
      id = this._localStorageService.getEmpRoleId() == undefined || this._localStorageService.getEmpRoleId() == null ? "0" : this._localStorageService.getEmpRoleId();
    }
    let req:any={id:id}
  this.dashboardApi("User_Roles/ajax_menu_items_by_user_role", req).
    subscribe(
      data => {
        if (data.status) {
          let temp: any = [];
            temp = data.response;
          if (temp) {
            for (let i of temp) {
              if (i.submenu) {
                for (let j of i.submenu) {
                  if (j.aurl == "/bug-master") {
                    j.menuitemname = this.company_setup.custom_name_bug_master ? this.company_setup.custom_name_bug_master : "Bug Master";
                  }
                  if (j.aurl == "/my-bug-master") {
                    j.menuitemname = "My " + this.company_setup.custom_name_bug_master;
                  }
//                   if (this._localStorageService.getUserRole() != "administrator") {
//                   if ((j.aurl == "\/dashboard" || j.menuitemname== "Compliance Dashboard")) {
//                     // j.menuitemname = "Compliance Dashboard"
//                   // window.location.href=window.location.origin+'/compliance/#/dashboard';
//                 //  this.webService.redirectURL('/compliance/#/dashboard');
//                   // this.webService.redirectURL('http://localhost:4200/compliance/#/dashboard');
        
//                 }
// else{
//                     this.webService.redirectURL('/dashboard');
//                   }}
                }
              }
            }
          }
          this.menuList = temp;
          this.GetCompanySetUpData();
        }else{
          this.toasterService.pop('error', "Error", data.message);
          this.isRunning = false;
          this.dashboardLoader = false;
          this.failDashboardCounterLoad();
        }
      },
      error => {
        this.toasterService.pop('error', "Error", "Something Went Wrong");
        this.isRunning = false;
        this.dashboardLoader = false;
        this.failDashboardCounterLoad();
      }
    );
   }
}

IS_VAILID_URL(url)
{
  // let url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

  let name:any=-'';
  let status:boolean=false;
  let array:any=[];
  array = this.menuList;
  if(array)
  {
    for(let i of array)
    {
      i.submenu=i.submenu?i.submenu:[]
      if(i.submenu)
      {
        let t:any=[];
        t=i.submenu.filter((v)=>{return v.aurl==url});
        if(t.length>0)
        {
          name=t[0].menuitemname?t[0].menuitemname:'';
          status=true;
        }
      }
    }
  }

  return status?status:false
}
isPoloarChart:boolean=false;
setChartType(type)
{
if(type=='polarArea')
{
  this.isPoloarChart=false;
  if(document.getElementById('activeChart')!=null)
  {
  // document.getElementById('activeChart').style.background=this.companyThemeBlockColor ? this.companyThemeBlockColor : "#035168";
  // document.getElementById('activeChart').style.color=this.CompanyThemetextColor ? this.CompanyThemetextColor : "#FFFFFF";
  }
}
else
{
  this.isPoloarChart=true;
}
this.pendingPOChartType=type;
}
getTimeSheetData(key)
{
  let list:any=JSON.parse(JSON.stringify(this.pendingProjectManagementTaskList));
  return list.some((v)=>{return v.key==key})?list.filter((v)=>{return v.key==key})[0]:{}
}
toggleCompanyData() {
  if (this.isRun) return; // Prevent the action while loading

  this.isDataVisible = !this.isDataVisible;  // Toggle the visibility

  if (this.isDataVisible) {
    // If we want to show the data, fetch it
    this.getViewData();
  } else {
    // If we want to hide the data, clear the companyGroupIds or handle it accordingly
    this.companyGroupIds = [];
    this.companyGroupList = [];
    this.filteredviewData  =[]
    this.isviewCompanyCardVisible =false;
  }
}
allCompanyTaskTitle:any='';
allCompanyTaskList:any= [];
allCompanyTaskCount:any = 0;
allCompanyTaskCountLastDays:any=0;
isAllCompanyCardVisible:boolean=false;
isviewCompanyCardVisible:boolean=false;

// getAllCompanyData():void {
//   if (this._localStorageService.getUserRole() == "vendor") {
//     return;
//   }
//   this.allCompanyTaskList=[];

//   this.allCompanyTaskCount = "";
//   let localCount1:any = 0;
//   let localDaysCount1:any=0;
//   let obj = {
//     "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
//     // "company_id": this._localStorageService.getEmpCompanyId(),
//     "company_id":"0",
//     "how_many_days_pending_in_dashboard":this.company_setup.how_many_days_pending_in_dashboard?this.company_setup.how_many_days_pending_in_dashboard:'5'
//   }
//   this.allCompanyTaskList=[];
//   this.isAllCompanyCardVisible=true;
//   this.isRunning=true;
//   this.dashboardApi("project/Timesheet/get_timesheet_chart_for_all_company", obj).
//     subscribe(
//       data => {
//         if (data.status) {
//           let temp:any=[];
//           data.response=data?data:{}
//           if(data.response)
//           {
//             for(let i in data.response)
//             {

//               let t:any=this.getTimeSheetData(i)
//               if(Object.keys(t).length>0)
//               {
//                 let toArray =  data.response[i].split("_");
//                 // console.log(toArray);
//                 toArray[0] = toArray[0] ? toArray[0] : 0;
//                 toArray[1] = toArray[1] ? toArray[1] : 0;
//                 t['count'] = toArray[1];
//                 t['total_count'] = toArray[0];

//                   temp.push({...t});
//                   // console.log(t)

//               }

//             }
//           }
//           this.allCompanyTaskList=[...temp]?[...temp]:[];
//           this.allCompanyTaskTitle=data.title?data.title:'All Companies Data';
//           console.log(this.allCompanyTaskList)
//           if(this.allCompanyTaskList){
//             for(let totalCount of this.allCompanyTaskList) {
//               // console.log(totalCount)
//               let title=totalCount.title;
//               if(title.indexOf(" For My Approval")!==-1)
//               {
//                 title=title.replace(" For My Approval", "");
//               }
//               if(title.indexOf(" for My Approval")!==-1)
//               {
//                 title=title.replace(" for My Approval", "");
//               }

//               totalCount.total_count = this.webService.convertNaN(totalCount.total_count) ? this.webService.convertNaN(totalCount.total_count) : 0;
//               totalCount.count = this.webService.convertNaN(totalCount.count) ? this.webService.convertNaN(totalCount.count) : 0;

//               if( totalCount.total_count !=""){
//                 if(this.isPendingCardVisibleForPM(totalCount.key)||this.isPendingCardVisible(totalCount.key)){
//                   localCount1 += parseFloat(totalCount.total_count);
//                 }
//               }
//               if( totalCount.count !=""){
//                 if(this.isPendingCardVisibleForPM(totalCount.key)||this.isPendingCardVisible(totalCount.key)){
//                   localDaysCount1 += parseFloat(totalCount.count);
//                 }
//               }
//             }
//           }
//           this.allCompanyTaskCount = localCount1 ? localCount1 : 0;
//           this.allCompanyTaskCountLastDays= localDaysCount1 ? localDaysCount1 : 0;
//          }
//          else
//          {
//           this.toasterService.pop('error', "Error", data.message);

//          }
//          this.isRunning=false;

//       },
//       error => {
//         this.toasterService.pop('error', "Error", "Something Went Wrong");
// this.isRunning=false;
//       }
//     );
// }
allCompanyData:any = [];
getAllCompanyData():void {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    return;
  }
  this.allCompanyTaskList=[];

  this.allCompanyTaskCount = "";
  let localCount1:any = 0;
  let localDaysCount1:any=0;
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "current_company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : "0",
    "company_id": "0",
    "how_many_days_pending_in_dashboard":this.company_setup.how_many_days_pending_in_dashboard?this.company_setup.how_many_days_pending_in_dashboard:'0',
    "company_ids": this.companyGroupIds ? this.companyGroupIds : []
  }
  this.allCompanyTaskList=[];
  this.isAllCompanyCardVisible=true;
  this.isRunning=true;
  this.dashboardApi("project/Timesheet/get_pie_chart_for_all_company", obj).
    subscribe(
      data => {
        if (data.status) {
          let temp:any=[];
          let tempArray = [];
          this.allCompanyData = data.response ? data.response : [];
          tempArray = data.response ? data.response : [];
          // this.allCompanyData = this.filterchartAllCompanyData(this.allCompanyData);
          if(tempArray){
            for(let d of tempArray){
              d.total_count = 0;
              d.count = 0;
              if(d.items){
                for(let x of d.items){
                  x.total_count = x.total_count ? this.webService.convertNaN(x.total_count) : 0;
                  x.count = this.webService.convertNaN(x.count) ? this.webService.convertNaN(x.count) : 0;
                  if(x.total_count != ""){
                    if(this.isPendingCardVisibleForPM(x.key)||this.isPendingCardVisible(x.key)){
                      d.total_count = +d.total_count + +x.total_count
                    }
                  }
                  if(x.count != ""){
                    if(this.isPendingCardVisibleForPM(x.key)||this.isPendingCardVisible(x.key)){
                      d.count = +d.count + +x.count
                    }
                  }
                }
              }
              localCount1 = +localCount1 + +d.total_count
              localDaysCount1= +localDaysCount1 + d.count

              // d.total_count = d.items ? d.items.reduce((pre,next)=>{return +pre.total_count + +next.total_count}): 0
              // d.count = d.items ? d.items.reduce((pre,next)=>{return +pre.count + +next.count}): 0
            }
          }
          this.allCompanyTaskCount = localCount1 ? localCount1 : 0;
          this.allCompanyTaskCountLastDays= localDaysCount1 ? localDaysCount1 : 0;
          this.allCompanyData = this.filterchartAllCompanyData(tempArray);
         }
         else
         {
          this.toasterService.pop('error', "Error", data.message);

         }
         this.isRunning=false;

      },
      error => {
        this.toasterService.pop('error', "Error", "Something Went Wrong");
        this.isRunning=false;
      },
    );
}


filterchartAllCompanyData(data: any) {
  let list: any = [];
  for (let x of data) {
    let temp = { title_with_count:'',title: "", label: [], data: [], total: 0, pieChartType: 'pie', lineChartLegend: true , key:x.key,temp_company_title:"",tempItems:[],backgroundColor:[],"company_title":[],tempLabel:[]};
    temp.title = x.title;
    temp.key = x.key;
    temp.pieChartType = temp.pieChartType ? temp.pieChartType : 'pie';
    temp.total = 0;
    temp.tempItems = x.items ? x.items.map((d)=>({count_title : d.count_title ? d.count_title.replace(/\s+/g, '').toLowerCase() : "","company_id": d.company_id ? d.company_id : ""})) : [];
    for (let y of x.items) {
      temp.backgroundColor.push(y.color)
      temp.company_title.push(y.company_title);
      // y.temp_company_title = `${y.count}-${y.total_count} ${y.company_title}`
      temp.total = temp.total + parseFloat(y.count);
      if (parseFloat(y.count) > 0) {
        temp.label.push(y.count_title);
        temp.tempLabel.push({"count_title" : y.count_title,"company_title": y.company_title})
      }
      else {
        //temp.label.push(y.count_title);
        temp.label.push(y.count_title);
        temp.tempLabel.push({"count_title" : y.count_title,"company_title": y.company_title})

      }
      temp.data.push(y.count);
    }
    temp.total = this.webService.convertNaN(temp.total) ? this.webService.convertNaN(temp.total) : '0';
    temp.title_with_count= temp.title +"("+temp.total+")"
    list.push(temp);
  }
  return list;
}

openPendingInvoicesPopupIfInvoiceApproval(titleWithCount: any): void {
  if(this.company_setup.enable_all_company_data_approval != '1'){
    return
  }
  console.log('openPendingInvoicesPopupIfInvoiceApproval here',titleWithCount)
  const title = (titleWithCount || '').toString();
  if (title.toLowerCase().indexOf('invoice for my approval') !== -1) {
    if (!this.companyGroupIds || this.companyGroupIds.length <= 0) {
      this.getMultiCompanyIds();
    }
    this.showPendingInvoicesPopup = true;
  }
}

closePendingInvoicesPopup(): void {
  this.showPendingInvoicesPopup = false;
}
companyGroupIds:any = [];
companyGroupList:any = [];
getMultiCompanyIds() {
  if (!this.isDashboardActive()) {
    return;
  }
  let obj = {
    "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : "0",
  }
  this.dashboardApi("/Companies/get_group_company_ids", obj).subscribe((data)=>{
    if(data.status){
      let TmpIds = data.response ? data.response : [];
      this.companyGroupList = TmpIds ? TmpIds : [];
      this.companyGroupIds = TmpIds ? TmpIds.map(d => d.company_id): [];
      this.getAllCompanyData();
    }
  })
}
financialYearFilterOpen: boolean = false;
financialYearLoading: boolean = false;
financialYearList: any = [];
filteredFinancialYearList: any = [];
financialYearSearchTerm: any = '';
selectedFinancialYears: any = [];
private financialYearListLoaded: boolean = false;

toggleFinancialYearFilter() {
  this.financialYearFilterOpen = !this.financialYearFilterOpen;
  if (this.financialYearFilterOpen) {
    this.onFinancialYearSearch('');
    if (!this.financialYearListLoaded && !this.financialYearLoading) {
      this.getFinancialYears();
    }
  }
}

onFinancialYearSearch(term: any) {
  this.financialYearSearchTerm = term ? term : '';
  let search = String(this.financialYearSearchTerm).toLowerCase().trim();
  this.filteredFinancialYearList = search
    ? this.financialYearList.filter((fy: any) => fy.label.toLowerCase().indexOf(search) != -1)
    : this.financialYearList;
}

getFinancialYears(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  this.financialYearLoading = true;
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  }
  this.dashboardApi("User_Roles/ajax_landing_dashboard_financial_years", obj).subscribe(
    (data) => {
      this.financialYearLoading = false;
      if (data && data.status) {
        let defaults = (data.default_selected || []).map((d: any) => String(d));
        // Default (current) years first so they are visible without scrolling.
        this.financialYearList = (data.response || [])
          .map((fy: any) => ({ value: String(fy.value), label: String(fy.label) }))
          .sort((a: any, b: any) => (defaults.indexOf(a.value) < 0 ? 1 : 0) - (defaults.indexOf(b.value) < 0 ? 1 : 0));
        this.selectedFinancialYears = defaults;
        this.onFinancialYearSearch(this.financialYearSearchTerm);
        this.financialYearListLoaded = true;
      }
      if (onComplete) {
        onComplete();
      }
    },
    () => {
      this.financialYearLoading = false;
      if (onComplete) {
        onComplete();
      }
    }
  );
}

isFinancialYearSelected(value: any) {
  return this.selectedFinancialYears.indexOf(value) != -1;
}

toggleFinancialYear(value: any) {
  let index = this.selectedFinancialYears.indexOf(value);
  if (index == -1) {
    this.selectedFinancialYears.push(value);
  } else {
    this.selectedFinancialYears.splice(index, 1);
  }
}

selectAllFinancialYears() {
  this.selectedFinancialYears = (this.filteredFinancialYearList || []).map((fy: any) => fy.value);
}

isAllFinancialYearsSelected() {
  let list = this.filteredFinancialYearList || [];
  if (list.length == 0) {
    return false;
  }
  return list.every((fy: any) => this.selectedFinancialYears.indexOf(fy.value) != -1);
}

toggleAllFinancialYears() {
  if (this.isAllFinancialYearsSelected()) {
    let values = (this.filteredFinancialYearList || []).map((fy: any) => fy.value);
    this.selectedFinancialYears = this.selectedFinancialYears.filter((v: any) => values.indexOf(v) == -1);
  } else {
    this.selectAllFinancialYears();
  }
}

clearFinancialYearFilter() {
  if (this.selectedFinancialYears.length == 0) {
    this.financialYearFilterOpen = false;
    return;
  }
  this.selectedFinancialYears = [];
  this.applyFinancialYearFilter();
}

applyFinancialYearFilter() {
  this.financialYearFilterOpen = false;
  this.getPendingPMTask(() => {
    this.getDynamicData(() => {
      this.getModuleWiseCompanyAnalytics(() => {
        this.getPendingTaskForRaiser(() => {
          this.getPendingPMTaskForRaiser(() => {
            this.getPendingTask(() => {
              this.getCardData(() => {
                this.getTallyIntegrationData();
              });
            });
          });
        });
      });
    });
  });
}

cardDataList: any = [];
getCardData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.continueDashboardCounterChain(onComplete);
    return;
  }
  this.cardDataList = [];
  let localCount: any = 0;
  let localDaysCount: any = 0;
  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
    "how_many_days_pending_in_dashboard": this.company_setup.how_many_days_pending_in_dashboard ? this.company_setup.how_many_days_pending_in_dashboard : '5',
    "financial_years": this.selectedFinancialYears,
  }
  // if(1==1) {
  //   return false;
  // }
  this.cardDataList = [];

  const proceedAfterCardData = () => {
    if (this.company_setup.hide_dashboard_counter != '1') {
      this.proceedDashboardCounterNext(onComplete, () => this.getInvoiceAgeingData());
    } else {
      this.continueDashboardCounterChain(onComplete);
    }
  };

  this.runDashboardCounterHttp(
    "/User_Roles/showCardDetails",
    obj,
    onComplete ? () => proceedAfterCardData() : undefined,
    (data) => {
        if (data.status) {
          let temp: any = [];
          data.response = typeof data.response == 'object' ? ([data.response ? data.response : {}]) : data.response
          if (data.response) {
            for (let i of data.response) {
              // console.log(i)
              this.vendorranking=i.vendor_ranking
              this.topProducts=i.top_products

              console.log( this.topProducts ,' this.topProducts')

              if (i.items.length > 0) {
                for (let j of i.items) {
                  j.key = j.key == 'raise_pending_recurring_invoices' ? 'recurring_invoice' : j.key
                  temp.push(j);
                }
              }
              if (this.webService.IS_VAILID_URL('/card-menu')) {
                this.getRanking(i.vendor_ranking ? i.vendor_ranking : [])
              }
              if (this.webService.IS_VAILID_URL('/card-menu')) {
                this.getTopProducts(i.top_products ? i.top_products : [])
              }
            }
          }
          this.cardDataList = temp ? temp : [];
          if (this.cardDataList) {
            for (let totalCount of this.cardDataList) {
              totalCount.isVisible = true
              if ((totalCount.key == 'product_approved')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }
              if ((totalCount.key == 'pending_po')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }
              if ((totalCount.key == 'total_po_value')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }
              if ((totalCount.key == 'vendors_profile_update')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }
              if ((totalCount.key == 'vendors_active')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }

              if ((totalCount.key == 'vendors_logged_in')) {
                if (!this.webService.IS_VAILID_URL('/card-menu')) {
                  totalCount.isVisible = false
                }
              }
              // console.log(totalCount)
              let title = totalCount.title;
              if (title.indexOf(" For My Approval") !== -1) {
                title = title.replace(" For My Approval", "");;
              }
              if (title.indexOf(" for My Approval") !== -1) {
                title = title.replace(" for My Approval", "");;
              }

              totalCount.total_count = this.webService.convertNaN(totalCount.total_count) ? parseInt(this.webService.convertNaN(totalCount.total_count)) : 0;
              totalCount.count = this.webService.convertNaN(totalCount.count) ? parseInt(this.webService.convertNaN(totalCount.count)) : 0;
            }
          }
          this.cardDataList = this.cardDataList.filter((v) => { return v.isVisible })
        }
      },
      () => {
      }
    );
}
colors?: any = ['#5fb2c6', '#53a759', '#e88b44', '#e23f3d']
chartType: any = {

  'pie': {
    type: 'pie', colors: [], options: {
      legend: {
        position: 'right',
        orient: 'vertical',
        display: true
      },
      plugins: {
        datalabels: {
          display: false,
        }
      }
  }
  }
}

getTopProducts(responseData: any) {
  if (responseData) {
    let colors=[]
    let data=[]
    let topProduct={data:[],labels:[],lineChartColors:[],fullList:[]}
    for (let k of responseData) {
      let p_name = k.product_name + "(" + k.productcode + ")"
      let color=k.color ? k.color : '#035168'
      var str = p_name;
      if(str.length > 4) str = str.substring(0,4)+"...";
      topProduct.labels.push(str);
     data.push(parseFloat(this.webService.convertNaN((k.amount))))
      colors.push(color)
      topProduct.fullList.push({lable:p_name,amount:k.amount_in_k})
    }
    topProduct.data.push(
      {
        type: 'bar',
        label: '',
        data: data,
        fill: false,
        borderColor: '',
        pointStyle: 'spline',
        pointBorderWidth: 7,
        display: true,
        backgroundColor: '',
      }
    )
    topProduct.lineChartColors = [{ backgroundColor: colors }];
    let icon=this.webService.getCurrencyIconString(this.company_setup.currency_icon)
    this.topProduct= {
      labels: topProduct.labels?topProduct.labels:[],
      data: topProduct.data?topProduct.data:[],
      barChartType: 'bar',
      colors: ['red', 'bule', 'red', 'bule', 'red', 'bule',],
      barlineChartLegend: false,
      title: '',
      ChartLegend: true,
      lineChartColors: topProduct.lineChartColors,
      barChartPlugins: [],
      options: {
        tooltips: {
          displayColors:false,
          callbacks: {
            title: function(tooltipItem, data) {
              return '';
            },
            label: function(tooltipItem, data) {
                  //your logic...
                    let d:any=topProduct.fullList[tooltipItem.index||0]?topProduct.fullList[tooltipItem.index||0]:{}
                    tooltipItem.label=d.lable?d.lable:''
                    tooltipItem.xLabel=d.lable?d.lable:''
                   var label= d.lable+"\n"+ icon+" "+d.amount
                   return label;

                },
              }
        },

        layout: {
          padding: {
              left: 0,
              right: 0,
              top: 30,
              bottom: 0
          }
      },
        maintainAspectRatio: false,
scaleShowVerticalLines: false,
scaleShowValues: true,
scaleValuePaddingX: 10,
scaleValuePaddingY: 10,
        responsive: true,
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter:  (value, context)=> {
              return topProduct.fullList[context.dataIndex] ? topProduct.fullList[context.dataIndex].amount : value;
             }
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            },
            ticks: {
            // callback: function (value, index, values) {
            //   // console.log(value)
            //   // console.log(index)
            //   // console.log(values)
            //   return value + icon;
            // }
          }
          }],
          yAxes: [{
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            }
            ,
            ticks: {
              // padding: 25,
              beginAtZero: true,
              maxTicksLimit: 5,
              // Create scientific notation labels
              callback: function (value, index, values) {
                // console.log(value)
                // console.log(index)
                // console.log(values)
                // console.log(topProduct.fullList)
              function formatToK(number) {
                  if (number >= 1000) {
                    return parseInt((number / 1000).toFixed(0)).toLocaleString() + 'K';
                  } else {
                    return number
                  }
                }
                return formatToK(value) + icon;
              }
            }
          }]
        }
      }
    }
  }
}
responseData1:any=[]
getRanking(responseData: any) {

  this.colors = []
  this.responseData1=responseData?responseData:[]
  let d: any = { items: [] }
  if (this.responseData1) {
    for (let i of this.responseData1) {
      i.title = i.category ? i.category : ''
      i.title = i.title + " (" + (i.count ? i.count : 0) + ")"
      d['category'] = i.category ? i.category : ''
      d['title'] = i.title ? i.title : ''
      d['color'] = i.color ? i.color : ''
      d['count'] = i.count ? i.count : 0
      this.colors.push(i.color)
      d.items.push(i)
    }
    this.chartType.pie.colors = [{ backgroundColor: this.colors }];
  }
  let list = this.filterRankingData([d]);
  if (list.length > 0) {
    console.log(list)
    this.filteredRankingData = [list[0]]
  }


}

filterRankingData(data: any) {
  let list: any = [];
  for (let x of data) {
    let temp = { title: "", label: [], data: [] };
    temp.title = x.title;
    for (let y of x.items) {
      temp.label.push(y.title);
      temp.data.push(y.count);
    }
    list.push(temp);
  }
  return list;
}
public chartClicked(e: any): void {
  if (e.active.length > 0) {
    const chart = e.active[0]._chart;
    const activePoints = chart.getElementAtEvent(e.event);
    if (activePoints.length > 0) {
      // get the internal index of slice in pie chart
      const clickedElementIndex = activePoints[0]._index;
      const label = chart.data.labels[clickedElementIndex];
      // get value by index
      const value = chart.data.datasets[0].data[clickedElementIndex];
      // this.navigateUrl(label,value);
      let key=label
      let category=label?label:''
      console.log(label)
      // console.log(this.responseData)
      let t=this.responseData1.filter((v)=>{return v.title==(key?key:'')}).length>0?this.responseData1.filter((v)=>{return v.title==(key?key:'')})[0]:{}
      if(Object.keys(t).length>0)
      {
      category=t.range?t.range:''
        console.log(t)
        localStorage.setItem('vendor_ranking_category',category);
        let redirectUrl = '/#';
        let origin = window.location.origin;
        redirectUrl = origin + '/master' + redirectUrl + '/vendors';
        // console.log(redirectUrl)
        window.location.href=redirectUrl
      }
    }
  }
}

navigateData(key)
{
  if(key=='product_approved')
  {
localStorage.setItem("dashboardAction", this.webService.set('approved_product','dashboardAction'));
let redirectUrl = '/#';
let origin = window.location.origin;
redirectUrl = origin + '/master' + redirectUrl + '/products';
// console.log(redirectUrl)
window.location.href=redirectUrl
  }
  if(key=='pending_po')
  {
   // console.log('approval_pending_po')
//localStorage.setItem("dashboardAction", this.webService.set('approval_pending_po','dashboardAction'));
//this.webService.redirectURL('po-approval')
  }
  if(key=='total_po_value')
  {
//localStorage.setItem("dashboardAction", this.webService.set('all_po','dashboardAction'));
//this.webService.redirectURL('poapproval-summary')
  }
  if(key=='vendors_profile_update')
  {
localStorage.setItem("dashboardAction", this.webService.set('vendor_profile_updated_id','dashboardActionVendorProfile'));
let redirectUrl = '/#';
let origin = window.location.origin;
redirectUrl = origin + '/master' + redirectUrl + '/vendors';
// console.log(redirectUrl)
window.location.href=redirectUrl
  }
  if(key=='vendors_active')
  {
    localStorage.setItem("dashboardAction", this.webService.set('is_vendor_portal_active','dashboardAction'));
    let redirectUrl = '/#';
    let origin = window.location.origin;
    redirectUrl = origin + '/master' + redirectUrl + '/vendors';
    // console.log(redirectUrl)
    window.location.href=redirectUrl
  }

  if(key=='vendors_logged_in')
  {
    localStorage.setItem("dashboardAction", this.webService.set('logged_vendor'));
    let redirectUrl = '/#';
    let origin = window.location.origin;
    redirectUrl = origin + '/report' + redirectUrl + '/vendor-activity';
    // console.log(redirectUrl)
    window.location.href=redirectUrl
  }
}
public chartHovered(e: any): void {
  console.log(e)
}
chartHoveredData(tooltipItem,data)
{
  return tooltipItem.index||0
}
acknowledgeSupportPopup() {
  if (this.supportPopupAcknowledging) {
    return;
  }

  const today = new Date();
  const popShowDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  const payload = {
    "project": 'operation',
    "activity_type": 'login',
    "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : 0,
    "user_id": this._localStorageService.getUserId(),
    "user_role_id": this.eesdesService.get('emp_role', localStorage.getItem('emp_role')) ? this.eesdesService.get('emp_role', localStorage.getItem('emp_role')) : '0',
    "pop_show_date": popShowDate
  };

  this.supportPopupAcknowledging = true;
  this.webService.commonPostMethod("User_activity/save_user_activity", payload)
    .pipe(finalize(() => this.supportPopupAcknowledging = false))
    .subscribe(
      data => {
        if (data.status) {
          localStorage.setItem('pop_show_date', popShowDate);
          this.closeSupportPopup();
        } else {
          this.toasterService.pop("error", "Error", data.message ? data.message : "Unable to acknowledge the support update");
        }
      },
      error => {
        this.toasterService.pop("error", "Error", "Something Went Wrong");
      }
    );
}
closeSupportPopup() {
  this.showSupportPopupFlag = false;
  this.popupService.open(false);
}
ngOnDestroy() {
  this.dashboardDestroyed = true;
  this.dashboardLoader = false;
  this.isRunning = false;
  this.failDashboardCounterLoad();
  this.destroy$.next();
  this.destroy$.complete();
}

getTallyIntegrationData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  // Hit this API only when ajax_menu_items_by_user_role contains aurl: "/card-menu"
  if (!this.IS_VAILID_URL('/card-menu')) {
    this.tallyIntegrationData = [];
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
    how_many_days_pending_in_dashboard: (this.company_setup && this.company_setup.how_many_days_pending_in_dashboard)
      ? this.company_setup.how_many_days_pending_in_dashboard
      : '5',
    financial_years: this.selectedFinancialYears,
  };

  this.tallyIntegrationData = [];
  this.runDashboardCounterHttp(
    "/User_Roles/ajax_dashboard_tally_cards_counter",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (!data || !data.status) {
        this.tallyIntegrationData = [];
        return;
      }

      const responseArr = typeof data.response === 'object'
        ? ([data.response ? data.response : {}])
        : (data.response || []);

      const temp: any[] = [];
      for (const i of responseArr) {
        if (i && i.items && i.items.length > 0) {
          for (const j of i.items) {
            temp.push(j);
          }
        }
      }

      this.tallyIntegrationData = temp;
    },
    () => {
      this.tallyIntegrationData = [];
    }
  );
}

myAmcTaskCardsTitle: any = 'My AMC Task Cards';
myAmcTaskCards: any[] = [];
myAmcTaskCardsTotal: any = 0;
getMyAmcTaskCards(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.myAmcTaskCards = [];
    this.myAmcTaskCardsTotal = 0;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  // Permission guard: route should exist in menu
  if (!this.IS_VAILID_URL('/my-amc-task')) {
    this.myAmcTaskCards = [];
    this.myAmcTaskCardsTotal = 0;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
  };

  this.myAmcTaskCards = [];
  this.myAmcTaskCardsTotal = 0;

  this.runDashboardCounterHttp(
    "Amc_dashboard/ajax_my_cards",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (!data || !data.status) {
        this.myAmcTaskCards = [];
        this.myAmcTaskCardsTotal = 0;
        return;
      }

      const getNum = (v: any) => {
        const n = this.webService.convertNaN(v);
        return n ? parseInt(n, 10) : 0;
      };

      // API response: { status, message, data: { cards: { my_today:{total}, my_overdue:{total}, my_this_week:{total}, my_next_week:{total} } } }
      const cards: any = data.data && data.data.cards ? data.data.cards : null;
      if (!cards) {
        this.myAmcTaskCards = [];
        this.myAmcTaskCardsTotal = 0;
        return;
      }

      const todayTotal = getNum(cards.my_today && cards.my_today.total != null ? cards.my_today.total : 0);
      const overdueTotal = getNum(cards.my_overdue && cards.my_overdue.total != null ? cards.my_overdue.total : 0);
      const thisWeekTotal = getNum(cards.my_this_week && cards.my_this_week.total != null ? cards.my_this_week.total : 0);
      const nextWeekTotal = getNum(cards.my_next_week && cards.my_next_week.total != null ? cards.my_next_week.total : 0);

      this.myAmcTaskCardsTitle = data.message ? data.message : 'My AMC Task Cards';
      this.myAmcTaskCards = [];
      this.myAmcTaskCardsTotal = 0;
      if (this.isPendingCardVisible('my_todays_tasks')) {
        this.myAmcTaskCards.push({ key: 'my_amc_today_tasks', title: "My Today's Tasks", count: todayTotal, color: "#f1894f" });
        this.myAmcTaskCardsTotal += todayTotal;
      }
      if (this.isPendingCardVisible('my_overdue_tasks')) {
        this.myAmcTaskCards.push({ key: 'my_amc_overdue_tasks', title: "My Overdue Tasks", count: overdueTotal, color: "#ec343c" });
        this.myAmcTaskCardsTotal += overdueTotal;
      }
      if (this.isPendingCardVisible('my_this_week_tasks')) {
        this.myAmcTaskCards.push({ key: 'my_amc_this_week_tasks', title: "My This Week Tasks", count: thisWeekTotal, color: "#4caf62" });
        this.myAmcTaskCardsTotal += thisWeekTotal;
      }
      if (this.isPendingCardVisible('my_next_week_tasks')) {
        this.myAmcTaskCards.push({ key: 'my_amc_next_week_tasks', title: "My Next Week Tasks", count: nextWeekTotal, color: "#4cb2c4" });
        this.myAmcTaskCardsTotal += nextWeekTotal;
      }
    },
    () => {
      this.myAmcTaskCards = [];
      this.myAmcTaskCardsTotal = 0;
    }
  );
}

vendorDetailsCard: any = null;
riskyVendorIds: any[] = [];

getVendorDetailsCard() {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.vendorDetailsCard = null;
    this.riskyVendorIds = [];
    return;
  }
  if (this.company_setup.is_risky_vendors_visible_in_dashboard != '1') {
    this.vendorDetailsCard = null;
    this.riskyVendorIds = [];
    return;
  }
  if (!this.IS_VAILID_URL('/card-menu')) {
    this.vendorDetailsCard = null;
    this.riskyVendorIds = [];
    return;
  }

  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
  };

  this.dashboardApi("vendor_rating/ajax_dashboard", obj).subscribe(
    (data) => {
      if (!data || !data.status || !data.data) {
        this.vendorDetailsCard = null;
        this.riskyVendorIds = [];
        return;
      }

      const getNum = (v: any) => {
        const n = this.webService.convertNaN(v);
        const parsed = parseInt(n, 10);
        return isNaN(parsed) ? 0 : parsed;
      };

      const responseData = data.data;
      const riskyVendorsCard = responseData.risky_vendors || {};
      this.riskyVendorIds = Array.isArray(responseData.data) ? responseData.data : [];

      const count = getNum(
        riskyVendorsCard.count != null ? riskyVendorsCard.count : this.riskyVendorIds.length
      );

      if (count <= 0) {
        this.vendorDetailsCard = null;
        this.riskyVendorIds = [];
        return;
      }

      this.vendorDetailsCard = {
        key: riskyVendorsCard.key || 'risky_vendors',
        title: riskyVendorsCard.title || 'Risky Vendor',
        count: count,
        color: riskyVendorsCard.color || '#FF6B6B',
        icon: riskyVendorsCard.icon || 'fa fa-thumbs-up'
      };
    },
    () => {
      this.vendorDetailsCard = null;
      this.riskyVendorIds = [];
    }
  );
}

navigateToVendorDetails() {
  const cardKey = this.vendorDetailsCard && this.vendorDetailsCard.key ? this.vendorDetailsCard.key : 'risky_vendors';
  localStorage.setItem("dashboardAction", this.webService.set(cardKey, 'dashboardAction'));
  localStorage.setItem('dashboard_risky_vendor_ids', JSON.stringify(this.riskyVendorIds || []));
  window.location.href = window.location.origin + '/master/#/vendors';
}

allAmcTaskCardsTitle: any = 'All AMC Task Cards';
allAmcTaskCards: any[] = [];
allAmcTaskCardsTotal: any = 0;
getAllAmcTaskCards(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.allAmcTaskCards = [];
    this.allAmcTaskCardsTotal = 0;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  // Permission guard: route should exist in menu
  if (!this.IS_VAILID_URL('/all-amc-tasks')) {
    this.allAmcTaskCards = [];
    this.allAmcTaskCardsTotal = 0;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
  };

  this.allAmcTaskCards = [];
  this.allAmcTaskCardsTotal = 0;

  this.runDashboardCounterHttp(
    "Amc_dashboard/ajax_all_cards",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (!data || !data.status) {
        this.allAmcTaskCards = [];
        this.allAmcTaskCardsTotal = 0;
        return;
      }

      const getNum = (v: any) => {
        const n = this.webService.convertNaN(v);
        return n ? parseInt(n, 10) : 0;
      };

      const cards: any = data.data && data.data.cards ? data.data.cards : null;
      if (!cards) {
        this.allAmcTaskCards = [];
        this.allAmcTaskCardsTotal = 0;
        return;
      }

      const todayTotal = getNum(cards.all_today && cards.all_today.total != null ? cards.all_today.total : 0);
      const overdueTotal = getNum(cards.all_overdue && cards.all_overdue.total != null ? cards.all_overdue.total : 0);
      const thisWeekTotal = getNum(cards.all_this_week && cards.all_this_week.total != null ? cards.all_this_week.total : 0);
      const nextWeekTotal = getNum(cards.all_next_week && cards.all_next_week.total != null ? cards.all_next_week.total : 0);

      this.allAmcTaskCardsTitle = data.message ? data.message : 'All AMC Task Cards';
      this.allAmcTaskCards = [];
      this.allAmcTaskCardsTotal = 0;
      if (this.isPendingCardVisible('all_todays_tasks')) {
        this.allAmcTaskCards.push({ key: 'all_amc_today_tasks', title: "All Today's Tasks", count: todayTotal, color: "#f1894f" });
        this.allAmcTaskCardsTotal += todayTotal;
      }
      if (this.isPendingCardVisible('all_overdue_tasks')) {
        this.allAmcTaskCards.push({ key: 'all_amc_overdue_tasks', title: "All Overdue Tasks", count: overdueTotal, color: "#ec343c" });
        this.allAmcTaskCardsTotal += overdueTotal;
      }
      if (this.isPendingCardVisible('all_this_week_tasks')) {
        this.allAmcTaskCards.push({ key: 'all_amc_this_week_tasks', title: "All This Week Tasks", count: thisWeekTotal, color: "#4caf62" });
        this.allAmcTaskCardsTotal += thisWeekTotal;
      }
      if (this.isPendingCardVisible('all_next_week_tasks')) {
        this.allAmcTaskCards.push({ key: 'all_amc_next_week_tasks', title: "All Next Week Tasks", count: nextWeekTotal, color: "#4cb2c4" });
        this.allAmcTaskCardsTotal += nextWeekTotal;
      }
    },
    () => {
      this.allAmcTaskCards = [];
      this.allAmcTaskCardsTotal = 0;
    }
  );
}

amcOverdueAgeingLoader: boolean = false;
amcOverdueAgeingChart: any = null; // scope: my
amcOverdueAgeingAllLoader: boolean = false;
amcOverdueAgeingAllChart: any = null; // scope: all
// Keep employee filter only in memory (default empty).
amcOverdueAgeingAllEmployeeId: string = '';
amcOverdueAgeingAllEmployeeName: string = '';
amcAgeingMyLobId: string = '';
amcAgeingMyLobLabel: string = '';
amcAgeingMyLocId: string = '';
amcAgeingMyLocLabel: string = '';
amcAgeingMyDepartmentId: string = '';
amcAgeingMyDepartmentLabel: string = '';
amcAgeingAllLobId: string = '';
amcAgeingAllLobLabel: string = '';
amcAgeingAllLocId: string = '';
amcAgeingAllLocLabel: string = '';
amcAgeingAllDepartmentId: string = '';
amcAgeingAllDepartmentLabel: string = '';
amcAgeingMyLobSearchTerm: string = '';
amcAgeingAllLobSearchTerm: string = '';
amcAgeingMyDepartmentSearchTerm: string = '';
amcAgeingAllDepartmentSearchTerm: string = '';
amcAgeingMyLocSearchTerm: string = '';
amcAgeingAllLocSearchTerm: string = '';
filteredAmcAgeingMyLobList: Array<{ id: any; label: string }> = [];
filteredAmcAgeingAllLobList: Array<{ id: any; label: string }> = [];
filteredAmcAgeingMyDepartmentList: Array<{ id: any; label: string }> = [];
filteredAmcAgeingAllDepartmentList: Array<{ id: any; label: string }> = [];
filteredAmcAgeingMyLocList: Array<{ id: any; label: string }> = [];
filteredAmcAgeingAllLocList: Array<{ id: any; label: string }> = [];
isAmcAgeingMyLobDropdownOpen: boolean = false;
isAmcAgeingAllLobDropdownOpen: boolean = false;
isAmcAgeingMyDepartmentDropdownOpen: boolean = false;
isAmcAgeingAllDepartmentDropdownOpen: boolean = false;
isAmcAgeingMyLocDropdownOpen: boolean = false;
isAmcAgeingAllLocDropdownOpen: boolean = false;
isAmcAgeingEmployeeDropdownOpen: boolean = false;
private amcAgeingMyLocSearchDebounceRef: any = null;
private amcAgeingAllLocSearchDebounceRef: any = null;

formatAmcOverdueAgeingChart(apiResponse: any, scope: 'my' | 'all') {
  const bucketColors: { [bucketName: string]: string } = {
    '0_3': '#59A14F',
    '4_7': '#4E79A7',
    '8_15': '#F28E2B',
    'gt_15': '#E15759',
    'gt_30': '#A05195',
  };
  const d = apiResponse && apiResponse.data ? apiResponse.data : null;
  const buckets = d && d.buckets ? d.buckets : null;
  // Show exactly the name sent by API (data.title, chart_title, or other common keys); fallback to message / default
  let titleBase = '';
  if (d) {
    const rawName = d.title || d.chart_title || d.chart_name || d.name;
    if (rawName && String(rawName).trim()) {
      titleBase = String(rawName).trim();
    }
  }
  if (!titleBase && apiResponse && apiResponse.message) {
    titleBase = String(apiResponse.message);
  }
  if (!titleBase) {
    titleBase = scope === 'all' ? 'All AMC overdue ageing' : 'AMC overdue ageing';
  }

  const getNum = (v: any) => {
    const n = this.webService.convertNaN(v);
    return n ? parseInt(n, 10) : 0;
  };

  if (!buckets) {
    return null;
  }

  const list = [
    { key: '0_3', label: '0–3 days', count: getNum(buckets['0_3'] && buckets['0_3'].total != null ? buckets['0_3'].total : 0) },
    { key: '4_7', label: '4–7 days', count: getNum(buckets['4_7'] && buckets['4_7'].total != null ? buckets['4_7'].total : 0) },
    { key: '8_15', label: '8–15 days', count: getNum(buckets['8_15'] && buckets['8_15'].total != null ? buckets['8_15'].total : 0) },
    { key: 'gt_15', label: 'More than 15 days', count: getNum(buckets['gt_15'] && buckets['gt_15'].total != null ? buckets['gt_15'].total : 0) },
    { key: 'gt_30', label: 'More than 30 days', count: getNum(buckets['gt_30'] && buckets['gt_30'].total != null ? buckets['gt_30'].total : 0) },
  ];

  let total = 0;
  const labels: any[] = [];
  const data: any[] = [];
  const colors: any[] = [];
  const items: any[] = [];

  for (const x of list) {
    total += x.count;
    const labelText = x.label + ' (' + x.count + ')';
    labels.push(labelText);
    data.push(x.count);
    colors.push(bucketColors[x.key] ? bucketColors[x.key] : '#4E79A7');
    items.push({ bucket: x.key, label: x.label, count: x.count, labelText: labelText });
  }

  // title = API name only; template shows total as (n) next to it
  return {
    title: titleBase,
    label: labels,
    data: data,
    colors: colors,
    total: total,
    pieChartType: 'pie',
    lineChartLegend: true,
    key: scope === 'all' ? 'amc_overdue_ageing_all' : 'amc_overdue_ageing',
    items: items
  };
}

getAmcOverdueAgeingChart(scope: 'my' | 'all', onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    if (scope === 'all') {
      this.amcOverdueAgeingAllChart = null;
    } else {
      this.amcOverdueAgeingChart = null;
    }
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  if (scope === 'all') {
    this.amcOverdueAgeingAllLoader = true;
  } else {
    this.amcOverdueAgeingLoader = true;
  }
  this.loadAmcManagementFilterOptions();
  let employee_id: any = '';
  if (scope === 'all') {
    employee_id = this.amcOverdueAgeingAllEmployeeId ? this.amcOverdueAgeingAllEmployeeId : '';
  }
  const filters = this.amcAgeingGetScopeFilters(scope);
  const obj: any = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
    scope: scope,
    employee_id: employee_id
  };
  if (filters.lobId) {
    obj.lob = filters.lobId;
  }
  if (filters.locId) {
    obj.lob_location = filters.locId;
  }
  if (filters.departmentId) {
    obj.department = filters.departmentId;
  }

  this.runDashboardCounterHttp(
    "Amc_dashboard/ajax_ageing_chart",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (scope === 'all') {
        this.amcOverdueAgeingAllLoader = false;
        if (data && data.status) {
          this.amcOverdueAgeingAllChart = this.formatAmcOverdueAgeingChart(data, 'all');
          if (this.amcOverdueAgeingAllChart) {
            this.amcOverdueAgeingAllChart.employee_id = this.amcOverdueAgeingAllEmployeeId;
            this.amcOverdueAgeingAllChart.employee_name = this.amcOverdueAgeingAllEmployeeName;
            this.amcAgeingAttachFilterMeta(this.amcOverdueAgeingAllChart, 'all');
          }
        } else {
          this.amcOverdueAgeingAllChart = null;
        }
      } else {
        this.amcOverdueAgeingLoader = false;
        if (data && data.status) {
          this.amcOverdueAgeingChart = this.formatAmcOverdueAgeingChart(data, 'my');
          if (this.amcOverdueAgeingChart) {
            this.amcAgeingAttachFilterMeta(this.amcOverdueAgeingChart, 'my');
          }
        } else {
          this.amcOverdueAgeingChart = null;
        }
      }
    },
    () => {
      if (scope === 'all') {
        this.amcOverdueAgeingAllLoader = false;
        this.amcOverdueAgeingAllChart = null;
      } else {
        this.amcOverdueAgeingLoader = false;
        this.amcOverdueAgeingChart = null;
      }
    }
  );
}

private amcAgeingGetScopeFilters(scope: 'my' | 'all'): { lobId: string; locId: string; departmentId: string } {
  if (scope === 'all') {
    return {
      lobId: this.amcAgeingAllLobId,
      locId: this.amcAgeingAllLocId,
      departmentId: this.amcAgeingAllDepartmentId,
    };
  }
  return {
    lobId: this.amcAgeingMyLobId,
    locId: this.amcAgeingMyLocId,
    departmentId: this.amcAgeingMyDepartmentId,
  };
}

private amcAgeingAttachFilterMeta(chart: any, scope: 'my' | 'all') {
  const filters = this.amcAgeingGetScopeFilters(scope);
  chart.lob = filters.lobId;
  chart.lob_location = filters.locId;
  chart.department = filters.departmentId;
}

private amcAgeingSyncFilteredLists() {
  this.filteredAmcAgeingMyLobList = this.amcManagementLobList.slice();
  this.filteredAmcAgeingAllLobList = this.amcManagementLobList.slice();
  this.filteredAmcAgeingMyDepartmentList = this.amcManagementDepartmentList.slice();
  this.filteredAmcAgeingAllDepartmentList = this.amcManagementDepartmentList.slice();
  this.filteredAmcAgeingMyLocList = this.amcManagementLocList.slice();
  this.filteredAmcAgeingAllLocList = this.amcManagementLocList.slice();
}

private closeAmcAgeingFilterDropdowns(scope: 'my' | 'all') {
  if (scope === 'all') {
    this.isAmcAgeingAllLobDropdownOpen = false;
    this.isAmcAgeingAllLocDropdownOpen = false;
    this.isAmcAgeingAllDepartmentDropdownOpen = false;
    this.isAmcAgeingEmployeeDropdownOpen = false;
    return;
  }
  this.isAmcAgeingMyLobDropdownOpen = false;
  this.isAmcAgeingMyLocDropdownOpen = false;
  this.isAmcAgeingMyDepartmentDropdownOpen = false;
}

onAmcAgeingLobSelected(lobId: any, scope: 'my' | 'all', label?: string) {
  const value = lobId != null && String(lobId).trim() !== '' ? String(lobId) : '';
  const lbl = value ? (label || this.amcMgmtFindLobLabel(value)) : '';
  if (scope === 'all') {
    this.amcAgeingAllLobId = value;
    this.amcAgeingAllLobLabel = lbl;
    this.isAmcAgeingAllLobDropdownOpen = false;
    this.amcAgeingAllLobSearchTerm = '';
    this.filteredAmcAgeingAllLobList = this.amcManagementLobList.slice();
  } else {
    this.amcAgeingMyLobId = value;
    this.amcAgeingMyLobLabel = lbl;
    this.isAmcAgeingMyLobDropdownOpen = false;
    this.amcAgeingMyLobSearchTerm = '';
    this.filteredAmcAgeingMyLobList = this.amcManagementLobList.slice();
  }
  this.getAmcOverdueAgeingChart(scope);
}

onAmcAgeingDepartmentSelected(departmentId: any, scope: 'my' | 'all', label?: string) {
  const value = departmentId != null && String(departmentId).trim() !== '' ? String(departmentId) : '';
  const lbl = value ? (label || this.amcMgmtFindDepartmentLabel(value)) : '';
  if (scope === 'all') {
    this.amcAgeingAllDepartmentId = value;
    this.amcAgeingAllDepartmentLabel = lbl;
    this.isAmcAgeingAllDepartmentDropdownOpen = false;
    this.amcAgeingAllDepartmentSearchTerm = '';
    this.filteredAmcAgeingAllDepartmentList = this.amcManagementDepartmentList.slice();
  } else {
    this.amcAgeingMyDepartmentId = value;
    this.amcAgeingMyDepartmentLabel = lbl;
    this.isAmcAgeingMyDepartmentDropdownOpen = false;
    this.amcAgeingMyDepartmentSearchTerm = '';
    this.filteredAmcAgeingMyDepartmentList = this.amcManagementDepartmentList.slice();
  }
  this.getAmcOverdueAgeingChart(scope);
}

onAmcAgeingLocSelected(locId: any, scope: 'my' | 'all') {
  const value = locId != null && String(locId).trim() !== '' ? String(locId) : '';
  const label = value ? this.amcMgmtFindLocLabel(value, scope) : '';
  if (scope === 'all') {
    this.amcAgeingAllLocId = value;
    this.amcAgeingAllLocLabel = label;
    this.isAmcAgeingAllLocDropdownOpen = false;
    this.amcAgeingAllLocSearchTerm = '';
    this.filteredAmcAgeingAllLocList = this.amcManagementLocList.slice();
  } else {
    this.amcAgeingMyLocId = value;
    this.amcAgeingMyLocLabel = label;
    this.isAmcAgeingMyLocDropdownOpen = false;
    this.amcAgeingMyLocSearchTerm = '';
    this.filteredAmcAgeingMyLocList = this.amcManagementLocList.slice();
  }
  this.getAmcOverdueAgeingChart(scope);
}

getAmcAgeingSelectedLobLabel(scope: 'my' | 'all'): string {
  const lobId = scope === 'all' ? this.amcAgeingAllLobId : this.amcAgeingMyLobId;
  if (!lobId) {
    return 'LOB';
  }
  const storedLabel = scope === 'all' ? this.amcAgeingAllLobLabel : this.amcAgeingMyLobLabel;
  return storedLabel || this.amcMgmtFindLobLabel(lobId) || 'LOB';
}

getAmcAgeingSelectedDepartmentLabel(scope: 'my' | 'all'): string {
  const departmentId = scope === 'all' ? this.amcAgeingAllDepartmentId : this.amcAgeingMyDepartmentId;
  if (!departmentId) {
    return 'Department';
  }
  const storedLabel = scope === 'all' ? this.amcAgeingAllDepartmentLabel : this.amcAgeingMyDepartmentLabel;
  return storedLabel || this.amcMgmtFindDepartmentLabel(departmentId) || 'Department';
}

getAmcAgeingSelectedLocLabel(scope: 'my' | 'all'): string {
  const locId = scope === 'all' ? this.amcAgeingAllLocId : this.amcAgeingMyLocId;
  if (!locId) {
    return 'LOC';
  }
  const storedLabel = scope === 'all' ? this.amcAgeingAllLocLabel : this.amcAgeingMyLocLabel;
  return storedLabel || this.amcMgmtFindLocLabel(locId, scope) || 'LOC';
}

getAmcAgeingSelectedEmployeeLabel(): string {
  return this.amcOverdueAgeingAllEmployeeName ? this.amcOverdueAgeingAllEmployeeName : 'Employee';
}

toggleAmcAgeingLobDropdown(scope: 'my' | 'all') {
  if (scope === 'all') {
    const opening = !this.isAmcAgeingAllLobDropdownOpen;
    this.closeAmcAgeingFilterDropdowns('all');
    this.closeAmcManagementFilterDropdowns('all');
    this.isAmcAgeingAllLobDropdownOpen = opening;
    if (opening) {
      this.onAmcAgeingLobSearch(this.amcAgeingAllLobSearchTerm, 'all');
    }
    return;
  }
  const opening = !this.isAmcAgeingMyLobDropdownOpen;
  this.closeAmcAgeingFilterDropdowns('my');
  this.closeAmcManagementFilterDropdowns('my');
  this.isAmcAgeingMyLobDropdownOpen = opening;
  if (opening) {
    this.onAmcAgeingLobSearch(this.amcAgeingMyLobSearchTerm, 'my');
  }
}

toggleAmcAgeingDepartmentDropdown(scope: 'my' | 'all') {
  if (scope === 'all') {
    const opening = !this.isAmcAgeingAllDepartmentDropdownOpen;
    this.closeAmcAgeingFilterDropdowns('all');
    this.closeAmcManagementFilterDropdowns('all');
    this.isAmcAgeingAllDepartmentDropdownOpen = opening;
    if (opening) {
      this.onAmcAgeingDepartmentSearch(this.amcAgeingAllDepartmentSearchTerm, 'all');
    }
    return;
  }
  const opening = !this.isAmcAgeingMyDepartmentDropdownOpen;
  this.closeAmcAgeingFilterDropdowns('my');
  this.closeAmcManagementFilterDropdowns('my');
  this.isAmcAgeingMyDepartmentDropdownOpen = opening;
  if (opening) {
    this.onAmcAgeingDepartmentSearch(this.amcAgeingMyDepartmentSearchTerm, 'my');
  }
}

toggleAmcAgeingLocDropdown(scope: 'my' | 'all') {
  if (scope === 'all') {
    const opening = !this.isAmcAgeingAllLocDropdownOpen;
    this.closeAmcAgeingFilterDropdowns('all');
    this.closeAmcManagementFilterDropdowns('all');
    this.isAmcAgeingAllLocDropdownOpen = opening;
    if (opening) {
      this.onAmcAgeingLocSearch(this.amcAgeingAllLocSearchTerm, 'all');
      if (!this.amcManagementLocList.length) {
        this.fetchAmcManagementLocationList('', 'all', 'ageing');
      }
    }
    return;
  }
  const opening = !this.isAmcAgeingMyLocDropdownOpen;
  this.closeAmcAgeingFilterDropdowns('my');
  this.closeAmcManagementFilterDropdowns('my');
  this.isAmcAgeingMyLocDropdownOpen = opening;
  if (opening) {
    this.onAmcAgeingLocSearch(this.amcAgeingMyLocSearchTerm, 'my');
    if (!this.amcManagementLocList.length) {
      this.fetchAmcManagementLocationList('', 'my', 'ageing');
    }
  }
}

toggleAmcAgeingEmployeeDropdown() {
  const opening = !this.isAmcAgeingEmployeeDropdownOpen;
  this.closeAmcAgeingFilterDropdowns('all');
  this.closeAmcManagementFilterDropdowns('all');
  this.isAmcAgeingEmployeeDropdownOpen = opening;
  if (opening) {
    this.maybeFetchAmcManagementEmployees();
    this.onAmcManagementEmployeeSearch(this.amcSharedEmployeeSearchTerm);
  }
}

onAmcAgeingLobSearch(term: string, scope: 'my' | 'all') {
  const q = (term || '').trim().toLowerCase();
  if (scope === 'all') {
    this.amcAgeingAllLobSearchTerm = term || '';
    this.filteredAmcAgeingAllLobList = !q
      ? this.amcManagementLobList.slice()
      : this.amcManagementLobList.filter((x) =>
        (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
      );
    return;
  }
  this.amcAgeingMyLobSearchTerm = term || '';
  this.filteredAmcAgeingMyLobList = !q
    ? this.amcManagementLobList.slice()
    : this.amcManagementLobList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
}

onAmcAgeingDepartmentSearch(term: string, scope: 'my' | 'all') {
  const q = (term || '').trim().toLowerCase();
  if (scope === 'all') {
    this.amcAgeingAllDepartmentSearchTerm = term || '';
    this.filteredAmcAgeingAllDepartmentList = !q
      ? this.amcManagementDepartmentList.slice()
      : this.amcManagementDepartmentList.filter((x) =>
        (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
      );
    return;
  }
  this.amcAgeingMyDepartmentSearchTerm = term || '';
  this.filteredAmcAgeingMyDepartmentList = !q
    ? this.amcManagementDepartmentList.slice()
    : this.amcManagementDepartmentList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
}

onAmcAgeingLocSearch(term: string, scope: 'my' | 'all') {
  const raw = (term || '').trim();
  const q = raw.toLowerCase();
  if (scope === 'all') {
    this.amcAgeingAllLocSearchTerm = term || '';
    if (this.amcAgeingAllLocSearchDebounceRef) {
      clearTimeout(this.amcAgeingAllLocSearchDebounceRef);
      this.amcAgeingAllLocSearchDebounceRef = null;
    }
    if (!raw) {
      this.filteredAmcAgeingAllLocList = this.amcManagementLocList.slice();
      return;
    }
    if (raw.length >= 2) {
      this.amcAgeingAllLocSearchDebounceRef = setTimeout(() => {
        this.fetchAmcManagementLocationList(raw, 'all', 'ageing');
      }, 300);
      return;
    }
    this.filteredAmcAgeingAllLocList = this.amcManagementLocList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
    return;
  }

  this.amcAgeingMyLocSearchTerm = term || '';
  if (this.amcAgeingMyLocSearchDebounceRef) {
    clearTimeout(this.amcAgeingMyLocSearchDebounceRef);
    this.amcAgeingMyLocSearchDebounceRef = null;
  }
  if (!raw) {
    this.filteredAmcAgeingMyLocList = this.amcManagementLocList.slice();
    return;
  }
  if (raw.length >= 2) {
    this.amcAgeingMyLocSearchDebounceRef = setTimeout(() => {
      this.fetchAmcManagementLocationList(raw, 'my', 'ageing');
    }, 300);
    return;
  }
  this.filteredAmcAgeingMyLocList = this.amcManagementLocList.filter((x) =>
    (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
  );
}

onAmcOverdueAgeingAllEmployeeSelected(employeeId: any, employeeName?: string) {
  if (employeeId && typeof employeeId === 'object' && employeeId.id !== undefined) {
    employeeName = employeeId.name;
    employeeId = employeeId.id;
  }
  this.amcOverdueAgeingAllEmployeeId = employeeId ? String(employeeId) : '';
  this.amcOverdueAgeingAllEmployeeName = employeeName ? String(employeeName).trim() : '';
  this.isAmcAgeingEmployeeDropdownOpen = false;
  this.amcSharedEmployeeSearchTerm = '';
  this.onAmcManagementEmployeeSearch('');
  this.getAmcOverdueAgeingChart('all');
}

// --- AMC Management Dashboard (Card 1: overdue buckets, Card 2: status_chart) ---
amcManagementLoader: boolean = false;
amcManagementAllLoader: boolean = false;
amcManagementOverdueChart: any = null;
amcManagementStatusChart: any = null;
amcManagementOverdueAllChart: any = null;
amcManagementStatusAllChart: any = null;
amcManagementMyOverdueVisible: boolean = false;
amcManagementMyStatusVisible: boolean = false;
amcManagementAllOverdueVisible: boolean = false;
amcManagementAllStatusVisible: boolean = false;
amcCriticalPendingLoader: boolean = false;
amcCriticalPendingAllLoader: boolean = false;
amcCriticalPendingMy: any = null;
amcCriticalPendingAll: any = null;
amcCriticalPendingMyVisible: boolean = false;
amcCriticalPendingAllVisible: boolean = false;
amcCompliancePendingLoader: boolean = false;
amcCompliancePendingAllLoader: boolean = false;
amcCompliancePendingMy: any = null;
amcCompliancePendingAll: any = null;
amcCompliancePendingMyVisible: boolean = false;
amcCompliancePendingAllVisible: boolean = false;
amcPendingTaskHover: any = null;
amcPendingTaskHoverTop: number = 0;
amcPendingTaskHoverLeft: number = 0;
amcPendingTaskHoverFlip: boolean = false;
amcCriticalAllEmployeeId: string = '';
amcCriticalAllEmployeeName: string = '';
amcCriticalMyLobId: string = '';
amcCriticalMyLobLabel: string = '';
amcCriticalMyLocId: string = '';
amcCriticalMyLocLabel: string = '';
amcCriticalMyDepartmentId: string = '';
amcCriticalMyDepartmentLabel: string = '';
amcCriticalAllLobId: string = '';
amcCriticalAllLobLabel: string = '';
amcCriticalAllLocId: string = '';
amcCriticalAllLocLabel: string = '';
amcCriticalAllDepartmentId: string = '';
amcCriticalAllDepartmentLabel: string = '';
amcCriticalMyLobSearchTerm: string = '';
amcCriticalAllLobSearchTerm: string = '';
amcCriticalMyDepartmentSearchTerm: string = '';
amcCriticalAllDepartmentSearchTerm: string = '';
amcCriticalMyLocSearchTerm: string = '';
amcCriticalAllLocSearchTerm: string = '';
filteredAmcCriticalMyLobList: Array<{ id: any; label: string }> = [];
filteredAmcCriticalAllLobList: Array<{ id: any; label: string }> = [];
filteredAmcCriticalMyDepartmentList: Array<{ id: any; label: string }> = [];
filteredAmcCriticalAllDepartmentList: Array<{ id: any; label: string }> = [];
filteredAmcCriticalMyLocList: Array<{ id: any; label: string }> = [];
filteredAmcCriticalAllLocList: Array<{ id: any; label: string }> = [];
isAmcCriticalMyLobDropdownOpen: boolean = false;
isAmcCriticalAllLobDropdownOpen: boolean = false;
isAmcCriticalMyDepartmentDropdownOpen: boolean = false;
isAmcCriticalAllDepartmentDropdownOpen: boolean = false;
isAmcCriticalMyLocDropdownOpen: boolean = false;
isAmcCriticalAllLocDropdownOpen: boolean = false;
isAmcCriticalEmployeeDropdownOpen: boolean = false;
private amcCriticalMyLocSearchDebounceRef: any = null;
private amcCriticalAllLocSearchDebounceRef: any = null;
amcComplianceAllEmployeeId: string = '';
amcComplianceAllEmployeeName: string = '';
amcComplianceMyLobId: string = '';
amcComplianceMyLobLabel: string = '';
amcComplianceMyLocId: string = '';
amcComplianceMyLocLabel: string = '';
amcComplianceMyDepartmentId: string = '';
amcComplianceMyDepartmentLabel: string = '';
amcComplianceAllLobId: string = '';
amcComplianceAllLobLabel: string = '';
amcComplianceAllLocId: string = '';
amcComplianceAllLocLabel: string = '';
amcComplianceAllDepartmentId: string = '';
amcComplianceAllDepartmentLabel: string = '';
amcComplianceMyLobSearchTerm: string = '';
amcComplianceAllLobSearchTerm: string = '';
amcComplianceMyDepartmentSearchTerm: string = '';
amcComplianceAllDepartmentSearchTerm: string = '';
amcComplianceMyLocSearchTerm: string = '';
amcComplianceAllLocSearchTerm: string = '';
filteredAmcComplianceMyLobList: Array<{ id: any; label: string }> = [];
filteredAmcComplianceAllLobList: Array<{ id: any; label: string }> = [];
filteredAmcComplianceMyDepartmentList: Array<{ id: any; label: string }> = [];
filteredAmcComplianceAllDepartmentList: Array<{ id: any; label: string }> = [];
filteredAmcComplianceMyLocList: Array<{ id: any; label: string }> = [];
filteredAmcComplianceAllLocList: Array<{ id: any; label: string }> = [];
isAmcComplianceMyLobDropdownOpen: boolean = false;
isAmcComplianceAllLobDropdownOpen: boolean = false;
isAmcComplianceMyDepartmentDropdownOpen: boolean = false;
isAmcComplianceAllDepartmentDropdownOpen: boolean = false;
isAmcComplianceMyLocDropdownOpen: boolean = false;
isAmcComplianceAllLocDropdownOpen: boolean = false;
isAmcComplianceEmployeeDropdownOpen: boolean = false;
private amcComplianceMyLocSearchDebounceRef: any = null;
private amcComplianceAllLocSearchDebounceRef: any = null;
amcManagementEmployees: Array<{ id: any; employee_name: string }> = [];
amcManagementEmployeesMaster: Array<{ id: any; employee_name: string }> = [];
filteredAmcManagementEmployees: Array<{ id: any; employee_name: string }> = [];
amcManagementEmployeesLoading: boolean = false;
private amcManagementEmployeeSearchDebounceRef: any = null;
private amcManagementLastEmployeesQuery: string = '';
private amcManagementLastEmployeeSearchChartKind: 'overdue' | 'status' = 'overdue';
amcSharedEmployeeSearchTerm: string = '';
amcManagementLobList: Array<{ id: any; label: string }> = [];
amcManagementLocList: Array<{ id: any; label: string }> = [];
amcManagementDepartmentList: Array<{ id: any; label: string }> = [];
amcManagementLocLoading: boolean = false;
amcManagementLobLoading: boolean = false;
amcManagementDepartmentLoading: boolean = false;
private amcManagementLastLocQuery: string = '';
private amcManagementLastLocSearchScope: 'my' | 'all' = 'my';
private amcManagementLastLocSearchChartKind: 'overdue' | 'status' = 'overdue';
private amcManagementLastLocSearchTarget: 'management' | 'critical' | 'compliance' | 'ageing' = 'management';
private amcManagementFiltersLoaded: boolean = false;
amcMgmtCardFilters: {
  my: { overdue: AmcMgmtCardFilterState; status: AmcMgmtCardFilterState };
  all: { overdue: AmcMgmtCardFilterState; status: AmcMgmtCardFilterState };
};
private amcMgmtRequestGen: {
  my: { overdue: number; status: number };
  all: { overdue: number; status: number };
} = {
  my: { overdue: 0, status: 0 },
  all: { overdue: 0, status: 0 },
};

private amcMgmtCreateEmptyCardFilterState(): AmcMgmtCardFilterState {
  return {
    lobId: '',
    lobLabel: '',
    locId: '',
    locLabel: '',
    departmentId: '',
    departmentLabel: '',
    employeeId: '',
    employeeName: '',
    lobSearchTerm: '',
    departmentSearchTerm: '',
    locSearchTerm: '',
    employeeSearchTerm: '',
    filteredLobList: [],
    filteredDepartmentList: [],
    filteredLocList: [],
    isLobDropdownOpen: false,
    isLocDropdownOpen: false,
    isDepartmentDropdownOpen: false,
    isEmployeeDropdownOpen: false,
    locSearchDebounceRef: null,
  };
}

private amcMgmtInitCardFilters() {
  this.amcMgmtCardFilters = {
    my: {
      overdue: this.amcMgmtCreateEmptyCardFilterState(),
      status: this.amcMgmtCreateEmptyCardFilterState(),
    },
    all: {
      overdue: this.amcMgmtCreateEmptyCardFilterState(),
      status: this.amcMgmtCreateEmptyCardFilterState(),
    },
  };
}

amcMgmtCard(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind): AmcMgmtCardFilterState {
  if (!this.amcMgmtCardFilters) {
    this.amcMgmtInitCardFilters();
  }
  return this.amcMgmtCardFilters[scope][chartKind];
}

amcMgmtIsValidChart(chart: any): boolean {
  return !!(
    chart
    && chart.title
    && Array.isArray(chart.datasets)
    && chart.datasets.length
    && Array.isArray(chart.labels)
    && chart.labels.length
  );
}

private amcMgmtCloneOverdueDataset(ds: any): any {
  return {
    label: ds.label,
    data: (ds.data || []).slice(),
    backgroundColor: ds.backgroundColor,
    borderColor: ds.borderColor,
    hoverBackgroundColor: ds.hoverBackgroundColor,
    stack: ds.stack || 'amc_overdue',
  };
}

private amcMgmtGetOverdueChartByScope(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind = 'overdue'): any {
  if (chartKind === 'status') {
    return scope === 'all' ? this.amcManagementStatusAllChart : this.amcManagementStatusChart;
  }
  return scope === 'all' ? this.amcManagementOverdueAllChart : this.amcManagementOverdueChart;
}

private amcMgmtSetOverdueChartByScope(scope: AmcMgmtScope, chart: any, recreateCanvas = false, chartKind: AmcMgmtChartKind = 'overdue') {
  chart.chartRevision = (chart.chartRevision || 0) + 1;
  const applyChart = (next: any) => {
    if (chartKind === 'status') {
      if (scope === 'all') { this.amcManagementStatusAllChart = next; }
      else { this.amcManagementStatusChart = next; }
      return;
    }
    if (scope === 'all') { this.amcManagementOverdueAllChart = next; }
    else { this.amcManagementOverdueChart = next; }
  };
  if (recreateCanvas) {
    chart.canvasAlive = false;
    applyChart(chart);
    setTimeout(() => {
      chart.canvasAlive = true;
      applyChart(Object.assign({}, chart));
    }, 0);
    return;
  }
  applyChart(chart);
}

onAmcMgmtOverdueLegendClick(scope: AmcMgmtScope, datasetIndex: number, event?: Event, chartKind: AmcMgmtChartKind = 'overdue') {
  if (event) {
    event.stopPropagation();
  }
  const chart = this.amcMgmtGetOverdueChartByScope(scope, chartKind);
  if (!chart || !chart.legendItems || !chart._sourceDatasets) {
    return;
  }
  const leg = chart.legendItems[datasetIndex];
  if (!leg) {
    return;
  }
  const visibleCount = chart.legendItems.filter((l: any) => !l.hidden).length;
  if (!leg.hidden && visibleCount <= 1) {
    return;
  }
  leg.hidden = !leg.hidden;
  this.amcMgmtSetOverdueChartByScope(scope, this.amcMgmtBuildOverdueChartView(chart), true, chartKind);
}

private amcMgmtBuildOverdueChartView(chart: any): any {
  const labelCount = chart.labels.length;
  const mask = chart.legendItems.map((l: any) => !l.hidden);
  const source = chart._sourceDatasets as any[];

  const datasets = source.map((ds, i) => {
    const next = this.amcMgmtCloneOverdueDataset(ds);
    if (!mask[i]) {
      next.data = new Array(labelCount).fill(0);
      next.hidden = true;
    }
    return next;
  });

  let total = 0;
  source.forEach((ds, i) => {
    if (!mask[i]) {
      return;
    }
    (ds.data || []).forEach((v: number) => {
      total += this.amcMgmtNum(v);
    });
  });

  const stackTotals = chart.labels.map((_: string, ageingIndex: number) =>
    source.reduce((sum: number, ds: any, i: number) => {
      if (!mask[i]) {
        return sum;
      }
      return sum + this.amcMgmtNum(ds.data[ageingIndex]);
    }, 0)
  );
  const maxStackHeight = stackTotals.length ? Math.max.apply(null, stackTotals) : 0;

  const chartColors = datasets.map((ds) => ({
    backgroundColor: ds.backgroundColor,
    borderColor: ds.borderColor,
    hoverBackgroundColor: ds.hoverBackgroundColor,
  }));

  const options = chart.chart_kind === 'status'
    ? this.amcMgmtStatusChartOptions(maxStackHeight)
    : this.amcMgmtOverdueChartOptions(maxStackHeight);
  options.tooltips = options.tooltips || {};
  options.tooltips.filter = (tooltipItem: any) => mask[tooltipItem.datasetIndex] === true;

  return {
    title: chart.title,
    total: total,
    labels: chart.labels.slice(),
    datasets: datasets,
    chartColors: chartColors,
    legendItems: chart.legendItems.map((l: any) => ({ ...l })),
    _sourceDatasets: chart._sourceDatasets,
    options: options,
    barChartType: chart.barChartType,
    barChartLegend: chart.barChartLegend,
    key: chart.key,
    scope: chart.scope,
    chart_kind: chart.chart_kind,
    items: chart.items,
  };
}

private amcMgmtApplyChartResult(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind, formatted: any) {
  if (!this.amcMgmtIsValidChart(formatted)) {
    return;
  }
  this.amcMgmtSetOverdueChartByScope(scope, formatted, true, chartKind);
  if (chartKind === 'overdue') {
    if (scope === 'all') {
      this.amcManagementAllOverdueVisible = true;
    } else {
      this.amcManagementMyOverdueVisible = true;
    }
    return;
  }
  if (scope === 'all') {
    this.amcManagementAllStatusVisible = true;
  } else {
    this.amcManagementMyStatusVisible = true;
  }
}

private amcMgmtClearScopeLoader(scope: AmcMgmtScope) {
  if (scope === 'all') {
    this.amcManagementAllLoader = false;
  } else {
    this.amcManagementLoader = false;
  }
}

private amcMgmtSyncManagementCardFilteredLists() {
  if (!this.amcMgmtCardFilters) {
    return;
  }
  (['my', 'all'] as AmcMgmtScope[]).forEach((scope) => {
    (['overdue', 'status'] as AmcMgmtChartKind[]).forEach((chartKind) => {
      const card = this.amcMgmtCard(scope, chartKind);
      card.filteredLobList = this.amcManagementLobList.slice();
      card.filteredDepartmentList = this.amcManagementDepartmentList.slice();
      card.filteredLocList = this.amcManagementLocList.slice();
    });
  });
}

private amcMgmtNum(v: any): number {
  const n = this.webService.convertNaN(v);
  return n ? parseInt(n, 10) : 0;
}

private amcMgmtNormalizeKey(value: any): string {
  return value ? String(value).trim().toLowerCase().replace(/[\s-]+/g, '_') : '';
}

private amcMgmtGetChartBlock(root: any, chartKind: 'overdue' | 'status'): any {
  if (!root) {
    return null;
  }
  if (chartKind === 'status') {
    const sc = root.status_chart && typeof root.status_chart === 'object' ? root.status_chart : null;
    if (!sc) {
      return null;
    }
    return {
      ...sc,
      legend: sc.status_legend || sc.legend || root.legend,
      status_legend: sc.status_legend,
      priority_labels: sc.priority_labels || sc.bucket_labels,
      priority_keys: sc.priority_keys,
      task_priority_keys: sc.priority_keys || sc.task_priority_keys || root.task_priority_keys,
      status_keys: sc.status_keys,
      buckets: sc.buckets,
      bucket_labels: sc.bucket_labels || root.bucket_labels,
      ageing_bucket_keys: sc.ageing_bucket_keys || root.ageing_bucket_keys,
      chart_title: sc.chart_title || sc.card_label || root.chart_title,
      card_label: sc.card_label || sc.chart_title || root.card_label,
      total: sc.total != null ? sc.total : (sc.card && sc.card.total != null ? sc.card.total : null),
    };
  }
  const card = root.card && typeof root.card === 'object' ? root.card : {};
  const chartData = card.chart_data || root.chart_data || {};
  return {
    ...root,
    ...card,
    ...chartData,
    buckets: root.buckets || card.buckets || chartData.buckets,
    legend: root.legend || card.legend || chartData.legend,
    bucket_labels: root.bucket_labels || card.bucket_labels || chartData.bucket_labels,
    ageing_bucket_keys: root.ageing_bucket_keys || card.ageing_bucket_keys || chartData.ageing_bucket_keys,
    task_priority_keys: root.task_priority_keys || card.task_priority_keys || chartData.task_priority_keys,
    chart_title: root.chart_title || card.chart_title || chartData.chart_title,
    card_label: root.card_label || card.card_label || chartData.card_label,
    total: root.total != null ? root.total : (card.total != null ? card.total : chartData.total),
  };
}

private amcMgmtComputeYAxisMax(maxStackHeight: number): number {
  if (maxStackHeight <= 0) {
    return 10;
  }
  if (maxStackHeight <= 20) {
    return Math.max(10, Math.ceil(maxStackHeight * 1.2));
  }
  if (maxStackHeight <= 1000) {
    return Math.ceil(maxStackHeight * 1.15);
  }
  return Math.ceil((maxStackHeight * 1.1) / 1000) * 1000;
}

private amcMgmtChartOptions(maxStackHeight: number): any {
  const yAxisMax = this.amcMgmtComputeYAxisMax(maxStackHeight);
  return {
    responsive: true,
    maintainAspectRatio: false,
    legend: { position: 'right' },
    plugins: {
      datalabels: { display: false },
    },
    tooltips: {
      mode: 'index',
      intersect: false,
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          const ds = data.datasets[tooltipItem.datasetIndex];
          const label = ds && ds.label ? ds.label : '';
          const val = tooltipItem.yLabel != null ? tooltipItem.yLabel : 0;
          return label + ': ' + val;
        },
      },
    },
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: { display: false },
        ticks: { maxRotation: 45, minRotation: 0 },
      }],
      yAxes: [{
        stacked: true,
        scaleLabel: { display: true, labelString: 'Task Count' },
        ticks: {
          beginAtZero: true,
          max: yAxisMax,
          precision: 0,
        },
        gridLines: { color: 'rgba(0, 0, 0, 0.08)' },
      }],
    },
  };
}

private amcMgmtWrapDayAxisLabel(label: any): string | string[] {
  const text = label == null ? '' : String(label).replace(/\s+/g, ' ').trim();
  if (!text) {
    return text;
  }
  const match = text.match(/^(.*\S)\s+(Days?)$/i);
  if (!match) {
    return text;
  }
  const head = match[1];
  const dayWord = match[2];
  if (/^more than/i.test(head)) {
    const rest = head.replace(/^more than\s+/i, '');
    return ['More than', (rest ? rest + ' ' : '') + dayWord];
  }
  return [head, dayWord];
}

private amcMgmtOverdueChartOptions(maxStackHeight: number): any {
  const options = this.amcMgmtChartOptions(maxStackHeight);
  options.layout = options.layout || { padding: {} };
  if (!options.layout.padding) {
    options.layout.padding = {};
  }
  options.layout.padding.bottom = 0;
  options.legend = { display: false };
  if (options.scales && options.scales.xAxes && options.scales.xAxes[0]) {
    options.scales.xAxes[0].ticks = {
      maxRotation: 0,
      minRotation: 0,
      autoSkip: false,
      fontSize: 9,
      padding: 2,
      callback: (value: any) => this.amcMgmtWrapDayAxisLabel(value),
    };
    options.scales.xAxes[0].gridLines = {
      display: false,
      offset: true,
    };
  }
  return options;
}

private amcMgmtStatusChartOptions(maxStackHeight: number): any {
  const options = this.amcMgmtChartOptions(maxStackHeight);
  options.legend = { display: false };
  options.plugins = {
    datalabels: {
      display: (context: any) => {
        const val = context.dataset.data[context.dataIndex];
        return val != null && val > 0;
      },
      color: '#fff',
      anchor: 'center',
      align: 'center',
      font: {
        weight: 'bold',
        size: 10,
      },
      formatter: (value: any) => (value > 0 ? value : ''),
    },
  };
  if (options.scales && options.scales.xAxes && options.scales.xAxes[0]) {
    options.scales.xAxes[0].scaleLabel = { display: true, labelString: 'Priority', fontSize: 9 };
    options.scales.xAxes[0].ticks = {
      maxRotation: 0,
      minRotation: 0,
      autoSkip: false,
      fontSize: 9,
      padding: 8,
    };
    options.scales.xAxes[0].gridLines = {
      display: false,
      offset: true,
    };
  }
  if (options.scales && options.scales.yAxes && options.scales.yAxes[0]) {
    options.scales.yAxes[0].scaleLabel = { display: true, labelString: 'Number of Tasks', fontSize: 9 };
    options.scales.yAxes[0].gridLines = {
      color: 'rgba(0, 0, 0, 0.08)',
      borderDash: [4, 4],
    };
  }
  return options;
}

private amcMgmtReadLegendColor(item: any): string {
  if (!item) {
    return '';
  }
  const raw = item.color || item.colour || item.background_color || item.color_code || item.hex;
  return raw != null && String(raw).trim() !== '' ? String(raw).trim() : '';
}

private amcMgmtLegendMap(legend: any): { [key: string]: { label: string; color: string } } {
  const map: { [key: string]: { label: string; color: string } } = {};
  if (!legend) {
    return map;
  }
  const list = Array.isArray(legend) ? legend : Object.keys(legend).map((k) => ({ key: k, ...(legend[k] || {}) }));
  for (const item of list) {
    if (!item) {
      continue;
    }
    const color = this.amcMgmtReadLegendColor(item);
    const label = item.label || item.name || item.title || '';
    const meta = { label: label, color: color };
    const keys = [
      item.key,
      item.priority_key,
      item.task_priority_key,
      item.task_priority,
      item.id,
      item.name,
    ].filter((k) => k != null && String(k).trim() !== '');
    if (!keys.length && item.label) {
      keys.push(item.label);
    }
    for (const k of keys) {
      const keyStr = String(k);
      map[keyStr] = { label: meta.label || keyStr, color: color };
      map[this.amcMgmtNormalizeKey(keyStr)] = { label: meta.label || keyStr, color: color };
    }
  }
  return map;
}

private amcMgmtLegendMeta(legendMap: { [key: string]: { label: string; color: string } }, priorityKey: string) {
  const fromMap = legendMap[priorityKey] || legendMap[this.amcMgmtNormalizeKey(priorityKey)];
  if (fromMap) {
    return fromMap;
  }
  return { label: priorityKey, color: '' };
}

private amcMgmtReadCount(val: any): number {
  if (val == null) {
    return 0;
  }
  if (typeof val === 'number' || typeof val === 'string') {
    return this.amcMgmtNum(val);
  }
  if (typeof val === 'object') {
    return this.amcMgmtNum(
      val.count != null ? val.count : (val.total != null ? val.total : (val.value != null ? val.value : val.task_count))
    );
  }
  return 0;
}

private amcMgmtMatchPriorityKey(item: any, priorityKey: string): boolean {
  if (!item) {
    return false;
  }
  const norm = this.amcMgmtNormalizeKey(priorityKey);
  const candidates = [
    item.task_priority,
    item.task_priority_key,
    item.priority_key,
    item.key,
    item.id,
    item.name,
    item.label,
  ];
  for (const pk of candidates) {
    if (pk == null || String(pk).trim() === '') {
      continue;
    }
    if (String(pk) === priorityKey || this.amcMgmtNormalizeKey(pk) === norm) {
      return true;
    }
  }
  return false;
}

private amcMgmtExtractPriorityFromRow(row: any, priorityKey: string): number {
  if (!row || typeof row !== 'object') {
    return 0;
  }
  if (row[priorityKey] != null) {
    return this.amcMgmtReadCount(row[priorityKey]);
  }
  const norm = this.amcMgmtNormalizeKey(priorityKey);
  for (const k of Object.keys(row)) {
    if (this.amcMgmtNormalizeKey(k) === norm) {
      return this.amcMgmtReadCount(row[k]);
    }
  }

  // API: task_priority array — [{ task_priority, count, color }, ...]
  if (Array.isArray(row.task_priority)) {
    for (const p of row.task_priority) {
      if (this.amcMgmtMatchPriorityKey(p, priorityKey)) {
        return this.amcMgmtReadCount(p);
      }
    }
  }
  if (Array.isArray(row.task_status)) {
    for (const s of row.task_status) {
      if (this.amcMgmtMatchPriorityKey(s, priorityKey)) {
        return this.amcMgmtReadCount(s);
      }
    }
  }
  // API: task_priority object map
  if (row.task_priority && typeof row.task_priority === 'object' && !Array.isArray(row.task_priority)) {
    if (row.task_priority[priorityKey] != null) {
      return this.amcMgmtReadCount(row.task_priority[priorityKey]);
    }
    for (const k of Object.keys(row.task_priority)) {
      if (this.amcMgmtNormalizeKey(k) === norm) {
        return this.amcMgmtReadCount(row.task_priority[k]);
      }
    }
  }

  if (Array.isArray(row.priorities)) {
    for (const p of row.priorities) {
      if (this.amcMgmtMatchPriorityKey(p, priorityKey)) {
        return this.amcMgmtReadCount(p);
      }
    }
  }
  if (row.priorities && typeof row.priorities === 'object' && !Array.isArray(row.priorities)) {
    if (row.priorities[priorityKey] != null) {
      return this.amcMgmtReadCount(row.priorities[priorityKey]);
    }
    for (const k of Object.keys(row.priorities)) {
      if (this.amcMgmtNormalizeKey(k) === norm) {
        return this.amcMgmtReadCount(row.priorities[k]);
      }
    }
  }
  if (Array.isArray(row.values) || Array.isArray(row.data)) {
    return 0;
  }
  return 0;
}

private amcMgmtBucketCount(
  buckets: any,
  ageingKeys: string[],
  priorityKeys: string[],
  ageingKey: string,
  priorityKey: string
): number {
  if (!buckets) {
    return 0;
  }
  const ageingIndex = ageingKeys.indexOf(ageingKey);
  const priorityIndex = priorityKeys.indexOf(priorityKey);

  // buckets[] aligned with ageing_bucket_keys by index (most common API shape)
  if (Array.isArray(buckets) && ageingIndex >= 0 && ageingIndex < buckets.length) {
    const row = buckets[ageingIndex];
    if (row != null) {
      if (Array.isArray(row)) {
        if (priorityIndex >= 0) {
          return this.amcMgmtReadCount(row[priorityIndex]);
        }
      } else if (typeof row === 'object') {
        return this.amcMgmtExtractPriorityFromRow(row, priorityKey);
      }
    }
  }

  // Matrix: [[v,v,...], ...] — row = ageing, col = priority
  if (Array.isArray(buckets) && buckets.length && Array.isArray(buckets[0])) {
    if (ageingIndex >= 0 && priorityIndex >= 0 && buckets[ageingIndex]) {
      return this.amcMgmtReadCount(buckets[ageingIndex][priorityIndex]);
    }
  }

  // Array of bucket rows — find by ageing key
  if (Array.isArray(buckets)) {
    const row = buckets.find((b: any) => {
      if (!b || typeof b !== 'object') {
        return false;
      }
      const raw = b.key || b.ageing_bucket || b.ageing_bucket_key || b.bucket_key || b.bucket || b.label;
      return raw != null && (
        String(raw) === ageingKey || this.amcMgmtNormalizeKey(raw) === this.amcMgmtNormalizeKey(ageingKey)
      );
    });
    if (row) {
      if (Array.isArray(row.values) && priorityIndex >= 0) {
        return this.amcMgmtReadCount(row.values[priorityIndex]);
      }
      if (Array.isArray(row.data) && priorityIndex >= 0) {
        return this.amcMgmtReadCount(row.data[priorityIndex]);
      }
      return this.amcMgmtExtractPriorityFromRow(row, priorityKey);
    }
  }

  // Ageing-first object: buckets[ageingKey] -> { task_priority: [...] }
  if (typeof buckets === 'object') {
    let ageingNode = buckets[ageingKey];
    if (ageingNode == null) {
      const ageingNorm = this.amcMgmtNormalizeKey(ageingKey);
      for (const k of Object.keys(buckets)) {
        if (this.amcMgmtNormalizeKey(k) === ageingNorm) {
          ageingNode = buckets[k];
          break;
        }
      }
    }
    if (ageingNode != null) {
      if (typeof ageingNode === 'number' || typeof ageingNode === 'string') {
        return this.amcMgmtReadCount(ageingNode);
      }
      if (typeof ageingNode === 'object') {
        return this.amcMgmtExtractPriorityFromRow(ageingNode, priorityKey);
      }
    }

    // Priority-first object: buckets[priorityKey][ageingKey]
    let priorityNode = buckets[priorityKey];
    if (priorityNode == null) {
      const prioNorm = this.amcMgmtNormalizeKey(priorityKey);
      for (const k of Object.keys(buckets)) {
        if (this.amcMgmtNormalizeKey(k) === prioNorm) {
          priorityNode = buckets[k];
          break;
        }
      }
    }
    if (priorityNode && typeof priorityNode === 'object') {
      if (priorityNode[ageingKey] != null) {
        return this.amcMgmtReadCount(priorityNode[ageingKey]);
      }
      const ageingNorm = this.amcMgmtNormalizeKey(ageingKey);
      for (const k of Object.keys(priorityNode)) {
        if (this.amcMgmtNormalizeKey(k) === ageingNorm) {
          return this.amcMgmtReadCount(priorityNode[k]);
        }
      }
      if (Array.isArray(priorityNode.values) && ageingIndex >= 0) {
        return this.amcMgmtReadCount(priorityNode.values[ageingIndex]);
      }
      if (Array.isArray(priorityNode.data) && ageingIndex >= 0) {
        return this.amcMgmtReadCount(priorityNode.data[ageingIndex]);
      }
    }
  }
  return 0;
}

private amcMgmtGetSampleBucketRow(chartBlock: any): any {
  const buckets = chartBlock && chartBlock.buckets;
  if (!buckets) {
    return null;
  }
  if (Array.isArray(buckets) && buckets.length) {
    return buckets[0];
  }
  const ageingKeys = chartBlock.ageing_bucket_keys;
  if (Array.isArray(ageingKeys) && ageingKeys.length && buckets[ageingKeys[0]]) {
    return buckets[ageingKeys[0]];
  }
  const firstKey = buckets && typeof buckets === 'object' ? Object.keys(buckets)[0] : null;
  return firstKey ? buckets[firstKey] : null;
}

private amcMgmtMergeLegendLabelsFromTaskPriority(
  chartBlock: any,
  legendMap: { [key: string]: { label: string; color: string } }
): { [key: string]: { label: string; color: string } } {
  const merged = { ...legendMap };
  const buckets = chartBlock && chartBlock.buckets;
  const rows: any[] = [];
  if (Array.isArray(buckets)) {
    rows.push.apply(rows, buckets);
  } else if (buckets && typeof buckets === 'object') {
    const ageingKeys = this.amcMgmtResolveAgeingKeys(chartBlock);
    for (const k of ageingKeys) {
      if (buckets[k]) {
        rows.push(buckets[k]);
      }
    }
  }
  for (const row of rows) {
    if (!row || !Array.isArray(row.task_priority)) {
      continue;
    }
    for (const p of row.task_priority) {
      if (!p) {
        continue;
      }
      const key = p.task_priority || p.task_priority_key || p.key || p.priority_key || p.name;
      if (!key) {
        continue;
      }
      const keyStr = String(key);
      const norm = this.amcMgmtNormalizeKey(keyStr);
      if (!merged[keyStr] && !merged[norm]) {
        const entry = {
          label: p.label || p.name || keyStr,
          color: this.amcMgmtReadLegendColor(p),
        };
        merged[keyStr] = entry;
        merged[norm] = entry;
      }
    }
  }
  return merged;
}

private amcMgmtResolveAgeingKeys(chartBlock: any): string[] {
  if (chartBlock && Array.isArray(chartBlock.ageing_bucket_keys) && chartBlock.ageing_bucket_keys.length) {
    return chartBlock.ageing_bucket_keys.map((k: any) => String(k));
  }
  if (chartBlock && Array.isArray(chartBlock.buckets) && chartBlock.buckets.length) {
    const fromRows: string[] = [];
    for (const row of chartBlock.buckets) {
      if (!row) {
        continue;
      }
      const k = row.ageing_bucket_key || row.ageing_bucket || row.bucket_key || row.key || row.bucket;
      if (k != null && String(k).trim() !== '') {
        fromRows.push(String(k));
      }
    }
    if (fromRows.length) {
      return fromRows;
    }
  }
  if (chartBlock && chartBlock.buckets && typeof chartBlock.buckets === 'object' && !Array.isArray(chartBlock.buckets)) {
    return Object.keys(chartBlock.buckets);
  }
  return [];
}

private amcMgmtGetLegendSeries(legendSource: any): Array<{ key: string; label: string; color: string }> {
  if (!legendSource) {
    return [];
  }
  if (Array.isArray(legendSource)) {
    const series: Array<{ key: string; label: string; color: string }> = [];
    for (const item of legendSource) {
      if (!item) {
        continue;
      }
      const key = item.key || item.task_priority || item.priority_key || item.task_priority_key || item.id || item.name;
      if (!key || String(key).trim() === '') {
        continue;
      }
      series.push({
        key: String(key),
        label: item.label || item.name || item.title || String(key),
        color: this.amcMgmtReadLegendColor(item),
      });
    }
    return series;
  }
  if (typeof legendSource === 'object') {
    return Object.keys(legendSource).map((k) => ({
      key: k,
      label: (legendSource[k] && (legendSource[k].label || legendSource[k].name)) || k,
      color: this.amcMgmtReadLegendColor(legendSource[k]),
    }));
  }
  return [];
}

private amcMgmtResolvePriorityKeys(chartBlock: any, legendMap: { [key: string]: { label: string; color: string } }): string[] {
  const legendSource = chartBlock && chartBlock.legend;
  const fromLegendSeries = this.amcMgmtGetLegendSeries(legendSource);
  if (fromLegendSeries.length) {
    return fromLegendSeries.map((s) => s.key);
  }
  if (chartBlock && Array.isArray(chartBlock.task_priority_keys) && chartBlock.task_priority_keys.length) {
    return chartBlock.task_priority_keys.map((k: any) => String(k));
  }
  const keys = Object.keys(legendMap);
  return keys.length ? keys : [];
}

private amcMgmtResolveLabel(chartBlock: any, ageingKey: string, ageingIndex?: number): string {
  const labels = chartBlock && chartBlock.bucket_labels ? chartBlock.bucket_labels : null;
  if (Array.isArray(labels) && ageingIndex != null && labels[ageingIndex] != null) {
    return String(labels[ageingIndex]);
  }
  if (labels && labels[ageingKey] != null) {
    return String(labels[ageingKey]);
  }
  const norm = this.amcMgmtNormalizeKey(ageingKey);
  if (labels && typeof labels === 'object') {
    for (const k of Object.keys(labels)) {
      if (this.amcMgmtNormalizeKey(k) === norm) {
        return String(labels[k]);
      }
    }
  }
  return ageingKey.replace(/_/g, ' ');
}

private amcMgmtResolvePriorityCategoryKeys(chartBlock: any): string[] {
  if (chartBlock && Array.isArray(chartBlock.priority_keys) && chartBlock.priority_keys.length) {
    return chartBlock.priority_keys.map((k: any) => String(k));
  }
  if (chartBlock && Array.isArray(chartBlock.task_priority_keys) && chartBlock.task_priority_keys.length) {
    return chartBlock.task_priority_keys.map((k: any) => String(k));
  }
  const buckets = chartBlock && chartBlock.buckets;
  if (Array.isArray(buckets) && buckets.length) {
    const fromRows: string[] = [];
    for (const row of buckets) {
      if (!row) {
        continue;
      }
      const k = row.task_priority_key || row.priority_key || row.task_priority || row.key || row.priority;
      if (k != null && String(k).trim() !== '') {
        fromRows.push(String(k));
      }
    }
    if (fromRows.length) {
      return fromRows;
    }
  }
  if (buckets && typeof buckets === 'object' && !Array.isArray(buckets)) {
    const skip = { data: 1, values: 1, ageing_bucket_keys: 1, task_priority_keys: 1, priority_keys: 1 };
    const keys = Object.keys(buckets).filter((k) => !skip[k]);
    if (keys.length) {
      return keys;
    }
  }
  return [];
}

private amcMgmtResolvePriorityCategoryLabel(chartBlock: any, priorityKey: string, priorityIndex?: number): string {
  const labels = chartBlock && (chartBlock.priority_labels || chartBlock.bucket_labels)
    ? (chartBlock.priority_labels || chartBlock.bucket_labels)
    : null;
  if (Array.isArray(labels) && priorityIndex != null && labels[priorityIndex] != null) {
    return String(labels[priorityIndex]);
  }
  if (labels && labels[priorityKey] != null) {
    return String(labels[priorityKey]);
  }
  const norm = this.amcMgmtNormalizeKey(priorityKey);
  if (labels && typeof labels === 'object') {
    for (const k of Object.keys(labels)) {
      if (this.amcMgmtNormalizeKey(k) === norm) {
        return String(labels[k]);
      }
    }
  }
  return priorityKey.replace(/_/g, ' ');
}

private amcMgmtStatusBucketCount(
  buckets: any,
  priorityKeys: string[],
  statusKeys: string[],
  priorityKey: string,
  statusKey: string
): number {
  if (!buckets) {
    return 0;
  }
  const priorityIndex = priorityKeys.indexOf(priorityKey);
  const statusIndex = statusKeys.indexOf(statusKey);

  if (Array.isArray(buckets) && priorityIndex >= 0 && priorityIndex < buckets.length) {
    const row = buckets[priorityIndex];
    if (row != null) {
      if (Array.isArray(row)) {
        if (statusIndex >= 0) {
          return this.amcMgmtReadCount(row[statusIndex]);
        }
      } else if (typeof row === 'object') {
        if (row.status && typeof row.status === 'object') {
          return this.amcMgmtExtractPriorityFromRow(row.status, statusKey);
        }
        if (row.task_status && typeof row.task_status === 'object') {
          return this.amcMgmtExtractPriorityFromRow(row.task_status, statusKey);
        }
        return this.amcMgmtExtractPriorityFromRow(row, statusKey);
      }
    }
  }

  let priorityNode = buckets[priorityKey];
  if (priorityNode == null) {
    const prioNorm = this.amcMgmtNormalizeKey(priorityKey);
    for (const k of Object.keys(buckets)) {
      if (this.amcMgmtNormalizeKey(k) === prioNorm) {
        priorityNode = buckets[k];
        break;
      }
    }
  }
  if (priorityNode != null && typeof priorityNode === 'object') {
    if (priorityNode.status && typeof priorityNode.status === 'object') {
      return this.amcMgmtExtractPriorityFromRow(priorityNode.status, statusKey);
    }
    if (priorityNode.task_status && typeof priorityNode.task_status === 'object') {
      return this.amcMgmtExtractPriorityFromRow(priorityNode.task_status, statusKey);
    }
    return this.amcMgmtExtractPriorityFromRow(priorityNode, statusKey);
  }
  return 0;
}

private amcMgmtParseChartBuckets(chartBlock: any): boolean {
  if (!chartBlock) {
    return false;
  }
  if (!chartBlock.buckets) {
    chartBlock.buckets = {};
  }
  if (typeof chartBlock.buckets === 'string') {
    try {
      chartBlock.buckets = JSON.parse(chartBlock.buckets);
    } catch (e) {
      return false;
    }
  }
  if (chartBlock.buckets && chartBlock.buckets.data && !Array.isArray(chartBlock.buckets)) {
    const nested = chartBlock.buckets;
    if (!chartBlock.ageing_bucket_keys && nested.ageing_bucket_keys) {
      chartBlock.ageing_bucket_keys = nested.ageing_bucket_keys;
    }
    if (!chartBlock.task_priority_keys && nested.task_priority_keys) {
      chartBlock.task_priority_keys = nested.task_priority_keys;
    }
    if (!chartBlock.priority_keys && nested.priority_keys) {
      chartBlock.priority_keys = nested.priority_keys;
    }
    if (!chartBlock.priority_labels && nested.priority_labels) {
      chartBlock.priority_labels = nested.priority_labels;
    }
    chartBlock.buckets = nested.data || nested.buckets || nested.values || chartBlock.buckets;
  }
  return true;
}

formatAmcManagementStatusChart(apiResponse: any, scope: 'my' | 'all') {
  const root = apiResponse && apiResponse.data ? apiResponse.data : null;
  if (!root) {
    return null;
  }
  const chartBlock = this.amcMgmtGetChartBlock(root, 'status');
  if (!chartBlock || !this.amcMgmtParseChartBuckets(chartBlock)) {
    return null;
  }

  const priorityKeys = this.amcMgmtResolvePriorityCategoryKeys(chartBlock);
  const statusLegendSource = chartBlock.status_legend || chartBlock.legend;
  const legendSeries = this.amcMgmtGetLegendSeries(statusLegendSource);
  const statusKeys = legendSeries.length
    ? legendSeries.map((s) => s.key)
    : (chartBlock.status_keys || []).map((k: any) => String(k));
  if (!priorityKeys.length || !statusKeys.length) {
    return null;
  }

  const labels: string[] = priorityKeys.map((k, i) => this.amcMgmtResolvePriorityCategoryLabel(chartBlock, k, i));
  const datasets: any[] = [];
  const items: any[] = [];
  let total = this.amcMgmtNum(chartBlock.total);
  if (!total && chartBlock.card && chartBlock.card.total != null) {
    total = this.amcMgmtNum(chartBlock.card.total);
  }

  let datasetIndex = 0;
  const legendMap = this.amcMgmtLegendMap(statusLegendSource);
  const seriesList = legendSeries.length
    ? legendSeries
    : statusKeys.map((statusKey) => {
      const meta = this.amcMgmtLegendMeta(legendMap, statusKey);
      return { key: statusKey, label: meta.label, color: meta.color };
    });

  for (const series of seriesList) {
    const statusKey = series.key;
    const barColor = series.color;
    const seriesData: number[] = [];
    for (let priorityIndex = 0; priorityIndex < priorityKeys.length; priorityIndex++) {
      const priorityKey = priorityKeys[priorityIndex];
      const count = this.amcMgmtStatusBucketCount(
        chartBlock.buckets,
        priorityKeys,
        statusKeys,
        priorityKey,
        statusKey
      );
      seriesData.push(count);
      items.push({
        priority_index: priorityIndex,
        dataset_index: datasetIndex,
        priority_key: priorityKey,
        priority_label: labels[priorityIndex],
        status_key: statusKey,
        status_label: series.label,
        count: count,
        chart_kind: 'status',
      });
    }
    datasets.push({
      label: series.label,
      data: seriesData,
      backgroundColor: barColor,
      borderColor: barColor,
      hoverBackgroundColor: barColor,
      stack: 'amc_status',
    });
    datasetIndex++;
  }

  const chartColors = datasets.map((ds) => ({
    backgroundColor: ds.backgroundColor,
    borderColor: ds.borderColor,
    hoverBackgroundColor: ds.hoverBackgroundColor,
  }));

  if (!total) {
    for (const item of items) {
      total += item.count;
    }
  }

  const stackTotals: number[] = priorityKeys.map((_, priorityIndex) =>
    datasets.reduce((sum, ds) => sum + this.amcMgmtNum(ds.data[priorityIndex]), 0)
  );
  const maxStackHeight = stackTotals.length ? Math.max.apply(null, stackTotals) : 0;

  let title = '';
  if (chartBlock.chart_title && String(chartBlock.chart_title).trim()) {
    title = String(chartBlock.chart_title).trim();
  } else if (chartBlock.card_label && String(chartBlock.card_label).trim()) {
    title = String(chartBlock.card_label).trim();
  } else {
    title = 'Status of Overdue Task';
  }

  const navKey = scope === 'all' ? 'amc_management_status_all' : 'amc_management_status_my';

  const legendItems = datasets.map((ds, index) => ({
    label: ds.label,
    color: ds.backgroundColor,
    datasetIndex: index,
    hidden: false,
  }));

  const sourceDatasets = datasets.map((ds) => ({
    label: ds.label,
    data: ds.data.slice(),
    backgroundColor: ds.backgroundColor,
    borderColor: ds.borderColor,
    hoverBackgroundColor: ds.hoverBackgroundColor,
    stack: ds.stack,
  }));

  return {
    title: title,
    total: total,
    labels: labels,
    datasets: datasets,
    chartColors: chartColors,
    legendItems: legendItems,
    _sourceDatasets: sourceDatasets,
    options: this.amcMgmtStatusChartOptions(maxStackHeight),
    barChartType: 'bar',
    barChartLegend: false,
    key: navKey,
    scope: scope,
    chart_kind: 'status',
    items: items,
    chartRevision: 1,
    canvasAlive: true,
  };
}

formatAmcManagementBarChart(
  apiResponse: any,
  scope: 'my' | 'all',
  chartKind: 'overdue' | 'status'
) {
  if (chartKind === 'status') {
    return this.formatAmcManagementStatusChart(apiResponse, scope);
  }
  const root = apiResponse && apiResponse.data ? apiResponse.data : null;
  if (!root) {
    return null;
  }
  const chartBlock = this.amcMgmtGetChartBlock(root, chartKind);
  if (!chartBlock || !this.amcMgmtParseChartBuckets(chartBlock)) {
    return null;
  }

  const ageingKeys = this.amcMgmtResolveAgeingKeys(chartBlock);
  const legendSource = chartBlock.legend || root.legend;
  const legendSeries = this.amcMgmtGetLegendSeries(legendSource);
  let legendMap = this.amcMgmtLegendMap(legendSource);
  legendMap = this.amcMgmtMergeLegendLabelsFromTaskPriority(chartBlock, legendMap);
  const priorityKeys = this.amcMgmtResolvePriorityKeys(chartBlock, legendMap);
  if (!ageingKeys.length || !priorityKeys.length) {
    return null;
  }

  const labels: string[] = ageingKeys.map((k, i) => this.amcMgmtResolveLabel(chartBlock, k, i));
  const datasets: any[] = [];
  const items: any[] = [];
  let total = this.amcMgmtNum(chartBlock.total);
  if (!total && chartBlock.card && chartBlock.card.total != null) {
    total = this.amcMgmtNum(chartBlock.card.total);
  }

  let datasetIndex = 0;
  const seriesList = legendSeries.length
    ? legendSeries
    : priorityKeys.map((priorityKey) => {
      const meta = this.amcMgmtLegendMeta(legendMap, priorityKey);
      return { key: priorityKey, label: meta.label, color: meta.color };
    });

  for (const series of seriesList) {
    const priorityKey = series.key;
    const barColor = series.color;
    const seriesData: number[] = [];
    for (let ageingIndex = 0; ageingIndex < ageingKeys.length; ageingIndex++) {
      const ageingKey = ageingKeys[ageingIndex];
      const count = this.amcMgmtBucketCount(
        chartBlock.buckets,
        ageingKeys,
        priorityKeys,
        ageingKey,
        priorityKey
      );
      seriesData.push(count);
      items.push({
        ageing_index: ageingIndex,
        dataset_index: datasetIndex,
        ageing_key: ageingKey,
        ageing_label: labels[ageingIndex],
        priority_key: priorityKey,
        priority_label: series.label,
        count: count,
        chart_kind: chartKind,
      });
    }
    datasets.push({
      label: series.label,
      data: seriesData,
      backgroundColor: barColor,
      borderColor: barColor,
      hoverBackgroundColor: barColor,
      stack: 'amc_overdue',
    });
    datasetIndex++;
  }

  const chartColors = datasets.map((ds) => ({
    backgroundColor: ds.backgroundColor,
    borderColor: ds.borderColor,
    hoverBackgroundColor: ds.hoverBackgroundColor,
  }));

  if (!total) {
    for (const item of items) {
      total += item.count;
    }
  }

  const stackTotals: number[] = ageingKeys.map((_, ageingIndex) =>
    datasets.reduce((sum, ds) => sum + this.amcMgmtNum(ds.data[ageingIndex]), 0)
  );
  const maxStackHeight = stackTotals.length ? Math.max.apply(null, stackTotals) : 0;

  let title = '';
  if (chartBlock.chart_title && String(chartBlock.chart_title).trim()) {
    title = String(chartBlock.chart_title).trim();
  } else if (chartBlock.card_label && String(chartBlock.card_label).trim()) {
    title = String(chartBlock.card_label).trim();
  } else if (chartKind === 'overdue' && root.chart_title) {
    title = String(root.chart_title);
  } else if (chartKind === 'overdue' && root.card_label) {
    title = String(root.card_label);
  } else if (apiResponse.message) {
    title = String(apiResponse.message);
  } else {
    title = 'Total OverDue Task';
  }

  const navKey = chartKind === 'overdue'
    ? (scope === 'all' ? 'amc_management_overdue_all' : 'amc_management_overdue_my')
    : '';

  const legendItems = datasets.map((ds, index) => ({
    label: ds.label,
    color: ds.backgroundColor,
    datasetIndex: index,
    hidden: false,
  }));

  const sourceDatasets = datasets.map((ds) => ({
    label: ds.label,
    data: ds.data.slice(),
    backgroundColor: ds.backgroundColor,
    borderColor: ds.borderColor,
    hoverBackgroundColor: ds.hoverBackgroundColor,
    stack: ds.stack,
  }));

  return {
    title: title,
    total: total,
    labels: labels,
    datasets: datasets,
    chartColors: chartColors,
    legendItems: legendItems,
    _sourceDatasets: sourceDatasets,
    options: this.amcMgmtOverdueChartOptions(maxStackHeight),
    barChartType: 'bar',
    barChartLegend: false,
    key: navKey,
    scope: scope,
    chart_kind: chartKind,
    items: items,
    chartRevision: 1,
    canvasAlive: true,
  };
}

getAmcManagementDashboard(scope: 'my' | 'all', onComplete?: () => void, chartKind: AmcMgmtChartKind = 'overdue') {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == 'vendor') {
    this.clearAmcManagementCharts(scope, chartKind);
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const routeUrl = scope === 'all' ? '/all-amc-tasks' : '/my-amc-task';
  if (!this.IS_VAILID_URL(routeUrl)) {
    this.clearAmcManagementCharts(scope, chartKind);
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const isInitChain = !!onComplete;
  if (isInitChain && chartKind === 'overdue') {
    if (scope === 'all') {
      this.amcManagementAllLoader = true;
    } else {
      this.amcManagementLoader = true;
    }
  }

  this.amcMgmtRequestGen[scope][chartKind]++;
  const requestId = this.amcMgmtRequestGen[scope][chartKind];

  const card = this.amcMgmtCard(scope, chartKind);
  const employee_id = scope === 'all' && card.employeeId ? card.employeeId : '';

  this.loadAmcManagementFilterOptions();

  const filters = this.amcMgmtGetScopeFilters(scope, chartKind);

  const obj: any = {
    user_id: this._localStorageService.getUserId() == undefined ? '0' : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
    scope: scope,
    employee_id: employee_id,
  };
  if (filters.lobId) {
    obj.lob = filters.lobId;
  }
  if (filters.locId) {
    obj.lob_location = filters.locId;
  }
  if (filters.departmentId) {
    obj.department = filters.departmentId;
  }

  this.runDashboardCounterHttp(
    'Amc_dashboard/ajax_management_dashboard',
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (requestId !== this.amcMgmtRequestGen[scope][chartKind]) {
        return;
      }
      const formatted = data && data.status
        ? this.formatAmcManagementBarChart(data, scope, chartKind)
        : null;
      this.amcMgmtApplyChartResult(scope, chartKind, formatted);
      if (isInitChain && chartKind === 'status') {
        this.amcMgmtClearScopeLoader(scope);
      }
    },
    () => {
      if (requestId !== this.amcMgmtRequestGen[scope][chartKind]) {
        return;
      }
      if (isInitChain && chartKind === 'status') {
        this.amcMgmtClearScopeLoader(scope);
      }
      if (isInitChain) {
        this.clearAmcManagementCharts(scope, chartKind);
      }
    }
  );
}

private amcMgmtPendingExtractRows(data: any, extraKeys: string[] = []): any[] {
  if (!data) {
    return [];
  }
  if (Array.isArray(data)) {
    return data;
  }
  const candidates = extraKeys.concat([
    'tasks', 'list', 'items', 'rows', 'pending_tasks', 'task_list',
    'critical_pending', 'critical_pending_list',
  ]);
  for (const key of candidates) {
    if (Array.isArray(data[key])) {
      return data[key];
    }
  }
  if (data.data && Array.isArray(data.data)) {
    return data.data;
  }
  if (data.data && Array.isArray(data.data.tasks)) {
    return data.data.tasks;
  }
  return [];
}

private amcMgmtPendingMapRow(row: any, index: number) {
  const daysRaw = row.days != null ? row.days
    : (row.overdue_days != null ? row.overdue_days
      : (row.no_of_days != null ? row.no_of_days : row.pending_days));
  const daysNum = this.amcMgmtNum(daysRaw);
  return {
    sno: row.sno != null ? row.sno : (row.s_no != null ? row.s_no : (row.serial_no != null ? row.serial_no : index + 1)),
    days: daysNum,
    task_name: row.task_name || row.task || row.name || row.title || '',
    task_name_short: row.task_name_short || row.short_task_name || row.task_short_name || '',
    description: row.description || row.task_description || '',
    task_description: row.task_description || row.description || '',
    due_date_display: row.due_date_display || row.due_date_text || '',
    employee_name: row.employee_name || row.emp_name || row.employee || row.assigned_to || '',
    task_id: row.task_id || row.id || row.amc_task_id || '',
    raw: row,
  };
}

formatAmcCriticalPending(apiResponse: any, scope: 'my' | 'all') {
  const data = apiResponse && apiResponse.data ? apiResponse.data : null;
  if (!data) {
    return null;
  }
  const title = (data.title || data.card_title || data.heading || 'Top 10 Critical Pending').toString().trim();
  const subtitle = (data.subtitle || data.card_subtitle || data.sub_title || '').toString().trim();
  const rows = this.amcMgmtPendingExtractRows(data).slice(0, 10)
    .map((row: any, index: number) => this.amcMgmtPendingMapRow(row, index));
  return {
    title: title,
    subtitle: subtitle,
    rows: rows,
    scope: scope,
    has_view_more: data.has_view_more === true,
    key: scope === 'all' ? 'amc_critical_pending_all' : 'amc_critical_pending_my',
  };
}

formatAmcCompliancePending(apiResponse: any, scope: 'my' | 'all') {
  const data = apiResponse && apiResponse.data ? apiResponse.data : null;
  if (!data) {
    return null;
  }
  const title = (data.title || data.card_title || data.heading || 'Top 10 Compliance Pending').toString().trim();
  const subtitle = (data.subtitle || data.card_subtitle || data.sub_title || '').toString().trim();
  const rows = this.amcMgmtPendingExtractRows(data, ['compliance_pending', 'compliance_pending_list']).slice(0, 10)
    .map((row: any, index: number) => this.amcMgmtPendingMapRow(row, index));
  return {
    title: title,
    subtitle: subtitle,
    rows: rows,
    scope: scope,
    has_view_more: data.has_view_more === true,
    key: scope === 'all' ? 'amc_compliance_pending_all' : 'amc_compliance_pending_my',
  };
}

private amcCriticalGetScopeFilters(scope: 'my' | 'all') {
  if (scope === 'all') {
    return { lobId: this.amcCriticalAllLobId, locId: this.amcCriticalAllLocId, departmentId: this.amcCriticalAllDepartmentId };
  }
  return { lobId: this.amcCriticalMyLobId, locId: this.amcCriticalMyLocId, departmentId: this.amcCriticalMyDepartmentId };
}

private amcComplianceGetScopeFilters(scope: 'my' | 'all') {
  if (scope === 'all') {
    return { lobId: this.amcComplianceAllLobId, locId: this.amcComplianceAllLocId, departmentId: this.amcComplianceAllDepartmentId };
  }
  return { lobId: this.amcComplianceMyLobId, locId: this.amcComplianceMyLocId, departmentId: this.amcComplianceMyDepartmentId };
}

private amcMgmtBuildPendingListPayload(scope: 'my' | 'all', target: 'critical' | 'compliance'): any {
  const filters = target === 'critical' ? this.amcCriticalGetScopeFilters(scope) : this.amcComplianceGetScopeFilters(scope);
  const employeeId = scope === 'all'
    ? (target === 'critical' ? this.amcCriticalAllEmployeeId : this.amcComplianceAllEmployeeId)
    : '';
  const obj: any = {
    user_id: this._localStorageService.getUserId() == undefined ? '0' : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
    scope: scope,
    employee_id: employeeId || '',
  };
  if (filters.lobId) { obj.lob = filters.lobId; }
  if (filters.locId) { obj.lob_location = filters.locId; }
  if (filters.departmentId) { obj.department = filters.departmentId; }
  return obj;
}

getAmcCriticalPending(scope: 'my' | 'all', onComplete?: () => void) {
  if (!this.isDashboardActive()) { return; }
  const routeUrl = scope === 'all' ? '/all-amc-tasks' : '/my-amc-task';
  if (this._localStorageService.getUserRole() == 'vendor' || !this.IS_VAILID_URL(routeUrl)) {
    if (scope === 'all') { this.amcCriticalPendingAll = null; this.amcCriticalPendingAllVisible = false; }
    else { this.amcCriticalPendingMy = null; this.amcCriticalPendingMyVisible = false; }
    this.continueDashboardCounterChain(onComplete);
    return;
  }
  if (scope === 'all') { this.amcCriticalPendingAllLoader = true; } else { this.amcCriticalPendingLoader = true; }
  this.loadAmcManagementFilterOptions();
  if (scope === 'all') { this.maybeFetchAmcManagementEmployees(); }
  this.runDashboardCounterHttp(
    'Amc_dashboard/ajax_management_critical_pending',
    this.amcMgmtBuildPendingListPayload(scope, 'critical'),
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (res) => {
      const next = res && res.status ? this.formatAmcCriticalPending(res, scope) : null;
      if (scope === 'all') {
        this.amcCriticalPendingAllLoader = false;
        this.amcCriticalPendingAll = next;
        this.amcCriticalPendingAllVisible = !!next;
      } else {
        this.amcCriticalPendingLoader = false;
        this.amcCriticalPendingMy = next;
        this.amcCriticalPendingMyVisible = !!next;
      }
    },
    () => {
      if (scope === 'all') { this.amcCriticalPendingAllLoader = false; this.amcCriticalPendingAll = null; this.amcCriticalPendingAllVisible = false; }
      else { this.amcCriticalPendingLoader = false; this.amcCriticalPendingMy = null; this.amcCriticalPendingMyVisible = false; }
    }
  );
}

getAmcCompliancePending(scope: 'my' | 'all', onComplete?: () => void) {
  if (!this.isDashboardActive()) { return; }
  const routeUrl = scope === 'all' ? '/all-amc-tasks' : '/my-amc-task';
  if (this._localStorageService.getUserRole() == 'vendor' || !this.IS_VAILID_URL(routeUrl)) {
    if (scope === 'all') { this.amcCompliancePendingAll = null; this.amcCompliancePendingAllVisible = false; }
    else { this.amcCompliancePendingMy = null; this.amcCompliancePendingMyVisible = false; }
    this.continueDashboardCounterChain(onComplete);
    return;
  }
  if (scope === 'all') { this.amcCompliancePendingAllLoader = true; } else { this.amcCompliancePendingLoader = true; }
  this.loadAmcManagementFilterOptions();
  if (scope === 'all') { this.maybeFetchAmcManagementEmployees(); }
  this.runDashboardCounterHttp(
    'Amc_dashboard/ajax_management_compliance_pending',
    this.amcMgmtBuildPendingListPayload(scope, 'compliance'),
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (res) => {
      const next = res && res.status ? this.formatAmcCompliancePending(res, scope) : null;
      if (scope === 'all') {
        this.amcCompliancePendingAllLoader = false;
        this.amcCompliancePendingAll = next;
        this.amcCompliancePendingAllVisible = !!next;
      } else {
        this.amcCompliancePendingLoader = false;
        this.amcCompliancePendingMy = next;
        this.amcCompliancePendingMyVisible = !!next;
      }
    },
    () => {
      if (scope === 'all') { this.amcCompliancePendingAllLoader = false; this.amcCompliancePendingAll = null; this.amcCompliancePendingAllVisible = false; }
      else { this.amcCompliancePendingLoader = false; this.amcCompliancePendingMy = null; this.amcCompliancePendingMyVisible = false; }
    }
  );
}

onAmcPendingTaskHover(event: MouseEvent, row: any) {
  if (!row || !row.task_name) {
    return;
  }
  const el = event.currentTarget as HTMLElement;
  const rect = el.getBoundingClientRect();
  const tooltipWidth = 300;
  const gap = 12;
  let left = rect.right + gap;
  let flip = false;

  if (left + tooltipWidth > window.innerWidth - 16) {
    left = rect.left - gap - tooltipWidth;
    flip = true;
  }
  if (left < 8) {
    left = 8;
  }

  this.amcPendingTaskHover = row;
  this.amcPendingTaskHoverTop = rect.top + (rect.height / 2);
  this.amcPendingTaskHoverLeft = left;
  this.amcPendingTaskHoverFlip = flip;
}

onAmcPendingTaskHoverEnd() {
  this.amcPendingTaskHover = null;
}


private amcMgmtSyncDerivedFilteredLists() {
  this.amcMgmtSyncManagementCardFilteredLists();
  this.amcAgeingSyncFilteredLists();
  this.filteredAmcCriticalMyLobList = this.amcManagementLobList.slice();
  this.filteredAmcCriticalAllLobList = this.amcManagementLobList.slice();
  this.filteredAmcCriticalMyDepartmentList = this.amcManagementDepartmentList.slice();
  this.filteredAmcCriticalAllDepartmentList = this.amcManagementDepartmentList.slice();
  this.filteredAmcCriticalMyLocList = this.amcManagementLocList.slice();
  this.filteredAmcCriticalAllLocList = this.amcManagementLocList.slice();
  this.filteredAmcComplianceMyLobList = this.amcManagementLobList.slice();
  this.filteredAmcComplianceAllLobList = this.amcManagementLobList.slice();
  this.filteredAmcComplianceMyDepartmentList = this.amcManagementDepartmentList.slice();
  this.filteredAmcComplianceAllDepartmentList = this.amcManagementDepartmentList.slice();
  this.filteredAmcComplianceMyLocList = this.amcManagementLocList.slice();
  this.filteredAmcComplianceAllLocList = this.amcManagementLocList.slice();
}

private amcMgmtGetLocSearchTerm(
  scope: 'my' | 'all',
  target: 'management' | 'critical' | 'compliance' | 'ageing',
  chartKind?: AmcMgmtChartKind
): string {
  if (target === 'critical') {
    return scope === 'all' ? this.amcCriticalAllLocSearchTerm : this.amcCriticalMyLocSearchTerm;
  }
  if (target === 'compliance') {
    return scope === 'all' ? this.amcComplianceAllLocSearchTerm : this.amcComplianceMyLocSearchTerm;
  }
  if (target === 'ageing') {
    return scope === 'all' ? this.amcAgeingAllLocSearchTerm : this.amcAgeingMyLocSearchTerm;
  }
  const kind = chartKind || this.amcManagementLastLocSearchChartKind || 'overdue';
  return this.amcMgmtCard(scope, kind).locSearchTerm;
}

private amcMgmtIsActiveLocSearch(
  scope: 'my' | 'all',
  target: 'management' | 'critical' | 'compliance' | 'ageing',
  query: string,
  chartKind?: AmcMgmtChartKind
): boolean {
  return this.amcMgmtGetLocSearchTerm(scope, target, chartKind).trim() === (query || '').trim();
}

private amcMgmtSetLocFilteredList(
  scope: 'my' | 'all',
  target: 'management' | 'critical' | 'compliance' | 'ageing',
  list: Array<{ id: any; label: string }>,
  chartKind?: AmcMgmtChartKind
) {
  if (target === 'critical') {
    if (scope === 'all') {
      this.filteredAmcCriticalAllLocList = list;
    } else {
      this.filteredAmcCriticalMyLocList = list;
    }
    return;
  }
  if (target === 'compliance') {
    if (scope === 'all') {
      this.filteredAmcComplianceAllLocList = list;
    } else {
      this.filteredAmcComplianceMyLocList = list;
    }
    return;
  }
  if (target === 'ageing') {
    if (scope === 'all') {
      this.filteredAmcAgeingAllLocList = list;
    } else {
      this.filteredAmcAgeingMyLocList = list;
    }
    return;
  }
  const kind = chartKind || this.amcManagementLastLocSearchChartKind || 'overdue';
  this.amcMgmtCard(scope, kind).filteredLocList = list;
}

private closeAmcCriticalFilterDropdowns(scope: 'my' | 'all') {
  if (scope === 'all') {
    this.isAmcCriticalAllLobDropdownOpen = false;
    this.isAmcCriticalAllLocDropdownOpen = false;
    this.isAmcCriticalAllDepartmentDropdownOpen = false;
    this.isAmcCriticalEmployeeDropdownOpen = false;
    return;
  }
  this.isAmcCriticalMyLobDropdownOpen = false;
  this.isAmcCriticalMyLocDropdownOpen = false;
  this.isAmcCriticalMyDepartmentDropdownOpen = false;
}

private closeAmcComplianceFilterDropdowns(scope: 'my' | 'all') {
  if (scope === 'all') {
    this.isAmcComplianceAllLobDropdownOpen = false;
    this.isAmcComplianceAllLocDropdownOpen = false;
    this.isAmcComplianceAllDepartmentDropdownOpen = false;
    this.isAmcComplianceEmployeeDropdownOpen = false;
    return;
  }
  this.isAmcComplianceMyLobDropdownOpen = false;
  this.isAmcComplianceMyLocDropdownOpen = false;
  this.isAmcComplianceMyDepartmentDropdownOpen = false;
}

private refreshAmcCriticalScope(scope: 'my' | 'all') {
  this.getAmcCriticalPending(scope);
}

private refreshAmcComplianceScope(scope: 'my' | 'all') {
  this.getAmcCompliancePending(scope);
}

onAmcCriticalFilterClear(filter: 'lob' | 'loc' | 'department' | 'employee', scope: 'my' | 'all', event: Event) {
  event.preventDefault();
  event.stopPropagation();
  if (filter === 'lob') {
    this.onAmcCriticalLobSearch('', scope);
    this.onAmcCriticalLobSelected('', scope);
  } else if (filter === 'loc') {
    this.onAmcCriticalLocSearch('', scope);
    this.onAmcCriticalLocSelected('', scope);
  } else if (filter === 'department') {
    this.onAmcCriticalDepartmentSearch('', scope);
    this.onAmcCriticalDepartmentSelected('', scope);
  } else if (filter === 'employee' && scope === 'all') {
    this.onAmcCriticalAllEmployeeSelected('', '');
  }
  this.closeAmcCriticalFilterDropdowns(scope);
}

onAmcComplianceFilterClear(filter: 'lob' | 'loc' | 'department' | 'employee', scope: 'my' | 'all', event: Event) {
  event.preventDefault();
  event.stopPropagation();
  if (filter === 'lob') {
    this.onAmcComplianceLobSearch('', scope);
    this.onAmcComplianceLobSelected('', scope);
  } else if (filter === 'loc') {
    this.onAmcComplianceLocSearch('', scope);
    this.onAmcComplianceLocSelected('', scope);
  } else if (filter === 'department') {
    this.onAmcComplianceDepartmentSearch('', scope);
    this.onAmcComplianceDepartmentSelected('', scope);
  } else if (filter === 'employee' && scope === 'all') {
    this.onAmcComplianceAllEmployeeSelected('', '');
  }
  this.closeAmcComplianceFilterDropdowns(scope);
}

onAmcCriticalLobSelected(lobId: any, scope: 'my' | 'all', label?: string) {
  const value = lobId != null && String(lobId).trim() !== '' ? String(lobId) : '';
  const lbl = value ? (label || this.amcMgmtFindLobLabel(value)) : '';
  if (scope === 'all') {
    this.amcCriticalAllLobId = value;
    this.amcCriticalAllLobLabel = lbl;
    this.isAmcCriticalAllLobDropdownOpen = false;
    this.amcCriticalAllLobSearchTerm = '';
    this.filteredAmcCriticalAllLobList = this.amcManagementLobList.slice();
  } else {
    this.amcCriticalMyLobId = value;
    this.amcCriticalMyLobLabel = lbl;
    this.isAmcCriticalMyLobDropdownOpen = false;
    this.amcCriticalMyLobSearchTerm = '';
    this.filteredAmcCriticalMyLobList = this.amcManagementLobList.slice();
  }
  this.refreshAmcCriticalScope(scope);
}

onAmcCriticalDepartmentSelected(departmentId: any, scope: 'my' | 'all', label?: string) {
  const value = departmentId != null && String(departmentId).trim() !== '' ? String(departmentId) : '';
  const lbl = value ? (label || this.amcMgmtFindDepartmentLabel(value)) : '';
  if (scope === 'all') {
    this.amcCriticalAllDepartmentId = value;
    this.amcCriticalAllDepartmentLabel = lbl;
    this.isAmcCriticalAllDepartmentDropdownOpen = false;
    this.amcCriticalAllDepartmentSearchTerm = '';
    this.filteredAmcCriticalAllDepartmentList = this.amcManagementDepartmentList.slice();
  } else {
    this.amcCriticalMyDepartmentId = value;
    this.amcCriticalMyDepartmentLabel = lbl;
    this.isAmcCriticalMyDepartmentDropdownOpen = false;
    this.amcCriticalMyDepartmentSearchTerm = '';
    this.filteredAmcCriticalMyDepartmentList = this.amcManagementDepartmentList.slice();
  }
  this.refreshAmcCriticalScope(scope);
}

onAmcCriticalLocSelected(locId: any, scope: 'my' | 'all') {
  const value = locId != null && String(locId).trim() !== '' ? String(locId) : '';
  const label = value ? this.amcMgmtFindLocLabel(value, scope) : '';
  if (scope === 'all') {
    this.amcCriticalAllLocId = value;
    this.amcCriticalAllLocLabel = label;
    this.isAmcCriticalAllLocDropdownOpen = false;
    this.amcCriticalAllLocSearchTerm = '';
    this.filteredAmcCriticalAllLocList = this.amcManagementLocList.slice();
  } else {
    this.amcCriticalMyLocId = value;
    this.amcCriticalMyLocLabel = label;
    this.isAmcCriticalMyLocDropdownOpen = false;
    this.amcCriticalMyLocSearchTerm = '';
    this.filteredAmcCriticalMyLocList = this.amcManagementLocList.slice();
  }
  this.refreshAmcCriticalScope(scope);
}

getAmcCriticalSelectedLobLabel(scope: 'my' | 'all'): string {
  const lobId = scope === 'all' ? this.amcCriticalAllLobId : this.amcCriticalMyLobId;
  if (!lobId) {
    return 'LOB';
  }
  const storedLabel = scope === 'all' ? this.amcCriticalAllLobLabel : this.amcCriticalMyLobLabel;
  return storedLabel || this.amcMgmtFindLobLabel(lobId) || 'LOB';
}

getAmcCriticalSelectedDepartmentLabel(scope: 'my' | 'all'): string {
  const departmentId = scope === 'all' ? this.amcCriticalAllDepartmentId : this.amcCriticalMyDepartmentId;
  if (!departmentId) {
    return 'Department';
  }
  const storedLabel = scope === 'all' ? this.amcCriticalAllDepartmentLabel : this.amcCriticalMyDepartmentLabel;
  return storedLabel || this.amcMgmtFindDepartmentLabel(departmentId) || 'Department';
}

getAmcCriticalSelectedLocLabel(scope: 'my' | 'all'): string {
  const locId = scope === 'all' ? this.amcCriticalAllLocId : this.amcCriticalMyLocId;
  if (!locId) {
    return 'LOC';
  }
  const storedLabel = scope === 'all' ? this.amcCriticalAllLocLabel : this.amcCriticalMyLocLabel;
  return storedLabel || this.amcMgmtFindLocLabel(locId, scope) || 'LOC';
}

getAmcCriticalSelectedEmployeeLabel(): string {
  return this.amcCriticalAllEmployeeName ? this.amcCriticalAllEmployeeName : 'Employee';
}

onAmcCriticalAllEmployeeSelected(employeeId: any, employeeName?: string) {
  if (employeeId && typeof employeeId === 'object' && employeeId.id !== undefined) {
    employeeName = employeeId.name;
    employeeId = employeeId.id;
  }
  this.amcCriticalAllEmployeeId = employeeId ? String(employeeId) : '';
  this.amcCriticalAllEmployeeName = employeeName ? String(employeeName).trim() : '';
  this.isAmcCriticalEmployeeDropdownOpen = false;
  this.amcSharedEmployeeSearchTerm = '';
  this.onAmcManagementEmployeeSearch('');
  this.getAmcCriticalPending('all');
}

toggleAmcCriticalEmployeeDropdown() {
  const opening = !this.isAmcCriticalEmployeeDropdownOpen;
  this.closeAmcCriticalFilterDropdowns('all');
  this.closeAmcManagementFilterDropdowns('all');
  this.closeAmcComplianceFilterDropdowns('all');
  this.isAmcCriticalEmployeeDropdownOpen = opening;
  if (opening) {
    this.maybeFetchAmcManagementEmployees();
    this.onAmcManagementEmployeeSearch(this.amcSharedEmployeeSearchTerm);
  }
}

toggleAmcCriticalLobDropdown(scope: 'my' | 'all') {
  if (scope === 'all') {
    const opening = !this.isAmcCriticalAllLobDropdownOpen;
    this.closeAmcCriticalFilterDropdowns('all');
    this.isAmcCriticalAllLobDropdownOpen = opening;
    if (opening) {
      this.onAmcCriticalLobSearch(this.amcCriticalAllLobSearchTerm, 'all');
    }
    return;
  }
  const opening = !this.isAmcCriticalMyLobDropdownOpen;
  this.closeAmcCriticalFilterDropdowns('my');
  this.isAmcCriticalMyLobDropdownOpen = opening;
  if (opening) {
    this.onAmcCriticalLobSearch(this.amcCriticalMyLobSearchTerm, 'my');
  }
}

toggleAmcCriticalDepartmentDropdown(scope: 'my' | 'all') {
  if (scope === 'all') {
    const opening = !this.isAmcCriticalAllDepartmentDropdownOpen;
    this.closeAmcCriticalFilterDropdowns('all');
    this.isAmcCriticalAllDepartmentDropdownOpen = opening;
    if (opening) {
      this.onAmcCriticalDepartmentSearch(this.amcCriticalAllDepartmentSearchTerm, 'all');
    }
    return;
  }
  const opening = !this.isAmcCriticalMyDepartmentDropdownOpen;
  this.closeAmcCriticalFilterDropdowns('my');
  this.isAmcCriticalMyDepartmentDropdownOpen = opening;
  if (opening) {
    this.onAmcCriticalDepartmentSearch(this.amcCriticalMyDepartmentSearchTerm, 'my');
  }
}

toggleAmcCriticalLocDropdown(scope: 'my' | 'all') {
  if (scope === 'all') {
    const opening = !this.isAmcCriticalAllLocDropdownOpen;
    this.closeAmcCriticalFilterDropdowns('all');
    this.isAmcCriticalAllLocDropdownOpen = opening;
    if (opening) {
      this.onAmcCriticalLocSearch(this.amcCriticalAllLocSearchTerm, 'all');
      if (!this.amcManagementLocList.length) {
        this.fetchAmcManagementLocationList('', 'all', 'critical');
      }
    }
    return;
  }
  const opening = !this.isAmcCriticalMyLocDropdownOpen;
  this.closeAmcCriticalFilterDropdowns('my');
  this.isAmcCriticalMyLocDropdownOpen = opening;
  if (opening) {
    this.onAmcCriticalLocSearch(this.amcCriticalMyLocSearchTerm, 'my');
    if (!this.amcManagementLocList.length) {
      this.fetchAmcManagementLocationList('', 'my', 'critical');
    }
  }
}

onAmcCriticalLobSearch(term: string, scope: 'my' | 'all') {
  const q = (term || '').trim().toLowerCase();
  if (scope === 'all') {
    this.amcCriticalAllLobSearchTerm = term || '';
    this.filteredAmcCriticalAllLobList = !q
      ? this.amcManagementLobList.slice()
      : this.amcManagementLobList.filter((x) =>
        (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
      );
    return;
  }
  this.amcCriticalMyLobSearchTerm = term || '';
  this.filteredAmcCriticalMyLobList = !q
    ? this.amcManagementLobList.slice()
    : this.amcManagementLobList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
}

onAmcCriticalDepartmentSearch(term: string, scope: 'my' | 'all') {
  const q = (term || '').trim().toLowerCase();
  if (scope === 'all') {
    this.amcCriticalAllDepartmentSearchTerm = term || '';
    this.filteredAmcCriticalAllDepartmentList = !q
      ? this.amcManagementDepartmentList.slice()
      : this.amcManagementDepartmentList.filter((x) =>
        (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
      );
    return;
  }
  this.amcCriticalMyDepartmentSearchTerm = term || '';
  this.filteredAmcCriticalMyDepartmentList = !q
    ? this.amcManagementDepartmentList.slice()
    : this.amcManagementDepartmentList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
}

onAmcCriticalLocSearch(term: string, scope: 'my' | 'all') {
  const raw = (term || '').trim();
  const q = raw.toLowerCase();
  if (scope === 'all') {
    this.amcCriticalAllLocSearchTerm = term || '';
    if (this.amcCriticalAllLocSearchDebounceRef) {
      clearTimeout(this.amcCriticalAllLocSearchDebounceRef);
      this.amcCriticalAllLocSearchDebounceRef = null;
    }
    if (!raw) {
      this.filteredAmcCriticalAllLocList = this.amcManagementLocList.slice();
      return;
    }
    if (raw.length >= 2) {
      this.amcCriticalAllLocSearchDebounceRef = setTimeout(() => {
        this.fetchAmcManagementLocationList(raw, 'all', 'critical');
      }, 300);
      return;
    }
    this.filteredAmcCriticalAllLocList = this.amcManagementLocList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
    return;
  }
  this.amcCriticalMyLocSearchTerm = term || '';
  if (this.amcCriticalMyLocSearchDebounceRef) {
    clearTimeout(this.amcCriticalMyLocSearchDebounceRef);
    this.amcCriticalMyLocSearchDebounceRef = null;
  }
  if (!raw) {
    this.filteredAmcCriticalMyLocList = this.amcManagementLocList.slice();
    return;
  }
  if (raw.length >= 2) {
    this.amcCriticalMyLocSearchDebounceRef = setTimeout(() => {
      this.fetchAmcManagementLocationList(raw, 'my', 'critical');
    }, 300);
    return;
  }
  this.filteredAmcCriticalMyLocList = this.amcManagementLocList.filter((x) =>
    (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
  );
}

onAmcPendingViewMoreClick(scope: 'my' | 'all', kind: 'critical' | 'compliance') {
  const filters = kind === 'critical' ? this.amcCriticalGetScopeFilters(scope) : this.amcComplianceGetScopeFilters(scope);
  const employeeId = scope === 'all' && (kind === 'critical' ? this.amcCriticalAllEmployeeId : this.amcComplianceAllEmployeeId)
    ? String(kind === 'critical' ? this.amcCriticalAllEmployeeId : this.amcComplianceAllEmployeeId)
    : '';
  const lob = filters.lobId ? String(filters.lobId) : '';
  const lobLocation = filters.locId ? String(filters.locId) : '';
  const department = filters.departmentId ? String(filters.departmentId) : '';
  const dashboardCardType = scope === 'all' ? 'all_overdue' : 'my_overdue';
  const taskPriority = kind === 'critical' ? 'business_critical' : 'compliance';
  localStorage.setItem('dashboard_card_type', dashboardCardType);
  localStorage.setItem('scope', scope);
  localStorage.setItem('task_priority', taskPriority);
  localStorage.setItem('status_bucket', '');
  localStorage.removeItem('ageing_bucket');
  if (employeeId) { localStorage.setItem('employee_id', employeeId); } else { localStorage.removeItem('employee_id'); }
  if (lob) { localStorage.setItem('lob', lob); } else { localStorage.removeItem('lob'); }
  if (lobLocation) { localStorage.setItem('lob_location', lobLocation); } else { localStorage.removeItem('lob_location'); }
  if (department) { localStorage.setItem('department', department); } else { localStorage.removeItem('department'); }
  localStorage.setItem(
    scope === 'all' ? 'amc_management_dashboard_all_filter' : 'amc_management_dashboard_filter',
    this.eesdesService.set(JSON.stringify({
      scope: scope,
      dashboard_card_type: dashboardCardType,
      task_priority: taskPriority,
      status_bucket: '',
      employee_id: employeeId,
      lob: lob,
      lob_location: lobLocation,
      department: department,
    }))
  );
  localStorage.setItem('dashboard_navigation_source', scope === 'all' ? 'amc_management_overdue_all' : 'amc_management_overdue_my');
  window.location.href = window.location.origin + '/master/#' + (scope === 'all' ? '/all-amc-tasks' : '/my-amc-task');
}

onAmcCriticalPendingRowClick(scope: 'my' | 'all', row: any) {
  if (!row) {
    return;
  }
  const filters = this.amcCriticalGetScopeFilters(scope);
  const employeeId = scope === 'all' && this.amcCriticalAllEmployeeId
    ? String(this.amcCriticalAllEmployeeId)
    : '';
  const dashboardCardType = scope === 'all' ? 'all_critical_pending' : 'my_critical_pending';
  const filterData: any = {
    scope: scope,
    dashboard_card_type: dashboardCardType,
    task_id: row.task_id ? String(row.task_id) : '',
    task_name: row.task_name,
    employee_name: row.employee_name,
    days: row.days,
    overdue_days: row.days,
    employee_id: employeeId,
    lob: filters.lobId ? String(filters.lobId) : '',
    lob_location: filters.locId ? String(filters.locId) : '',
    department: filters.departmentId ? String(filters.departmentId) : '',
  };
  localStorage.setItem('dashboard_card_type', dashboardCardType);
  localStorage.setItem('scope', scope);
  if (filterData.task_id) {
    localStorage.setItem('task_id', filterData.task_id);
  }
  if (employeeId) {
    localStorage.setItem('employee_id', employeeId);
  }
  if (filterData.lob) {
    localStorage.setItem('lob', filterData.lob);
  }
  if (filterData.lob_location) {
    localStorage.setItem('lob_location', filterData.lob_location);
  }
  if (filterData.department) {
    localStorage.setItem('department', filterData.department);
  }
  localStorage.setItem(
    scope === 'all' ? 'amc_critical_pending_all_filter' : 'amc_critical_pending_my_filter',
    this.eesdesService.set(JSON.stringify(filterData))
  );
  localStorage.setItem('dashboard_navigation_source', scope === 'all' ? 'amc_critical_pending_all' : 'amc_critical_pending_my');
  const url = scope === 'all' ? '/all-amc-tasks' : '/my-amc-task';
  window.location.href = window.location.origin + '/master/#' + url;
}

onAmcComplianceLobSelected(lobId: any, scope: 'my' | 'all', label?: string) {
  const value = lobId != null && String(lobId).trim() !== '' ? String(lobId) : '';
  const lbl = value ? (label || this.amcMgmtFindLobLabel(value)) : '';
  if (scope === 'all') {
    this.amcComplianceAllLobId = value;
    this.amcComplianceAllLobLabel = lbl;
    this.isAmcComplianceAllLobDropdownOpen = false;
    this.amcComplianceAllLobSearchTerm = '';
    this.filteredAmcComplianceAllLobList = this.amcManagementLobList.slice();
  } else {
    this.amcComplianceMyLobId = value;
    this.amcComplianceMyLobLabel = lbl;
    this.isAmcComplianceMyLobDropdownOpen = false;
    this.amcComplianceMyLobSearchTerm = '';
    this.filteredAmcComplianceMyLobList = this.amcManagementLobList.slice();
  }
  this.refreshAmcComplianceScope(scope);
}

onAmcComplianceDepartmentSelected(departmentId: any, scope: 'my' | 'all', label?: string) {
  const value = departmentId != null && String(departmentId).trim() !== '' ? String(departmentId) : '';
  const lbl = value ? (label || this.amcMgmtFindDepartmentLabel(value)) : '';
  if (scope === 'all') {
    this.amcComplianceAllDepartmentId = value;
    this.amcComplianceAllDepartmentLabel = lbl;
    this.isAmcComplianceAllDepartmentDropdownOpen = false;
    this.amcComplianceAllDepartmentSearchTerm = '';
    this.filteredAmcComplianceAllDepartmentList = this.amcManagementDepartmentList.slice();
  } else {
    this.amcComplianceMyDepartmentId = value;
    this.amcComplianceMyDepartmentLabel = lbl;
    this.isAmcComplianceMyDepartmentDropdownOpen = false;
    this.amcComplianceMyDepartmentSearchTerm = '';
    this.filteredAmcComplianceMyDepartmentList = this.amcManagementDepartmentList.slice();
  }
  this.refreshAmcComplianceScope(scope);
}

onAmcComplianceLocSelected(locId: any, scope: 'my' | 'all') {
  const value = locId != null && String(locId).trim() !== '' ? String(locId) : '';
  const label = value ? this.amcMgmtFindLocLabel(value, scope) : '';
  if (scope === 'all') {
    this.amcComplianceAllLocId = value;
    this.amcComplianceAllLocLabel = label;
    this.isAmcComplianceAllLocDropdownOpen = false;
    this.amcComplianceAllLocSearchTerm = '';
    this.filteredAmcComplianceAllLocList = this.amcManagementLocList.slice();
  } else {
    this.amcComplianceMyLocId = value;
    this.amcComplianceMyLocLabel = label;
    this.isAmcComplianceMyLocDropdownOpen = false;
    this.amcComplianceMyLocSearchTerm = '';
    this.filteredAmcComplianceMyLocList = this.amcManagementLocList.slice();
  }
  this.refreshAmcComplianceScope(scope);
}

getAmcComplianceSelectedLobLabel(scope: 'my' | 'all'): string {
  const lobId = scope === 'all' ? this.amcComplianceAllLobId : this.amcComplianceMyLobId;
  if (!lobId) {
    return 'LOB';
  }
  const storedLabel = scope === 'all' ? this.amcComplianceAllLobLabel : this.amcComplianceMyLobLabel;
  return storedLabel || this.amcMgmtFindLobLabel(lobId) || 'LOB';
}

getAmcComplianceSelectedDepartmentLabel(scope: 'my' | 'all'): string {
  const departmentId = scope === 'all' ? this.amcComplianceAllDepartmentId : this.amcComplianceMyDepartmentId;
  if (!departmentId) {
    return 'Department';
  }
  const storedLabel = scope === 'all' ? this.amcComplianceAllDepartmentLabel : this.amcComplianceMyDepartmentLabel;
  return storedLabel || this.amcMgmtFindDepartmentLabel(departmentId) || 'Department';
}

getAmcComplianceSelectedLocLabel(scope: 'my' | 'all'): string {
  const locId = scope === 'all' ? this.amcComplianceAllLocId : this.amcComplianceMyLocId;
  if (!locId) {
    return 'LOC';
  }
  const storedLabel = scope === 'all' ? this.amcComplianceAllLocLabel : this.amcComplianceMyLocLabel;
  return storedLabel || this.amcMgmtFindLocLabel(locId, scope) || 'LOC';
}

getAmcComplianceSelectedEmployeeLabel(): string {
  return this.amcComplianceAllEmployeeName ? this.amcComplianceAllEmployeeName : 'Employee';
}

onAmcComplianceAllEmployeeSelected(employeeId: any, employeeName?: string) {
  if (employeeId && typeof employeeId === 'object' && employeeId.id !== undefined) {
    employeeName = employeeId.name;
    employeeId = employeeId.id;
  }
  this.amcComplianceAllEmployeeId = employeeId ? String(employeeId) : '';
  this.amcComplianceAllEmployeeName = employeeName ? String(employeeName).trim() : '';
  this.isAmcComplianceEmployeeDropdownOpen = false;
  this.amcSharedEmployeeSearchTerm = '';
  this.onAmcManagementEmployeeSearch('');
  this.getAmcCompliancePending('all');
}

toggleAmcComplianceEmployeeDropdown() {
  const opening = !this.isAmcComplianceEmployeeDropdownOpen;
  this.closeAmcComplianceFilterDropdowns('all');
  this.closeAmcManagementFilterDropdowns('all');
  this.closeAmcCriticalFilterDropdowns('all');
  this.isAmcComplianceEmployeeDropdownOpen = opening;
  if (opening) {
    this.maybeFetchAmcManagementEmployees();
    this.onAmcManagementEmployeeSearch(this.amcSharedEmployeeSearchTerm);
  }
}

toggleAmcComplianceLobDropdown(scope: 'my' | 'all') {
  if (scope === 'all') {
    const opening = !this.isAmcComplianceAllLobDropdownOpen;
    this.closeAmcComplianceFilterDropdowns('all');
    this.isAmcComplianceAllLobDropdownOpen = opening;
    if (opening) {
      this.onAmcComplianceLobSearch(this.amcComplianceAllLobSearchTerm, 'all');
    }
    return;
  }
  const opening = !this.isAmcComplianceMyLobDropdownOpen;
  this.closeAmcComplianceFilterDropdowns('my');
  this.isAmcComplianceMyLobDropdownOpen = opening;
  if (opening) {
    this.onAmcComplianceLobSearch(this.amcComplianceMyLobSearchTerm, 'my');
  }
}

toggleAmcComplianceDepartmentDropdown(scope: 'my' | 'all') {
  if (scope === 'all') {
    const opening = !this.isAmcComplianceAllDepartmentDropdownOpen;
    this.closeAmcComplianceFilterDropdowns('all');
    this.isAmcComplianceAllDepartmentDropdownOpen = opening;
    if (opening) {
      this.onAmcComplianceDepartmentSearch(this.amcComplianceAllDepartmentSearchTerm, 'all');
    }
    return;
  }
  const opening = !this.isAmcComplianceMyDepartmentDropdownOpen;
  this.closeAmcComplianceFilterDropdowns('my');
  this.isAmcComplianceMyDepartmentDropdownOpen = opening;
  if (opening) {
    this.onAmcComplianceDepartmentSearch(this.amcComplianceMyDepartmentSearchTerm, 'my');
  }
}

toggleAmcComplianceLocDropdown(scope: 'my' | 'all') {
  if (scope === 'all') {
    const opening = !this.isAmcComplianceAllLocDropdownOpen;
    this.closeAmcComplianceFilterDropdowns('all');
    this.isAmcComplianceAllLocDropdownOpen = opening;
    if (opening) {
      this.onAmcComplianceLocSearch(this.amcComplianceAllLocSearchTerm, 'all');
      if (!this.amcManagementLocList.length) {
        this.fetchAmcManagementLocationList('', 'all', 'compliance');
      }
    }
    return;
  }
  const opening = !this.isAmcComplianceMyLocDropdownOpen;
  this.closeAmcComplianceFilterDropdowns('my');
  this.isAmcComplianceMyLocDropdownOpen = opening;
  if (opening) {
    this.onAmcComplianceLocSearch(this.amcComplianceMyLocSearchTerm, 'my');
    if (!this.amcManagementLocList.length) {
      this.fetchAmcManagementLocationList('', 'my', 'compliance');
    }
  }
}

onAmcComplianceLobSearch(term: string, scope: 'my' | 'all') {
  const q = (term || '').trim().toLowerCase();
  if (scope === 'all') {
    this.amcComplianceAllLobSearchTerm = term || '';
    this.filteredAmcComplianceAllLobList = !q
      ? this.amcManagementLobList.slice()
      : this.amcManagementLobList.filter((x) =>
        (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
      );
    return;
  }
  this.amcComplianceMyLobSearchTerm = term || '';
  this.filteredAmcComplianceMyLobList = !q
    ? this.amcManagementLobList.slice()
    : this.amcManagementLobList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
}

onAmcComplianceDepartmentSearch(term: string, scope: 'my' | 'all') {
  const q = (term || '').trim().toLowerCase();
  if (scope === 'all') {
    this.amcComplianceAllDepartmentSearchTerm = term || '';
    this.filteredAmcComplianceAllDepartmentList = !q
      ? this.amcManagementDepartmentList.slice()
      : this.amcManagementDepartmentList.filter((x) =>
        (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
      );
    return;
  }
  this.amcComplianceMyDepartmentSearchTerm = term || '';
  this.filteredAmcComplianceMyDepartmentList = !q
    ? this.amcManagementDepartmentList.slice()
    : this.amcManagementDepartmentList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
}

onAmcComplianceLocSearch(term: string, scope: 'my' | 'all') {
  const raw = (term || '').trim();
  const q = raw.toLowerCase();
  if (scope === 'all') {
    this.amcComplianceAllLocSearchTerm = term || '';
    if (this.amcComplianceAllLocSearchDebounceRef) {
      clearTimeout(this.amcComplianceAllLocSearchDebounceRef);
      this.amcComplianceAllLocSearchDebounceRef = null;
    }
    if (!raw) {
      this.filteredAmcComplianceAllLocList = this.amcManagementLocList.slice();
      return;
    }
    if (raw.length >= 2) {
      this.amcComplianceAllLocSearchDebounceRef = setTimeout(() => {
        this.fetchAmcManagementLocationList(raw, 'all', 'compliance');
      }, 300);
      return;
    }
    this.filteredAmcComplianceAllLocList = this.amcManagementLocList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
    return;
  }
  this.amcComplianceMyLocSearchTerm = term || '';
  if (this.amcComplianceMyLocSearchDebounceRef) {
    clearTimeout(this.amcComplianceMyLocSearchDebounceRef);
    this.amcComplianceMyLocSearchDebounceRef = null;
  }
  if (!raw) {
    this.filteredAmcComplianceMyLocList = this.amcManagementLocList.slice();
    return;
  }
  if (raw.length >= 2) {
    this.amcComplianceMyLocSearchDebounceRef = setTimeout(() => {
      this.fetchAmcManagementLocationList(raw, 'my', 'compliance');
    }, 300);
    return;
  }
  this.filteredAmcComplianceMyLocList = this.amcManagementLocList.filter((x) =>
    (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
  );
}

onAmcCompliancePendingRowClick(scope: 'my' | 'all', row: any) {
  if (!row) {
    return;
  }
  const filters = this.amcComplianceGetScopeFilters(scope);
  const employeeId = scope === 'all' && this.amcComplianceAllEmployeeId
    ? String(this.amcComplianceAllEmployeeId)
    : '';
  const dashboardCardType = scope === 'all' ? 'all_compliance_pending' : 'my_compliance_pending';
  const filterData: any = {
    scope: scope,
    dashboard_card_type: dashboardCardType,
    task_id: row.task_id ? String(row.task_id) : '',
    task_name: row.task_name,
    employee_name: row.employee_name,
    days: row.days,
    overdue_days: row.days,
    employee_id: employeeId,
    lob: filters.lobId ? String(filters.lobId) : '',
    lob_location: filters.locId ? String(filters.locId) : '',
    department: filters.departmentId ? String(filters.departmentId) : '',
  };
  localStorage.setItem('dashboard_card_type', dashboardCardType);
  localStorage.setItem('scope', scope);
  if (filterData.task_id) {
    localStorage.setItem('task_id', filterData.task_id);
  }
  if (employeeId) {
    localStorage.setItem('employee_id', employeeId);
  }
  if (filterData.lob) {
    localStorage.setItem('lob', filterData.lob);
  }
  if (filterData.lob_location) {
    localStorage.setItem('lob_location', filterData.lob_location);
  }
  if (filterData.department) {
    localStorage.setItem('department', filterData.department);
  }
  localStorage.setItem(
    scope === 'all' ? 'amc_compliance_pending_all_filter' : 'amc_compliance_pending_my_filter',
    this.eesdesService.set(JSON.stringify(filterData))
  );
  localStorage.setItem('dashboard_navigation_source', scope === 'all' ? 'amc_compliance_pending_all' : 'amc_compliance_pending_my');
  const url = scope === 'all' ? '/all-amc-tasks' : '/my-amc-task';
  window.location.href = window.location.origin + '/master/#' + url;
}


private clearAmcManagementCharts(scope: 'my' | 'all', chartKind?: AmcMgmtChartKind) {
  if (chartKind === 'overdue') {
    if (scope === 'all') {
      this.amcManagementOverdueAllChart = null;
      this.amcManagementAllOverdueVisible = false;
    } else {
      this.amcManagementOverdueChart = null;
      this.amcManagementMyOverdueVisible = false;
    }
    return;
  }
  if (chartKind === 'status') {
    if (scope === 'all') {
      this.amcManagementStatusAllChart = null;
      this.amcManagementAllStatusVisible = false;
    } else {
      this.amcManagementStatusChart = null;
      this.amcManagementMyStatusVisible = false;
    }
    return;
  }
  if (scope === 'all') {
    this.amcManagementOverdueAllChart = null;
    this.amcManagementStatusAllChart = null;
    this.amcManagementAllOverdueVisible = false;
    this.amcManagementAllStatusVisible = false;
  } else {
    this.amcManagementOverdueChart = null;
    this.amcManagementStatusChart = null;
    this.amcManagementMyOverdueVisible = false;
    this.amcManagementMyStatusVisible = false;
  }
}

onAmcManagementEmployeeSelected(employeeId: any, employeeName: string, chartKind: AmcMgmtChartKind) {
  const card = this.amcMgmtCard('all', chartKind);
  card.employeeId = employeeId ? String(employeeId) : '';
  card.employeeName = employeeName ? String(employeeName).trim() : '';
  card.isEmployeeDropdownOpen = false;
  card.employeeSearchTerm = '';
  this.onAmcManagementEmployeeSearch('', chartKind);
  this.refreshAmcManagementDashboard('all', chartKind);
}

toggleAmcManagementEmployeeDropdown(chartKind: AmcMgmtChartKind) {
  const card = this.amcMgmtCard('all', chartKind);
  const opening = !card.isEmployeeDropdownOpen;
  this.closeAllAmcManagementFilterDropdowns();
  card.isEmployeeDropdownOpen = opening;
  if (opening) {
    this.maybeFetchAmcManagementEmployees();
    this.onAmcManagementEmployeeSearch(card.employeeSearchTerm, chartKind);
  }
}

getAmcManagementSelectedEmployeeLabel(chartKind: AmcMgmtChartKind): string {
  const card = this.amcMgmtCard('all', chartKind);
  return card.employeeName ? card.employeeName : 'Employee';
}

private maybeFetchAmcManagementEmployees() {
  if (this.amcManagementEmployeesLoading || this.amcManagementEmployeesMaster.length > 0) {
    return;
  }
  this.fetchAmcManagementEmployees('');
}

private fetchAmcManagementEmployees(query: string = '') {
  this.amcManagementEmployeesLoading = true;
  this.amcManagementLastEmployeesQuery = (query || '').trim();
  const payload: any = {};
  if (this.amcManagementLastEmployeesQuery.length >= 3) {
    payload.search = this.amcManagementLastEmployeesQuery;
    payload.keyword = this.amcManagementLastEmployeesQuery;
    payload.employee_name = this.amcManagementLastEmployeesQuery;
  }
  this.webService.commonPostMethod('Amc_dashboard/ajax_employees', payload).pipe(takeUntil(this.destroy$)).subscribe(
    (res: any) => {
      const list = res && res.data && Array.isArray(res.data.employees) ? res.data.employees : [];
      if (!this.amcManagementLastEmployeesQuery) {
        this.amcManagementEmployeesMaster = list;
        this.amcManagementEmployees = list;
        this.filteredAmcManagementEmployees = list;
      } else {
        this.filteredAmcManagementEmployees = list;
      }
      this.amcManagementEmployeesLoading = false;
    },
    () => {
      this.amcManagementEmployees = [];
      this.filteredAmcManagementEmployees = [];
      this.amcManagementEmployeesMaster = [];
      this.amcManagementEmployeesLoading = false;
    }
  );
}

onAmcManagementEmployeeSearch(term: string, chartKind?: AmcMgmtChartKind) {
  const searchTerm = term || '';
  if (chartKind) {
    this.amcMgmtCard('all', chartKind).employeeSearchTerm = searchTerm;
    this.amcManagementLastEmployeeSearchChartKind = chartKind;
  } else {
    this.amcSharedEmployeeSearchTerm = searchTerm;
  }
  const q = searchTerm.trim().toLowerCase();
  const raw = searchTerm.trim();
  if (this.amcManagementEmployeeSearchDebounceRef) {
    clearTimeout(this.amcManagementEmployeeSearchDebounceRef);
    this.amcManagementEmployeeSearchDebounceRef = null;
  }
  if (!raw) {
    this.filteredAmcManagementEmployees = this.amcManagementEmployeesMaster.length
      ? this.amcManagementEmployeesMaster
      : this.amcManagementEmployees;
    return;
  }
  if (raw.length >= 3) {
    this.amcManagementEmployeeSearchDebounceRef = setTimeout(() => {
      this.fetchAmcManagementEmployees(raw);
    }, 300);
    return;
  }
  const src = this.amcManagementEmployeesMaster.length ? this.amcManagementEmployeesMaster : this.amcManagementEmployees;
  this.filteredAmcManagementEmployees = src.filter((e: any) =>
    (e && e.employee_name ? String(e.employee_name) : '').toLowerCase().includes(q)
  );
}

loadAmcManagementFilterOptions() {
  if (this.amcManagementFiltersLoaded) {
    return;
  }
  this.amcManagementFiltersLoaded = true;
  this.fetchAmcManagementLobList();
  this.fetchAmcManagementDepartmentList();
  this.fetchAmcManagementLocationList('', 'my', 'management', 'overdue');
}

onAmcManagementLobSelected(lobId: any, scope: AmcMgmtScope, chartKind: AmcMgmtChartKind, label?: string) {
  const card = this.amcMgmtCard(scope, chartKind);
  const value = lobId != null && String(lobId).trim() !== '' ? String(lobId) : '';
  const lbl = value ? (label || this.amcMgmtFindLobLabel(value)) : '';
  card.lobId = value;
  card.lobLabel = lbl;
  card.isLobDropdownOpen = false;
  card.lobSearchTerm = '';
  card.filteredLobList = this.amcManagementLobList.slice();
  this.refreshAmcManagementDashboard(scope, chartKind);
}

onAmcManagementDepartmentSelected(departmentId: any, scope: AmcMgmtScope, chartKind: AmcMgmtChartKind, label?: string) {
  const card = this.amcMgmtCard(scope, chartKind);
  const value = departmentId != null && String(departmentId).trim() !== '' ? String(departmentId) : '';
  const lbl = value ? (label || this.amcMgmtFindDepartmentLabel(value)) : '';
  card.departmentId = value;
  card.departmentLabel = lbl;
  card.isDepartmentDropdownOpen = false;
  card.departmentSearchTerm = '';
  card.filteredDepartmentList = this.amcManagementDepartmentList.slice();
  this.refreshAmcManagementDashboard(scope, chartKind);
}

getAmcManagementSelectedLobLabel(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind): string {
  const card = this.amcMgmtCard(scope, chartKind);
  if (!card.lobId) {
    return 'LOB';
  }
  if (card.lobLabel) {
    return card.lobLabel;
  }
  return this.amcMgmtFindLobLabel(card.lobId) || 'LOB';
}

getAmcManagementSelectedDepartmentLabel(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind): string {
  const card = this.amcMgmtCard(scope, chartKind);
  if (!card.departmentId) {
    return 'Department';
  }
  if (card.departmentLabel) {
    return card.departmentLabel;
  }
  return this.amcMgmtFindDepartmentLabel(card.departmentId) || 'Department';
}

toggleAmcManagementLobDropdown(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind) {
  const card = this.amcMgmtCard(scope, chartKind);
  const opening = !card.isLobDropdownOpen;
  this.closeAllAmcManagementFilterDropdowns();
  card.isLobDropdownOpen = opening;
  if (opening) {
    this.onAmcManagementLobSearch(card.lobSearchTerm, scope, chartKind);
  }
}

toggleAmcManagementDepartmentDropdown(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind) {
  const card = this.amcMgmtCard(scope, chartKind);
  const opening = !card.isDepartmentDropdownOpen;
  this.closeAllAmcManagementFilterDropdowns();
  card.isDepartmentDropdownOpen = opening;
  if (opening) {
    this.onAmcManagementDepartmentSearch(card.departmentSearchTerm, scope, chartKind);
  }
}

onAmcManagementLobSearch(term: string, scope: AmcMgmtScope, chartKind: AmcMgmtChartKind) {
  const card = this.amcMgmtCard(scope, chartKind);
  const raw = (term || '').trim();
  const q = raw.toLowerCase();
  card.lobSearchTerm = term || '';
  card.filteredLobList = !q
    ? this.amcManagementLobList.slice()
    : this.amcManagementLobList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
}

onAmcManagementDepartmentSearch(term: string, scope: AmcMgmtScope, chartKind: AmcMgmtChartKind) {
  const card = this.amcMgmtCard(scope, chartKind);
  const raw = (term || '').trim();
  const q = raw.toLowerCase();
  card.departmentSearchTerm = term || '';
  card.filteredDepartmentList = !q
    ? this.amcManagementDepartmentList.slice()
    : this.amcManagementDepartmentList.filter((x) =>
      (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
    );
}

private closeAllAmcManagementFilterDropdowns() {
  if (!this.amcMgmtCardFilters) {
    return;
  }
  (['my', 'all'] as AmcMgmtScope[]).forEach((scope) => {
    (['overdue', 'status'] as AmcMgmtChartKind[]).forEach((chartKind) => {
      const card = this.amcMgmtCard(scope, chartKind);
      card.isLobDropdownOpen = false;
      card.isLocDropdownOpen = false;
      card.isDepartmentDropdownOpen = false;
      card.isEmployeeDropdownOpen = false;
    });
  });
}

/** @deprecated Use closeAllAmcManagementFilterDropdowns — kept for ageing/critical/compliance callers */
private closeAmcManagementFilterDropdowns(_scope: 'my' | 'all') {
  this.closeAllAmcManagementFilterDropdowns();
}

private amcMgmtFindLobLabel(lobId: string): string {
  const match = this.amcManagementLobList.find((x) => String(x.id) === String(lobId));
  return match ? match.label : '';
}

private amcMgmtFindDepartmentLabel(departmentId: string): string {
  const match = this.amcManagementDepartmentList.find((x) => String(x.id) === String(departmentId));
  return match ? match.label : '';
}

onAmcManagementLocSelected(locId: any, scope: AmcMgmtScope, chartKind: AmcMgmtChartKind) {
  const card = this.amcMgmtCard(scope, chartKind);
  const value = locId != null && String(locId).trim() !== '' ? String(locId) : '';
  const label = value ? this.amcMgmtFindLocLabel(value, scope, chartKind) : '';
  card.locId = value;
  card.locLabel = label;
  card.isLocDropdownOpen = false;
  card.locSearchTerm = '';
  card.filteredLocList = this.amcManagementLocList.slice();
  this.refreshAmcManagementDashboard(scope, chartKind);
}

getAmcManagementSelectedLocLabel(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind): string {
  const card = this.amcMgmtCard(scope, chartKind);
  if (!card.locId) {
    return 'LOC';
  }
  if (card.locLabel) {
    return card.locLabel;
  }
  return this.amcMgmtFindLocLabel(card.locId, scope, chartKind) || 'LOC';
}

toggleAmcManagementLocDropdown(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind) {
  const card = this.amcMgmtCard(scope, chartKind);
  const opening = !card.isLocDropdownOpen;
  this.closeAllAmcManagementFilterDropdowns();
  card.isLocDropdownOpen = opening;
  if (opening) {
    this.onAmcManagementLocSearch(card.locSearchTerm, scope, chartKind);
    if (!this.amcManagementLocList.length) {
      this.fetchAmcManagementLocationList('', scope, 'management', chartKind);
    }
  }
}

onAmcManagementLocSearch(term: string, scope: AmcMgmtScope, chartKind: AmcMgmtChartKind) {
  const card = this.amcMgmtCard(scope, chartKind);
  const raw = (term || '').trim();
  const q = raw.toLowerCase();
  card.locSearchTerm = term || '';
  if (card.locSearchDebounceRef) {
    clearTimeout(card.locSearchDebounceRef);
    card.locSearchDebounceRef = null;
  }
  if (!raw) {
    card.filteredLocList = this.amcManagementLocList.slice();
    return;
  }
  if (raw.length >= 2) {
    card.locSearchDebounceRef = setTimeout(() => {
      this.fetchAmcManagementLocationList(raw, scope, 'management', chartKind);
    }, 300);
    return;
  }
  card.filteredLocList = this.amcManagementLocList.filter((x) =>
    (x && x.label ? String(x.label) : '').toLowerCase().includes(q)
  );
}

private amcMgmtGetScopeFilters(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind): { lobId: string; locId: string; departmentId: string } {
  const card = this.amcMgmtCard(scope, chartKind);
  return {
    lobId: card.lobId,
    locId: card.locId,
    departmentId: card.departmentId,
  };
}

private amcMgmtFindLocLabel(locId: string, scope: AmcMgmtScope, chartKind?: AmcMgmtChartKind): string {
  const lists: Array<Array<{ id: any; label: string }>> = [];
  if (chartKind) {
    lists.push(this.amcMgmtCard(scope, chartKind).filteredLocList);
  }
  lists.push(this.amcManagementLocList);
  for (const list of lists) {
    const match = list.find((x) => String(x.id) === String(locId));
    if (match) {
      return match.label;
    }
  }
  return '';
}

private refreshAmcManagementDashboard(scope: AmcMgmtScope, chartKind: AmcMgmtChartKind) {
  this.getAmcManagementDashboard(scope, undefined, chartKind);
}

private fetchAmcManagementLobList() {
  this.amcManagementLobLoading = true;
  this.webService.commonPostMethod('lob/approved_lob', {}).pipe(takeUntil(this.destroy$)).subscribe(
    (res: any) => {
      this.amcManagementLobLoading = false;
      const rows = this.amcMgmtExtractApiRows(res, ['response', 'data', 'lob', 'lobs']);
      this.amcManagementLobList = rows.map((item: any) => ({
        id: item.id,
        label: this.amcMgmtBuildLobLabel(item),
      })).filter((x: any) => x.id != null && x.label);
      this.amcMgmtSyncDerivedFilteredLists();
    },
    () => {
      this.amcManagementLobLoading = false;
      this.amcManagementLobList = [];
      this.amcMgmtSyncDerivedFilteredLists();
    }
  );
}

private fetchAmcManagementDepartmentList() {
  this.amcManagementDepartmentLoading = true;
  this.webService.commonPostMethod('department/department_dropdown', {}).pipe(takeUntil(this.destroy$)).subscribe(
    (res: any) => {
      this.amcManagementDepartmentLoading = false;
      const rows = this.amcMgmtExtractApiRows(res, ['response', 'data', 'departments', 'department']);
      this.amcManagementDepartmentList = rows.map((item: any) => ({
        id: item.id,
        label: this.amcMgmtBuildDepartmentLabel(item),
      })).filter((x: any) => x.id != null && x.label);
      this.amcMgmtSyncDerivedFilteredLists();
    },
    () => {
      this.amcManagementDepartmentLoading = false;
      this.amcManagementDepartmentList = [];
      this.amcMgmtSyncDerivedFilteredLists();
    }
  );
}

private fetchAmcManagementLocationList(
  query: string = '',
  scope: 'my' | 'all' = 'my',
  target: 'management' | 'critical' | 'compliance' | 'ageing' = 'management',
  chartKind: AmcMgmtChartKind = 'overdue'
) {
  this.amcManagementLocLoading = true;
  const requestedQuery = (query || '').trim();
  this.amcManagementLastLocQuery = requestedQuery;
  this.amcManagementLastLocSearchScope = scope;
  this.amcManagementLastLocSearchTarget = target;
  if (target === 'management') {
    this.amcManagementLastLocSearchChartKind = chartKind;
  }
  const payload: any = {
    search_query: requestedQuery,
    is_backend_search: '1',
    only_emp_loc: '1',
    item_in: [],
    is_remove_keys: '0',
    keys_list: [],
    type: 'loc',
  };
  this.webService.commonPostMethod('locations/ajax_location_dropdown_for_reports', payload).pipe(takeUntil(this.destroy$)).subscribe(
    (res: any) => {
      this.amcManagementLocLoading = false;
      const rows = this.amcMgmtExtractApiRows(res, ['locations', 'response', 'data']);
      const list = rows.map((item: any) => ({
        id: item.id,
        label: this.amcMgmtBuildLocationLabel(item),
      })).filter((x: any) => x.id != null && x.label);
      if (!requestedQuery) {
        this.amcManagementLocList = list;
        this.amcMgmtSyncDerivedFilteredLists();
        return;
      }
      if (!this.amcMgmtIsActiveLocSearch(scope, target, requestedQuery, target === 'management' ? chartKind : undefined)) {
        return;
      }
      this.amcMgmtSetLocFilteredList(scope, target, list, target === 'management' ? chartKind : undefined);
    },
    () => {
      this.amcManagementLocLoading = false;
      if (!requestedQuery) {
        this.amcManagementLocList = [];
        this.amcMgmtSyncDerivedFilteredLists();
        return;
      }
      if (!this.amcMgmtIsActiveLocSearch(scope, target, requestedQuery, target === 'management' ? chartKind : undefined)) {
        return;
      }
      this.amcMgmtSetLocFilteredList(scope, target, [], target === 'management' ? chartKind : undefined);
    }
  );
}

private amcMgmtExtractApiRows(res: any, keys: string[]): any[] {
  if (!res) {
    return [];
  }
  if (Array.isArray(res)) {
    return res;
  }
  for (const key of keys) {
    if (Array.isArray(res[key])) {
      return res[key];
    }
  }
  if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
    for (const key of keys) {
      if (Array.isArray(res.data[key])) {
        return res.data[key];
      }
    }
  }
  return [];
}

private amcMgmtBuildLobLabel(item: any): string {
  const name = item.lob_name || item.name || item.label || '';
  const code = item.cs_id || item.lob_code || item.code || '';
  if (name && code) {
    return name + ' (' + code + ')';
  }
  return name || code || String(item.id || '');
}

private amcMgmtBuildDepartmentLabel(item: any): string {
  const name = item.department_name || item.name || item.label || '';
  const code = item.department_code || item.code || '';
  if (name && code) {
    return name + ' (' + code + ')';
  }
  return name || code || String(item.id || '');
}

private amcMgmtBuildLocationLabel(item: any): string {
  const name = item.nick_name || item.location_nickname_9_digit || item.name || item.label || '';
  const code = item.location_code || item.location_code_9_digit || item.code || '';
  if (name && code) {
    return name + ' (' + code + ')';
  }
  return name || code || String(item.id || '');
}

@HostListener('document:click', ['$event'])
onAmcManagementDocumentClick(event: MouseEvent) {
  if (this.financialYearFilterOpen && !(event.target as HTMLElement).closest('.fy-filter')) {
    this.financialYearFilterOpen = false;
  }
  const clickedInside = this.elRef && this.elRef.nativeElement && this.elRef.nativeElement.contains(event.target);
  if (!clickedInside) {
    this.closeAllAmcManagementFilterDropdowns();
    this.closeAmcCriticalFilterDropdowns('my');
    this.closeAmcCriticalFilterDropdowns('all');
    this.closeAmcComplianceFilterDropdowns('my');
    this.closeAmcComplianceFilterDropdowns('all');
    this.closeAmcAgeingFilterDropdowns('my');
    this.closeAmcAgeingFilterDropdowns('all');
    return;
  }
}

onAmcManagementChartClicked(e: any, scope: 'my' | 'all', chartKind: 'overdue' | 'status') {
  if (!e || !e.active || e.active.length <= 0) {
    return;
  }
  const chart = e.active[0]._chart;
  const activePoints = chart.getElementAtEvent(e.event);
  if (!activePoints || activePoints.length <= 0) {
    return;
  }
  let chartConfig: any = null;
  if (scope === 'all') {
    chartConfig = chartKind === 'status' ? this.amcManagementStatusAllChart : this.amcManagementOverdueAllChart;
  } else {
    chartConfig = chartKind === 'status' ? this.amcManagementStatusChart : this.amcManagementOverdueChart;
  }
  if (!chartConfig || !chartConfig.items) {
    return;
  }
  const barIndex = activePoints[0]._index;
  const datasetIndex = activePoints[0]._datasetIndex;
  const clickedItem = chartConfig.items.find((item: any) => {
    if (chartKind === 'status') {
      return item.priority_index === barIndex && item.dataset_index === datasetIndex;
    }
    return item.ageing_index === barIndex && item.dataset_index === datasetIndex;
  });
  if (!clickedItem || !clickedItem.count) {
    return;
  }
  this.navigateAmcManagementChart(scope, clickedItem, chartKind);
}

navigateAmcManagementChart(scope: 'my' | 'all', clickedItem: any, chartKind: 'overdue' | 'status') {
  const priorityKey = clickedItem.priority_key ? String(clickedItem.priority_key) : '';
  const statusKey = clickedItem.status_key ? String(clickedItem.status_key) : '';
  const statusBucket = chartKind === 'status' ? statusKey : '';
  const ageingBucket = clickedItem.ageing_key ? String(clickedItem.ageing_key) : '';
  // Same card type for overdue + status charts; status is filtered via status_bucket.
  const dashboardCardType = scope === 'all' ? 'all_overdue' : 'my_overdue';
  const scopeVal = scope;
  const employeeId = scope === 'all' && this.amcMgmtCard('all', chartKind).employeeId
    ? String(this.amcMgmtCard('all', chartKind).employeeId)
    : '';
  const filters = this.amcMgmtGetScopeFilters(scope, chartKind);
  const lobId = filters.lobId ? String(filters.lobId) : '';
  const locationId = filters.locId ? String(filters.locId) : '';
  const departmentId = filters.departmentId ? String(filters.departmentId) : '';
  const navSource = chartKind === 'status'
    ? (scope === 'all' ? 'amc_management_status_all' : 'amc_management_status_my')
    : (scope === 'all' ? 'amc_management_overdue_all' : 'amc_management_overdue_my');

  const filterData: any = {
    scope: scopeVal,
    dashboard_card_type: dashboardCardType,
    task_priority: priorityKey,
    status_bucket: statusBucket,
    priority: priorityKey,
    chart_kind: chartKind,
    count: clickedItem.count,
    employee_id: employeeId,
    lob: lobId,
    lob_location: locationId,
    department: departmentId,
  };
  if (chartKind === 'status') {
    filterData.priority_label = clickedItem.priority_label;
    filterData.status_label = clickedItem.status_label;
  } else {
    filterData.bucket = ageingBucket;
    filterData.ageing_bucket = ageingBucket;
    filterData.label = clickedItem.ageing_label;
    filterData.priority_label = clickedItem.priority_label;
  }

  localStorage.setItem('dashboard_card_type', dashboardCardType);
  localStorage.setItem('scope', scopeVal);
  localStorage.setItem('task_priority', priorityKey);
  localStorage.setItem('status_bucket', statusBucket);
  localStorage.removeItem('task_status');
  if (chartKind === 'status') {
    localStorage.removeItem('ageing_bucket');
  } else {
    localStorage.setItem('ageing_bucket', ageingBucket);
  }
  if (employeeId) {
    localStorage.setItem('employee_id', employeeId);
  }
  if (lobId) {
    localStorage.setItem('lob', lobId);
  }
  if (locationId) {
    localStorage.setItem('lob_location', locationId);
  }
  if (departmentId) {
    localStorage.setItem('department', departmentId);
  }
  localStorage.setItem(
    scope === 'all' ? 'amc_management_dashboard_all_filter' : 'amc_management_dashboard_filter',
    this.eesdesService.set(JSON.stringify(filterData))
  );
  localStorage.setItem('dashboard_navigation_source', navSource);
  if (chartKind === 'status') {
    localStorage.setItem('dashboard_navigation_bucket', priorityKey);
  } else {
    localStorage.setItem('dashboard_navigation_bucket', ageingBucket);
  }

  const url = scope === 'all' ? '/all-amc-tasks' : '/my-amc-task';
  window.location.href = window.location.origin + '/master/#' + url;
}

navigateFailedIntegrationByUrl(key) {
  let url = "";
  let project = '';
  let dashboardAction = "";
  switch (key) {
    case "sapb1_failed_integrations":
      url = "/all-approved-invoices";
      project = 'operation';
      dashboardAction = "sapb1_failed_integrations";
      break;
    default:
      url = "";
  }

  localStorage.setItem("dashboardAction", this.eesdesService.set(dashboardAction));
  if (url != '' && url != undefined) {
    let redirectUrl = '/#';
    let origin = window.location.origin;
    if (project == 'master') {
      redirectUrl = origin + '/master' + redirectUrl + url;
    } else if (project == 'report') {
      redirectUrl = origin + '/report' + redirectUrl + url;
    } else if (project == 'mapping') {
      redirectUrl = origin + '/mapping' + redirectUrl + url;
    } else if (project == 'finance') {
      redirectUrl = origin + '/finance' + redirectUrl + url;
    } else if (project == 'project_management') {
      redirectUrl = origin + '/project_management' + redirectUrl + url;
    } else if (project == 'help_desk') {
      redirectUrl = origin + '/help_desk' + redirectUrl + url;
    } else {
      if (url == '#' || !url) return;
      this.webService.redirectURL(url);
      return;
    }
    window.location.href = redirectUrl;
  }
}

navigateTallyIntegrationByUrl(key) {
  if (!key) return;
  localStorage.setItem("dashboardAction", this.eesdesService.set(key));
  localStorage.setItem("isTallyIntegrationAction", this.eesdesService.set('1'));
  this.webService.redirectURL("/all-approved-invoices");
}

getFailedIntegrationData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }

  const sapB1Enabled = this.company_setup && this.company_setup.sap_b1_api_enable == '1';
  const sapEnabled = this.company_setup && this.company_setup.enable_sap_integration == '1';
  const isBothSapTogglesDisabled = !sapB1Enabled && !sapEnabled;

  if (isBothSapTogglesDisabled) {
    this.failedIntegrationData = [];
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    user_id: this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    company_id: this._localStorageService.getEmpCompanyId(),
    how_many_days_pending_in_dashboard: (this.company_setup && this.company_setup.how_many_days_pending_in_dashboard)
      ? this.company_setup.how_many_days_pending_in_dashboard
      : '5'
  };

  this.failedIntegrationData = [];
  this.runDashboardCounterHttp(
    "/User_Roles/ajax_dashboard_failed_integrations_cards_counter",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (!data || !data.status) {
        this.failedIntegrationData = [];
        return;
      }

      const responseArr = typeof data.response === 'object' ? ([data.response ? data.response : {}]) : (data.response || []);
      const temp: any[] = [];
      for (const i of responseArr) {
        if (i && i.items && i.items.length > 0) {
          for (const j of i.items) {
            let isVisible = true;
            if (!j || !j.key) {
              isVisible = false;
            }
            if (j.key === 'sapb1_failed_integrations') {
              isVisible = sapB1Enabled;
            }
            if (j.key === 'sap_failed_integrations') {
              isVisible = sapEnabled;
            }
            if(isVisible) {
              temp.push(j);
            }
          }
        }
      } 
      this.failedIntegrationData = temp;
    },
    () => {
      this.failedIntegrationData = [];
    }
  );
}
getAgreementDashboardCards(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const agreementApis = [
    {
      url: "Vendors/ajax_agreement_dashboard_cards",
      keys: ['vendor_agreement_expiring_60', 'expired_vendor_agreement']
    },
    {
      url: "Customer_master/ajax_agreement_dashboard_cards",
      keys: ['customer_agreement_expiring_60', 'expired_customer_agreement']
    }
  ];

  const notifications = this.company_setup.email_dashboard_notification || [];
  const apisToHit = agreementApis.filter((api) => {
    return notifications.some((v) => {
      return api.keys.indexOf(v.id) > -1
        && (v.is_visible_on_dashboard === true || v.is_visible_on_dashboard === 1 || v.is_visible_on_dashboard === '1');
    });
  });

  if (!apisToHit.length) {
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  let obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
    "how_many_days_pending_in_dashboard": this.company_setup.how_many_days_pending_in_dashboard ? this.company_setup.how_many_days_pending_in_dashboard : '5'
  };

  const mergeAgreementCards = (data: any) => {
    if (!data || !data.status || !data.response) {
      return;
    }
    for (let i of data.response) {
      let cards = (i.items && i.items.length > 0) ? i.items : (i.key ? [i] : []);
      for (let j of cards) {
        // Agreement APIs return `count` only; UI shows `total_count`
        j.count = parseInt(this.webService.convertNaN(j.count), 10) || 0;
        j.total_count = (j.total_count !== undefined && j.total_count !== null && j.total_count !== '')
          ? (parseInt(this.webService.convertNaN(j.total_count), 10) || 0)
          : j.count;

        const existingIndex = this.pendingProjectManagementTaskList.findIndex((v) => { return v.key == j.key });
        if (existingIndex > -1) {
          const old = this.pendingProjectManagementTaskList[existingIndex];
          if (this.isPendingCardVisibleForPM(old.key) || this.isPendingCardVisible(old.key)) {
            this.pendingPMTaskCount = (parseFloat(this.pendingPMTaskCount) || 0) - (parseFloat(old.total_count) || 0);
            this.pendingPMTaskCountLastDays = (parseFloat(this.pendingPMTaskCountLastDays) || 0) - (parseFloat(old.count) || 0);
          }
          this.pendingProjectManagementTaskList[existingIndex] = j;
        } else {
          this.pendingProjectManagementTaskList.push(j);
        }
        if (this.isPendingCardVisibleForPM(j.key) || this.isPendingCardVisible(j.key)) {
          this.pendingPMTaskCount = (parseFloat(this.pendingPMTaskCount) || 0) + parseFloat(j.total_count);
          this.pendingPMTaskCountLastDays = (parseFloat(this.pendingPMTaskCountLastDays) || 0) + parseFloat(j.count);
        }
      }
    }
  };

  const runNext = (index: number) => {
    if (index >= apisToHit.length) {
      this.continueDashboardCounterChain(onComplete);
      return;
    }
    this.runDashboardCounterHttp(
      apisToHit[index].url,
      obj,
      () => runNext(index + 1),
      (data) => { mergeAgreementCards(data); },
      () => { }
    );
  };
  runNext(0);
}
getSalesStatisticsData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.salesStatisticsCharts = [];
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  };

  this.runDashboardCounterHttp(
    "Sales_dashboard/ajax_sales_statistics",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (data && data.status && data.response) {
        this.salesStatisticsCharts = this.formatSalesStatisticsCharts(data.response);
      } else {
        this.salesStatisticsCharts = [];
      }
    },
    () => {
      this.salesStatisticsCharts = [];
    }
  );
}

formatSalesStatisticsCharts(response: any) {
  const list: any = [];
  const sections = Array.isArray(response) ? response : [];
  for (let section of sections) {
    const items = section && section.items ? section.items : [];
    const totalItem = items.filter((item) => {
      return item.key == 'raised_sales_order' || item.key == 'raised_sales_invoice';
    })[0];
    const sliceItems = items.filter((item) => {
      return item.key != 'raised_sales_order' && item.key != 'raised_sales_invoice';
    });

    const chart: any = {
      title: section.title ? section.title : '',
      label: [],
      data: [],
      itemKeys: [],
      redirectType: '',
      total: totalItem ? parseFloat(totalItem.count) : 0,
      full_title: totalItem && totalItem.full_title ? totalItem.full_title : '',
      pieChartType: 'pie',
      lineChartLegend: true
    };

    const sectionTitle = (section.title ? String(section.title) : '').toLowerCase();
    const isSalesOrderCard = sectionTitle.indexOf('sales order') >= 0
      || items.some((item) => item && (item.key == 'raised_sales_order' || item.key == 'approved_sales_order' || item.key == 'pending_sales_order'));
    const isSalesInvoiceCard = sectionTitle.indexOf('sales invoice') >= 0
      || items.some((item) => item && (item.key == 'raised_sales_invoice' || item.key == 'approved_sales_invoice' || item.key == 'pending_sales_invoice'));
    if (isSalesOrderCard) {
      chart.redirectType = 'sales_order';
    } else if (isSalesInvoiceCard) {
      chart.redirectType = 'sales_invoice';
    }

    if (!chart.total) {
      for (let item of sliceItems) {
        chart.total = chart.total + (parseFloat(item.count) || 0);
      }
    }

    for (let item of sliceItems) {
      const count = parseFloat(item.count) || 0;
      if (item.full_title) {
        chart.label.push(item.title + " (" + item.full_title + ")");
      } else if (count > 0) {
        chart.label.push(item.title + " (" + item.count + ")");
      } else {
        chart.label.push(item.title);
      }
      chart.data.push(count);
      chart.itemKeys.push(item.key ? item.key : '');
    }

    chart.total = this.webService.convertNaN(chart.total) ? this.webService.convertNaN(chart.total) : '0';
    if (!chart.full_title) {
      chart.full_title = chart.total;
    }
    list.push(chart);
  }
  return list;
}

getOpenArAgeingData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.openArAgeingChart = null;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  };

  this.runDashboardCounterHttp(
    "Sales_dashboard/ajax_open_ar_ageing",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (data && data.status && data.response) {
        this.openArAgeingChart = this.formatOpenArAgeingChart(data.response);
      } else {
        this.openArAgeingChart = null;
      }
    },
    () => {
      this.openArAgeingChart = null;
    }
  );
}

formatOpenArAgeingChart(response: any) {
  if (!response || !response.buckets || !response.buckets.length) {
    return null;
  }

  const labels: any[] = [];
  const amounts: any[] = [];
  const counts: any[] = [];
  const amountFormatted: any[] = [];

  for (let bucket of response.buckets) {
    labels.push(bucket.label ? bucket.label : '');
    amounts.push(parseFloat(bucket.amount) || 0);
    counts.push(parseFloat(bucket.count) || 0);
    amountFormatted.push(bucket.amount_formatted ? bucket.amount_formatted : (bucket.amount || 0));
  }

  const totalAmount = parseFloat(response.total_amount) || 0;
  const totalCount = parseFloat(response.total_count) || 0;
  if (totalAmount <= 0 && totalCount <= 0) {
    return null;
  }

  const maxAmount = Math.max.apply(null, amounts);
  const maxCount = Math.max.apply(null, counts);
  const yAxis = response.y_axis ? response.y_axis : {};
  const yAxisTicks = Array.isArray(yAxis.ticks) ? yAxis.ticks : [];
  const yAmountMax = parseFloat(yAxis.max_lakh) || this.getOpenArNiceMax(maxAmount);
  const yAmountStep = parseFloat(yAxis.step_lakh) || (yAmountMax / 5);
  const yCountMax = this.getOpenArNiceMax(maxCount, true);
  const barLabel = (response.bar_series && response.bar_series.label) ? response.bar_series.label : 'Outstanding Amount';
  const lineLabel = (response.line_series && response.line_series.label) ? response.line_series.label : 'Open Invoice Count';
  const barColor = this.companyThemeBlockColor ? this.companyThemeBlockColor : '#035168';
  const amountAxisLabel = (response.currency == 'INR') ? 'Amount (₹)' : ('Amount (' + (response.currency ? response.currency : '') + ')');

  return {
    title: response.title ? response.title : 'Open AR Ageing',
    total: totalAmount,
    labels: labels,
    datasets: [
      {
        data: amounts,
        label: barLabel,
        type: 'bar',
        yAxisID: 'y-amount'
      },
      {
        data: counts,
        label: lineLabel,
        type: 'line',
        fill: false,
        yAxisID: 'y-count',
        lineTension: 0.3,
        pointRadius: 5,
        pointHoverRadius: 6,
        borderWidth: 2
      }
    ],
    colors: [
      { backgroundColor: barColor, borderColor: barColor },
      {
        backgroundColor: 'transparent',
        borderColor: '#e88b44',
        pointBackgroundColor: '#ffffff',
        pointBorderColor: '#e88b44',
        pointBorderWidth: 2
      }
    ],
    barChartType: 'bar',
    barChartLegend: true,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: 10,
          fontSize: 10,
          padding: 8
        }
      },
      layout: {
        padding: {
          top: 4,
          bottom: 0,
          left: 8,
          right: 8
        }
      },
      plugins: {
        datalabels: { display: false }
      },
      tooltips: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: function (tooltipItem, data) {
            const ds = data.datasets[tooltipItem.datasetIndex];
            const name = ds && ds.label ? ds.label : '';
            if (tooltipItem.datasetIndex === 0) {
              return name + ': ' + (amountFormatted[tooltipItem.index] || tooltipItem.yLabel);
            }
            return name + ': ' + tooltipItem.yLabel;
          }
        }
      },
      scales: {
        xAxes: [{
          gridLines: { display: false },
          ticks: {
            maxRotation: 45,
            minRotation: 45,
            autoSkip: false,
            fontSize: 9
          }
        }],
        yAxes: [
          {
            id: 'y-amount',
            position: 'left',
            scaleLabel: {
              display: false,
              labelString: amountAxisLabel,
              fontColor: barColor,
              fontSize: 10
            },
            ticks: {
              beginAtZero: true,
              max: yAmountMax,
              stepSize: yAmountStep,
              maxTicksLimit: 6,
              fontColor: barColor,
              fontSize: 9,
              padding: 4,
              callback: function (value) {
                if (!value) {
                  return '0';
                }
                let tickLabel = '';
                if (yAxisTicks.length) {
                  const idx = Math.round(value / yAmountStep) - 1;
                  if (idx >= 0 && yAxisTicks[idx]) {
                    tickLabel = String(yAxisTicks[idx]);
                  }
                }
                if (!tickLabel) {
                  for (let i = 0; i < amounts.length; i++) {
                    if (Math.abs((amounts[i] || 0) - value) < 0.00001) {
                      tickLabel = String(amountFormatted[i]);
                      break;
                    }
                  }
                }
                if (!tickLabel) {
                  return '';
                }
                return tickLabel.replace(/ Lakhs?/i, '').replace(/\.00$/, '').trim();
              }
            },
            gridLines: { color: 'rgba(0, 0, 0, 0.08)' }
          },
          {
            id: 'y-count',
            position: 'right',
            scaleLabel: {
              display: true,
              labelString: 'Count',
              fontColor: '#e88b44',
              fontSize: 10,
              padding: 4
            },
            ticks: {
              beginAtZero: true,
              max: yCountMax,
              maxTicksLimit: 6,
              precision: 0,
              fontColor: '#e88b44',
              fontSize: 9,
              padding: 4
            },
            gridLines: { drawOnChartArea: false }
          }
        ]
      }
    }
  };
}

getOpenArNiceMax(maxValue: number, isCount?: boolean) {
  const value = parseFloat(String(maxValue)) || 0;
  if (value <= 0) {
    return isCount ? 5 : 10;
  }
  if (isCount) {
    return Math.max(5, Math.ceil(value * 1.2));
  }
  const padded = value * 1.15;
  const mag = Math.pow(10, Math.floor(Math.log10(padded)));
  return Math.ceil(padded / mag) * mag;
}

getArOutstandingAgeingData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.arOutstandingAgeingChart = null;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  };

  this.runDashboardCounterHttp(
    "Sales_dashboard/ajax_ar_outstanding_ageing",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (data && data.status && data.response) {
        this.arOutstandingAgeingChart = this.formatArOutstandingAgeingChart(data.response);
      } else {
        this.arOutstandingAgeingChart = null;
      }
    },
    () => {
      this.arOutstandingAgeingChart = null;
    }
  );
}

formatArOutstandingAgeingChart(response: any) {
  if (!response || !response.buckets || !response.buckets.length) {
    return null;
  }

  const totalAmount = parseFloat(response.total_amount) || 0;
  if (totalAmount <= 0) {
    return null;
  }

  const labels: any[] = [];
  const barData: any[] = [];
  const amountFormatted: any[] = [];
  const lineSeries = Array.isArray(response.line_series) ? response.line_series : [];
  const lineDataMap: any = {};

  for (let series of lineSeries) {
    lineDataMap[series.key] = [];
  }

  for (let bucket of response.buckets) {
    labels.push(bucket.label ? bucket.label : '');
    barData.push(parseFloat(bucket.amount_lakh) || 0);
    amountFormatted.push(bucket.amount_formatted ? bucket.amount_formatted : (bucket.amount || 0));
    const linesLakh = bucket.lines_lakh ? bucket.lines_lakh : {};
    for (let series of lineSeries) {
      lineDataMap[series.key].push(parseFloat(linesLakh[series.key]) || 0);
    }
  }

  const barColor = this.companyThemeBlockColor ? this.companyThemeBlockColor : '#4E79A7';
  const barLabel = (response.bar_series && response.bar_series.label) ? response.bar_series.label : 'Current Outstanding';
  const lineColors = ['#e88b44', '#8e6bb0', '#53a75a'];
  const yAxis = response.y_axis ? response.y_axis : {};
  const yMax = parseFloat(yAxis.max_lakh) || 5;
  const yStep = parseFloat(yAxis.step_lakh) || (yMax / 5);
  const currency = response.currency ? response.currency : 'INR';
  const yAxisLabel = 'Amount in Lakh (' + currency + ')';
  const self = this;

  const datasets: any[] = [{
    data: barData,
    label: barLabel + ' (Bar)',
    type: 'bar',
    yAxisID: 'y-amount'
  }];
  const colors: any[] = [
    { backgroundColor: barColor, borderColor: barColor }
  ];

  for (let i = 0; i < lineSeries.length; i++) {
    const series = lineSeries[i];
    const lineColor = lineColors[i] ? lineColors[i] : '#e88b44';
    datasets.push({
      data: lineDataMap[series.key] ? lineDataMap[series.key] : [],
      label: series.label ? series.label : series.key,
      type: 'line',
      fill: false,
      yAxisID: 'y-amount',
      lineTension: 0.3,
      pointRadius: 5,
      pointHoverRadius: 6,
      borderWidth: 2
    });
    colors.push({
      backgroundColor: 'transparent',
      borderColor: lineColor,
      pointBackgroundColor: lineColor,
      pointBorderColor: '#ffffff',
      pointBorderWidth: 2
    });
  }

  return {
    title: response.title ? response.title : 'AR Outstanding Ageing',
    total: totalAmount,
    labels: labels,
    datasets: datasets,
    colors: colors,
    barChartType: 'bar',
    barChartLegend: true,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'bottom'
      },
      plugins: {
        datalabels: { display: false }
      },
      tooltips: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: function (tooltipItem, data) {
            const ds = data.datasets[tooltipItem.datasetIndex];
            const name = ds && ds.label ? ds.label : '';
            if (tooltipItem.datasetIndex === 0) {
              return name + ': ' + (amountFormatted[tooltipItem.index] || tooltipItem.yLabel);
            }
            return name + ': ' + tooltipItem.yLabel;
          }
        }
      },
      scales: {
        xAxes: [{
          gridLines: { display: false },
          ticks: {
            maxRotation: 45,
            minRotation: 0,
            autoSkip: false,
            fontSize: 10
          }
        }],
        yAxes: [{
          id: 'y-amount',
          position: 'left',
          scaleLabel: {
            display: true,
            labelString: yAxisLabel
          },
          ticks: {
            beginAtZero: true,
            max: yMax,
            stepSize: yStep,
            callback: function (value) {
              for (let i = 0; i < barData.length; i++) {
                if (Math.abs((barData[i] || 0) - value) < 0.00001) {
                  return amountFormatted[i];
                }
              }
              return self.webService.numberWithCommas(
                value,
                0,
                self.company_setup.comma_separate_currency_code,
                self.company_setup.is_enable_comma_separate_price
              );
            }
          },
          gridLines: {
            color: 'rgba(0, 0, 0, 0.12)',
            borderDash: [4, 4]
          }
        }]
      }
    }
  };
}

getTopCustomersData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.topCustomersData = null;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  };

  this.runDashboardCounterHttp(
    "Sales_dashboard/ajax_top_customers",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (data && data.status && data.response && data.response.rows && data.response.rows.length) {
        this.topCustomersData = data.response;
      } else {
        this.topCustomersData = null;
      }
    },
    () => {
      this.topCustomersData = null;
    }
  );
}

getTopCustomerCell(row: any, column: any) {
  if (!row || !column) {
    return '';
  }
  if (column.formatted_key && row[column.formatted_key] != null && row[column.formatted_key] !== '') {
    return row[column.formatted_key];
  }
  return (row[column.key] != null && row[column.key] !== '') ? row[column.key] : '';
}

getColumnHeaderMain(label: any) {
  if (!label) {
    return '';
  }
  const text = String(label);
  const idx = text.lastIndexOf('(');
  if (idx > 0) {
    return text.substring(0, idx).trim();
  }
  return text;
}

getColumnHeaderSub(label: any) {
  if (!label) {
    return '';
  }
  const text = String(label);
  const idx = text.lastIndexOf('(');
  if (idx > 0) {
    return text.substring(idx).trim();
  }
  return '';
}

getDashboardColLabelMain(label: any) {
  if (!label) {
    return '';
  }
  const idx = String(label).indexOf(' (');
  return idx >= 0 ? String(label).substring(0, idx) : String(label);
}

getDashboardColLabelBracket(label: any) {
  if (!label) {
    return '';
  }
  const idx = String(label).indexOf(' (');
  return idx >= 0 ? String(label).substring(idx + 1) : '';
}

isTopCustomerAmountColumn(column: any) {
  if (!column || !column.key) {
    return false;
  }
  return column.key != 's_no' && column.key != 'customer_name' && column.key != 'customer_code';
}

loadTopCustomersMore() {
  if (!this.topCustomersData || !this.topCustomersData.has_more || this.topCustomersMoreLoading) {
    return;
  }
  const moreApi = this.topCustomersData.more_api ? this.topCustomersData.more_api : 'Sales_dashboard/ajax_top_customers_all';
  const obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  };
  this.topCustomersMoreLoading = true;
  this.webService.commonPostMethod(moreApi, obj).subscribe(
    (data) => {
      this.topCustomersMoreLoading = false;
      if (data && data.status && data.response) {
        this.topCustomersData = data.response;
      }
    },
    () => {
      this.topCustomersMoreLoading = false;
    }
  );
}

getTotalRevenueData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.totalRevenueChart = null;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  };

  this.runDashboardCounterHttp(
    "Sales_dashboard/ajax_total_revenue",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (data && data.status && data.response) {
        this.totalRevenueChart = this.formatTotalRevenueChart(data.response);
      } else {
        this.totalRevenueChart = null;
      }
    },
    () => {
      this.totalRevenueChart = null;
    }
  );
}

formatTotalRevenueChart(response: any) {
  if (!response || !response.months || !response.months.length) {
    return null;
  }

  const totalAmount = parseFloat(response.total_amount) || 0;
  if (totalAmount <= 0) {
    return null;
  }

  const labels: any[] = [];
  const amounts: any[] = [];
  const amountFormatted: any[] = [];

  for (let month of response.months) {
    labels.push(month.label ? month.label : '');
    amounts.push(parseFloat(month.amount_lakh) || 0);
    amountFormatted.push(month.amount_formatted ? month.amount_formatted : (month.amount || 0));
  }

  const barColor = this.companyThemeBlockColor ? this.companyThemeBlockColor : '#4E79A7';
  const barLabel = (response.bar_series && response.bar_series.label) ? response.bar_series.label : 'Monthly Revenue';
  const legendLabel = (response.revenue_basis == 'excl_gst_net_credit_notes')
    ? (barLabel + ' (excl. GST, net CN)')
    : barLabel;
  const yAxis = response.y_axis ? response.y_axis : {};
  const yMax = parseFloat(yAxis.max_lakh) || 5;
  const yStep = parseFloat(yAxis.step_lakh) || (yMax / 5);
  const yAxisTicks = Array.isArray(yAxis.ticks) ? yAxis.ticks : [];
  const currency = response.currency ? response.currency : 'INR';
  const yAxisLabel = 'Amount in Lakh (' + currency + ')';

  return {
    title: response.title ? response.title : 'Total Revenue',
    labels: labels,
    datasets: [{
      data: amounts,
      label: legendLabel,
      type: 'bar'
    }],
    colors: [{ backgroundColor: barColor, borderColor: barColor }],
    barChartType: 'bar',
    barChartLegend: true,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: 10,
          fontSize: 10,
          padding: 8
        }
      },
      plugins: {
        datalabels: { display: false }
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            const idx = tooltipItem.index;
            return legendLabel + ': ' + (amountFormatted[idx] || tooltipItem.yLabel);
          }
        }
      },
      scales: {
        xAxes: [{
          gridLines: { display: false },
          ticks: {
            maxRotation: 45,
            minRotation: 45,
            autoSkip: false,
            fontSize: 10
          }
        }],
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: yAxisLabel
          },
          ticks: {
            beginAtZero: true,
            max: yMax,
            stepSize: yStep,
            callback: function (value) {
              if (!value) {
                return '0';
              }
              const idx = Math.round(value / yStep) - 1;
              if (idx >= 0 && yAxisTicks[idx]) {
                return String(yAxisTicks[idx]).replace(/ Lakhs?/i, '').trim();
              }
              return value;
            }
          },
          gridLines: {
            color: 'rgba(0, 0, 0, 0.12)',
            borderDash: [4, 4]
          }
        }]
      }
    }
  };
}

getNewCustomersData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.newCustomersData = null;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  };

  this.runDashboardCounterHttp(
    "Sales_dashboard/ajax_new_customers",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (data && data.status && data.response && data.response.rows && data.response.rows.length) {
        this.newCustomersData = data.response;
      } else {
        this.newCustomersData = null;
      }
    },
    () => {
      this.newCustomersData = null;
    }
  );
}

getNewCustomerCell(row: any, column: any) {
  if (!row || !column) {
    return '—';
  }
  let value: any = '';
  if (column.formatted_key && row[column.formatted_key] != null && row[column.formatted_key] !== '') {
    value = row[column.formatted_key];
  } else if (row[column.key] != null && row[column.key] !== '') {
    value = row[column.key];
  }
  return (value === '' || value == null) ? '—' : value;
}

isNewCustomerAmountColumn(column: any) {
  if (!column || !column.key) {
    return false;
  }
  return column.key == 'cy_revenue' || column.key == 'py_revenue' || column.key == 'current_outstanding';
}

getMissedCustomersData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.missedCustomersData = null;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  };

  this.runDashboardCounterHttp(
    "Sales_dashboard/ajax_missed_customers",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (data && data.status && data.response && data.response.rows && data.response.rows.length) {
        this.missedCustomersData = data.response;
      } else {
        this.missedCustomersData = null;
      }
    },
    () => {
      this.missedCustomersData = null;
    }
  );
}

getUpcomingRenewalsData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.upcomingRenewalsData = null;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  };

  this.runDashboardCounterHttp(
    "Sales_dashboard/ajax_upcoming_renewals",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (data && data.status && data.response && data.response.rows && data.response.rows.length) {
        this.upcomingRenewalsData = data.response;
      } else {
        this.upcomingRenewalsData = null;
      }
    },
    () => {
      this.upcomingRenewalsData = null;
    }
  );
}

redirectUpcomingRenewalsMore() {
  if (!this.upcomingRenewalsData) {
    return;
  }
  const moreRedirect = this.upcomingRenewalsData.more_redirect ? this.upcomingRenewalsData.more_redirect : {};
  const filterKey = moreRedirect.filter_key
    ? moreRedirect.filter_key
    : (this.upcomingRenewalsData.filter_key ? this.upcomingRenewalsData.filter_key : 'customer_agreement_expiring_60');
  this.navigatePendingPmTaskByUrl(filterKey, false);
}

getExpiredAgreementsData(onComplete?: () => void) {
  if (!this.isDashboardActive()) {
    return;
  }
  if (this._localStorageService.getUserRole() == "vendor") {
    this.expiredAgreementsData = null;
    this.continueDashboardCounterChain(onComplete);
    return;
  }

  const obj = {
    "user_id": this._localStorageService.getUserId() == undefined ? "0" : this._localStorageService.getUserId(),
    "company_id": this._localStorageService.getEmpCompanyId(),
  };

  this.runDashboardCounterHttp(
    "Sales_dashboard/ajax_expired_agreements",
    obj,
    onComplete ? () => this.continueDashboardCounterChain(onComplete) : undefined,
    (data) => {
      if (data && data.status && data.response && data.response.rows && data.response.rows.length) {
        this.expiredAgreementsData = data.response;
      } else {
        this.expiredAgreementsData = null;
      }
    },
    () => {
      this.expiredAgreementsData = null;
    }
  );
}

redirectExpiredAgreementsMore() {
  if (!this.expiredAgreementsData) {
    return;
  }
  const moreRedirect = this.expiredAgreementsData.more_redirect ? this.expiredAgreementsData.more_redirect : {};
  const filterKey = moreRedirect.filter_key
    ? moreRedirect.filter_key
    : (this.expiredAgreementsData.filter_key ? this.expiredAgreementsData.filter_key : 'expired_customer_agreement');
  this.navigatePendingPmTaskByUrl(filterKey, false);
}

}



// WEBPACK FOOTER //
// /codebuild/output/src1860559092/src/src/app/pages/dashboard/dashboard.component.ts